import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Byte: { input: any; output: any; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AiChatMessage = {
  __typename?: 'AIChatMessage';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  role: AiChatRole;
  tool_call_id?: Maybe<Scalars['String']['output']>;
  tool_calls?: Maybe<Scalars['JSON']['output']>;
};

export enum AiChatRole {
  Assistant = 'assistant',
  System = 'system',
  Tool = 'tool',
  User = 'user'
}

export type AiChatThread = {
  __typename?: 'AIChatThread';
  id: Scalars['ID']['output'];
  messages: Array<AiChatMessage>;
  spaceId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AiEmbedding = {
  __typename?: 'AIEmbedding';
  distance: Scalars['Float']['output'];
  fromBlockId: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  toBlockId: Scalars['String']['output'];
};

export type AiFeaturePermission = {
  __typename?: 'AIFeaturePermission';
  enabled: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  model: Scalars['String']['output'];
};

export type AiSugesstionInput = {
  promptTokens: Scalars['Int']['input'];
  responseText: Scalars['String']['input'];
  responseTokens: Scalars['Int']['input'];
  spaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type AcceptInvitationInput = {
  id: Scalars['String']['input'];
};

export type AcceptPageInvitationInput = {
  id: Scalars['String']['input'];
};

export type AddAiPromptInput = {
  prompt: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: CustomPromptType;
};

export type AddBlocksInput = {
  blocks: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type AdminSpaceList = {
  __typename?: 'AdminSpaceList';
  activeSubscription?: Maybe<SpaceSubscription>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ownerIds: Array<Maybe<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
  usedSpaceTokens: Scalars['Int']['output'];
};

export type AdminSpaceListInput = {
  urlKey: Scalars['String']['input'];
};

export type AdminUser = {
  __typename?: 'AdminUser';
  createdAt: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  names: Scalars['String']['output'];
  role: UserRole;
  updatedAt: Scalars['String']['output'];
};

export type AdminUserDeleteInput = {
  deletePosthodData: Scalars['Boolean']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminUserDetailsInput = {
  email: Scalars['String']['input'];
};

export type AdminUserList = {
  __typename?: 'AdminUserList';
  pageInfo: PageInfo;
  users: Array<AdminUser>;
};

export type AdminUserListInput = {
  createdAtFrom: Scalars['Date']['input'];
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  page: Scalars['Int']['input'];
};

export type AdminUserListSharedCountInput = {
  userId: Scalars['String']['input'];
};

export type AdminUsersDeleteInput = {
  users: Array<AdminUserDeleteInput>;
};

export type ApiToken = {
  __typename?: 'ApiToken';
  id: Scalars['String']['output'];
};

export type BillingPortalInput = {
  clientUrl?: InputMaybe<Scalars['String']['input']>;
  sourceUrlKey: Scalars['String']['input'];
};

export type CancelSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
};

export type ChangeSubscriptionInput = {
  priceId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type ChatThreadsInput = {
  urlKey: Scalars['String']['input'];
};

export type Collection = {
  __typename?: 'Collection';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type CollectionPropertiesOrderInput = {
  collectionId: Scalars['String']['input'];
  folderViewProperties: Array<Scalars['String']['input']>;
  tagViewProperties: Array<Scalars['String']['input']>;
};

export type CollectionPropertyOrder = {
  __typename?: 'CollectionPropertyOrder';
  collectionId: Scalars['String']['output'];
  folderViewProperties: Array<Scalars['String']['output']>;
  tagViewProperties: Array<Scalars['String']['output']>;
};

export type CollectionsByUrlKeyInput = {
  urlKey: Scalars['String']['input'];
};

export type CopyWorkspaceInput = {
  urlKey: Scalars['String']['input'];
};

export type CreateApiTokenInput = {
  urlKey: Scalars['String']['input'];
};

export type CreatePageInput = {
  title: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type CreateSpaceInput = {
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  test?: InputMaybe<CreateSpaceTestInput>;
  title: Scalars['String']['input'];
  useCases?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSpaceSubscription = {
  __typename?: 'CreateSpaceSubscription';
  space?: Maybe<Space>;
};

export type CreateSpaceTestInput = {
  createSubscription: Scalars['Boolean']['input'];
};

export type CreateSubscriptionInput = {
  action: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  sourceUrlKey: Scalars['String']['input'];
};

export type CreateSubscriptionSessionInput = {
  action: Scalars['String']['input'];
  clientUrl?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
  referral?: InputMaybe<Scalars['String']['input']>;
  sourceUrlKey: Scalars['String']['input'];
  spaceUrlKey: Scalars['String']['input'];
  workspaceMembersCount: Scalars['Int']['input'];
};

export type CustomAiPrompt = {
  __typename?: 'CustomAIPrompt';
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: CustomPromptType;
};

export enum CustomPromptType {
  Command = 'COMMAND',
  Prompt = 'PROMPT'
}

export type CustomToken = {
  __typename?: 'CustomToken';
  token: Scalars['String']['output'];
};

export type DeleteAssetInput = {
  assetKeys: Array<Scalars['String']['input']>;
  urlKey: Scalars['String']['input'];
};

export type DeleteSpaceInput = {
  urlKey: Scalars['String']['input'];
};

export type DuplicateAssetKeyInput = {
  assetKey: Scalars['String']['input'];
  assetType: Scalars['String']['input'];
  sourceSpaceUrlKey: Scalars['String']['input'];
  targetSpaceUrlKey: Scalars['String']['input'];
};

export type DuplicatePageAssetsInput = {
  assetKeys: Array<DuplicateAssetKeyInput>;
};

export type EmbeddingSearchInput = {
  query?: InputMaybe<Scalars['String']['input']>;
  urlKey: Scalars['String']['input'];
};

export type ExtendedSettings = {
  __typename?: 'ExtendedSettings';
  collectionPropertiesOrder?: Maybe<Array<CollectionPropertyOrder>>;
  collectionsColumnsOrder?: Maybe<Array<Scalars['String']['output']>>;
  pagesColumnsOrder?: Maybe<Array<Scalars['String']['output']>>;
  sharedPagesColumnsOrder?: Maybe<Array<Scalars['String']['output']>>;
  tasksColumnsOrder?: Maybe<Array<Scalars['String']['output']>>;
};

export type ExtendedSettingsInput = {
  collectionPropertiesOrder?: InputMaybe<Array<CollectionPropertiesOrderInput>>;
  collectionsColumnsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  pagesColumnsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedPagesColumnsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
  tasksColumnsOrder?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FeaturePermission = {
  __typename?: 'FeaturePermission';
  enabled: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
};

export enum FeatureSet {
  Business = 'BUSINESS',
  Free = 'FREE',
  Standard = 'STANDARD'
}

export type FileUploadPermission = {
  __typename?: 'FileUploadPermission';
  limitFile: Scalars['Int']['output'];
};

export type GoogleDriveFile = {
  __typename?: 'GoogleDriveFile';
  iconLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  modifiedTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owners?: Maybe<Array<Maybe<GoogleDriveOwner>>>;
  thumbnailLink?: Maybe<Scalars['String']['output']>;
  webViewLink: Scalars['String']['output'];
};

export type GoogleDriveFileInput = {
  id: Scalars['String']['input'];
};

export type GoogleDriveOwner = {
  __typename?: 'GoogleDriveOwner';
  displayName?: Maybe<Scalars['String']['output']>;
};

export type HideAiThreadInput = {
  threadId: Scalars['String']['input'];
};

export type IntegrationSearchInput = {
  query: Scalars['String']['input'];
};

export type IntegrationSearchResult = {
  __typename?: 'IntegrationSearchResult';
  googleDriveFiles: Array<GoogleDriveFile>;
  linearIssues: Array<LinearIssue>;
};

export type Invite = {
  __typename?: 'Invite';
  id: Scalars['String']['output'];
  role: Role;
  userEmail: Scalars['String']['output'];
};

export type InviteMembersInput = {
  newMembers: Array<NewMemberInput>;
  urlKey: Scalars['String']['input'];
};

export type InviteMetaData = {
  __typename?: 'InviteMetaData';
  inviteId: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  workspaceMembersCount: Scalars['Int']['output'];
  workspaceOwnerEmail: Scalars['String']['output'];
  workspaceTitle: Scalars['String']['output'];
};

export type InviteMetaDataInput = {
  id: Scalars['String']['input'];
};

export type InvitePageMembersInput = {
  newMembers: Array<NewPageMemberInput>;
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};

export type InvitesInput = {
  urlKey: Scalars['String']['input'];
};

export type Invoices = {
  __typename?: 'Invoices';
  created: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  paid: Scalars['Boolean']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
  subscriptionId: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type InvoicesInput = {
  spaceId: Scalars['String']['input'];
};

export enum Language {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Pt = 'PT'
}

export type LeaveSpaceInput = {
  urlKey: Scalars['String']['input'];
};

export type LinearIssue = {
  __typename?: 'LinearIssue';
  assignee?: Maybe<LinearUser>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  priorityLabel?: Maybe<Scalars['String']['output']>;
  state?: Maybe<LinearIssueState>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export type LinearIssueCreateInput = {
  teamId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type LinearIssueDeleteInput = {
  id: Scalars['String']['input'];
};

export type LinearIssueInput = {
  id: Scalars['String']['input'];
};

export type LinearIssueState = {
  __typename?: 'LinearIssueState';
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LinearTeam = {
  __typename?: 'LinearTeam';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LinearUser = {
  __typename?: 'LinearUser';
  name: Scalars['String']['output'];
};

export type MarkNotificationsAsReadInput = {
  ids: Array<Scalars['String']['input']>;
};

export type Member = {
  __typename?: 'Member';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  role?: Maybe<Role>;
  spaceId: Scalars['String']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type MembersInput = {
  urlKey: Scalars['String']['input'];
};

export type MentionNotification = Node & Notification & {
  __typename?: 'MentionNotification';
  blockId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mentionBlockUrl: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  readAt?: Maybe<Scalars['String']['output']>;
  spaceColor?: Maybe<Scalars['String']['output']>;
  spaceId: Scalars['String']['output'];
  spaceTitle: Scalars['String']['output'];
  spaceUrlKey: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: Space;
  acceptPageInvitation: SharedPage;
  addAIPrompt: CustomAiPrompt;
  addBlocks?: Maybe<Scalars['String']['output']>;
  adminUserDelete: Array<UserDelete>;
  adminUserDetails: UserWithDetails;
  cancelSubscription: SpaceSubscription;
  changeSubscription: SpaceSubscription;
  copyWorkspace: Space;
  createApiToken: ApiToken;
  createPage: Page;
  createSpace: Space;
  createSubscription?: Maybe<CreateSpaceSubscription>;
  createSubscriptionSession: SubscriptionSession;
  deleteAsset: Scalars['Boolean']['output'];
  deleteSpace: Space;
  duplicatePageAssets: Scalars['Boolean']['output'];
  hideAIThread: Scalars['Boolean']['output'];
  inviteMembers: Array<Invite>;
  invitePageMembers: Array<PageInvite>;
  leaveSpace: Space;
  linearIssueCreate: LinearIssue;
  linearIssueDelete: Scalars['Boolean']['output'];
  markNotificationsAsRead: Array<Notification>;
  removeAIPrompt: Scalars['Boolean']['output'];
  removeMember: Scalars['String']['output'];
  removeSharedPage: Scalars['Boolean']['output'];
  removeUserIntegration: Scalars['Boolean']['output'];
  requestSignInLink: Scalars['Boolean']['output'];
  revokeInvite: Invite;
  revokePageInvite: PageInvite;
  sendNotification: Scalars['Boolean']['output'];
  sendTaskAssignmentNotification: Scalars['Boolean']['output'];
  sendTaskMentionNotification: Scalars['Boolean']['output'];
  sharePage: SharedPage;
  signup: User;
  updateAIPrompts?: Maybe<Array<CustomAiPrompt>>;
  updateMemberRole: Member;
  updatePageSharedToSpace: SharedPage;
  updateSpaceMetadata: Space;
  updateSpacePublicMetadata: Space;
  updateSpaceSorting: Array<Space>;
  updateSpaceUseCases: Space;
  updateUserLanguage: User;
  updateUserName: User;
  updateUserPagePermission: Array<PageMember>;
  updateUserSettings: UserSettings;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAcceptPageInvitationArgs = {
  input: AcceptPageInvitationInput;
};


export type MutationAddAiPromptArgs = {
  input: AddAiPromptInput;
};


export type MutationAddBlocksArgs = {
  input: AddBlocksInput;
};


export type MutationAdminUserDeleteArgs = {
  input: AdminUsersDeleteInput;
};


export type MutationAdminUserDetailsArgs = {
  input: AdminUserDetailsInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationChangeSubscriptionArgs = {
  input: ChangeSubscriptionInput;
};


export type MutationCopyWorkspaceArgs = {
  input: CopyWorkspaceInput;
};


export type MutationCreateApiTokenArgs = {
  input: CreateApiTokenInput;
};


export type MutationCreatePageArgs = {
  input: CreatePageInput;
};


export type MutationCreateSpaceArgs = {
  input: CreateSpaceInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateSubscriptionSessionArgs = {
  input: CreateSubscriptionSessionInput;
};


export type MutationDeleteAssetArgs = {
  input: DeleteAssetInput;
};


export type MutationDeleteSpaceArgs = {
  input: DeleteSpaceInput;
};


export type MutationDuplicatePageAssetsArgs = {
  input: DuplicatePageAssetsInput;
};


export type MutationHideAiThreadArgs = {
  input: HideAiThreadInput;
};


export type MutationInviteMembersArgs = {
  input: InviteMembersInput;
};


export type MutationInvitePageMembersArgs = {
  input: InvitePageMembersInput;
};


export type MutationLeaveSpaceArgs = {
  input: LeaveSpaceInput;
};


export type MutationLinearIssueCreateArgs = {
  input: LinearIssueCreateInput;
};


export type MutationLinearIssueDeleteArgs = {
  input: LinearIssueDeleteInput;
};


export type MutationMarkNotificationsAsReadArgs = {
  input: MarkNotificationsAsReadInput;
};


export type MutationRemoveAiPromptArgs = {
  input: RemoveAiPromptInput;
};


export type MutationRemoveMemberArgs = {
  input: RemoveMemberInput;
};


export type MutationRemoveSharedPageArgs = {
  input: RemoveSharedPageInput;
};


export type MutationRemoveUserIntegrationArgs = {
  input: RemoveUserIntegrationInput;
};


export type MutationRequestSignInLinkArgs = {
  input: RequestSignInLinkInput;
};


export type MutationRevokeInviteArgs = {
  input: RevokeInviteInput;
};


export type MutationRevokePageInviteArgs = {
  input: RevokePageInviteInput;
};


export type MutationSendNotificationArgs = {
  input: SendNotificationInput;
};


export type MutationSendTaskAssignmentNotificationArgs = {
  input: SendTaskAssignmentNotificationInput;
};


export type MutationSendTaskMentionNotificationArgs = {
  input: SendTaskMentionNotificationInput;
};


export type MutationSharePageArgs = {
  input: SharePageInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationUpdateAiPromptsArgs = {
  input: Array<UpdateAiPromptsInput>;
};


export type MutationUpdateMemberRoleArgs = {
  input: UpdateMemberRoleInput;
};


export type MutationUpdatePageSharedToSpaceArgs = {
  input: UpdatePageSharedToSpaceInput;
};


export type MutationUpdateSpaceMetadataArgs = {
  input: UpdateSpaceMetadataInput;
};


export type MutationUpdateSpacePublicMetadataArgs = {
  input: UpdateSpacePublicMetadataInput;
};


export type MutationUpdateSpaceSortingArgs = {
  input: UpdateSpaceSortingInput;
};


export type MutationUpdateSpaceUseCasesArgs = {
  input: UpdateSpaceUseCasesInput;
};


export type MutationUpdateUserLanguageArgs = {
  input: UpdateUserLanguageInput;
};


export type MutationUpdateUserNameArgs = {
  input: UpdateUserNameInput;
};


export type MutationUpdateUserPagePermissionArgs = {
  input: UpdateUserPagePermissionInput;
};


export type MutationUpdateUserSettingsArgs = {
  input?: InputMaybe<UpdateUserSettingsInput>;
};

export type NewMemberInput = {
  email: Scalars['String']['input'];
  role: Role;
};

export type NewPageMemberInput = {
  email: Scalars['String']['input'];
  role: PagePermission;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Notification = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  readAt?: Maybe<Scalars['String']['output']>;
  spaceColor?: Maybe<Scalars['String']['output']>;
  spaceTitle: Scalars['String']['output'];
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
};

export type Page = {
  __typename?: 'Page';
  aliases: Array<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['String']['output']>;
  collections: Array<Scalars['String']['output']>;
  icon?: Maybe<PageIcon>;
  id: Scalars['String']['output'];
  isPublicDuplicatable?: Maybe<Scalars['Boolean']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  settings: PageSettings;
  spaceId: Scalars['String']['output'];
  staticBlocks: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
};

export type PageAndPermission = {
  __typename?: 'PageAndPermission';
  page: Page;
  permission: PagePermission;
};

export type PageHistoryInput = {
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type PageHistorySnapshot = {
  __typename?: 'PageHistorySnapshot';
  authorEmail?: Maybe<Scalars['String']['output']>;
  buffer: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type PageIcon = {
  __typename?: 'PageIcon';
  colons: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageInput = {
  pageId: Scalars['String']['input'];
};

export type PageInvite = {
  __typename?: 'PageInvite';
  id: Scalars['String']['output'];
  role: PagePermission;
  userEmail: Scalars['String']['output'];
};

export type PageInviteMeta = {
  __typename?: 'PageInviteMeta';
  id: Scalars['String']['output'];
  inviterEmail: Scalars['String']['output'];
  role: PagePermission;
  title: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

export type PageInviteMetaInput = {
  id: Scalars['String']['input'];
};

export type PageInviteNotification = Node & Notification & {
  __typename?: 'PageInviteNotification';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inviteId?: Maybe<Scalars['String']['output']>;
  pageId: Scalars['String']['output'];
  pageTitle: Scalars['String']['output'];
  readAt?: Maybe<Scalars['String']['output']>;
  spaceColor?: Maybe<Scalars['String']['output']>;
  spaceTitle: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type PageInvitesInput = {
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};

export type PageMember = {
  __typename?: 'PageMember';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  permission: PagePermission;
  userEmail?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type PageMembersInput = {
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};

export enum PagePermission {
  Admin = 'ADMIN',
  Hidden = 'HIDDEN',
  Viewer = 'VIEWER',
  Writer = 'WRITER'
}

export type PageSettings = {
  __typename?: 'PageSettings';
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
};

export type PagesByUrlKeyInput = {
  urlKey: Scalars['String']['input'];
};

export type Permissions = {
  __typename?: 'Permissions';
  editors: FeaturePermission;
  fileUpload: FileUploadPermission;
  guests: FeaturePermission;
  sagaAi: AiFeaturePermission;
  tasks: FeaturePermission;
  viewers: FeaturePermission;
};

export type PermissionsUpdatedInput = {
  urlKey: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  adminSpaceList: AdminSpaceList;
  adminUserList: AdminUserList;
  adminUserListSharedCount: UserListSharedCount;
  allSharedPagesStatusesByUrlKey: Array<SharedPage>;
  billingPortal: Scalars['String']['output'];
  cannyToken?: Maybe<Scalars['String']['output']>;
  chatThreads: Array<AiChatThread>;
  collectionsByUrlKey: Array<Collection>;
  currentUser?: Maybe<User>;
  getCustomToken: CustomToken;
  googleDriveDocument: GoogleDriveFile;
  inviteMetaData?: Maybe<InviteMetaData>;
  invites: Array<Invite>;
  invoices: Array<Invoices>;
  linearIssue: LinearIssue;
  linearTeams: Array<LinearTeam>;
  members: Array<Member>;
  notificationsConnection: NotificationsConnection;
  page?: Maybe<PageAndPermission>;
  pageHistory: Array<PageHistorySnapshot>;
  pageInviteMetaData?: Maybe<PageInviteMeta>;
  pageInvites: Array<PageInvite>;
  pageMembers: Array<PageMember>;
  pagesByUrlKey: Array<Page>;
  searchIntegrations: IntegrationSearchResult;
  sharedPageStatus?: Maybe<SharedPage>;
  spaceByUrlKey?: Maybe<Space>;
  spaceEmbeddings: Array<AiEmbedding>;
  spacePermissions: SpacePermissions;
  spaces: Array<Space>;
  subscriptionPlans: Array<SubscriptionPlan>;
  subscriptionUpcoming?: Maybe<SubscriptionUpcoming>;
  templates: Array<Template>;
  unreadNotificationsCounter?: Maybe<Scalars['Int']['output']>;
  userIntegrations: Array<UserIntegration>;
  userInvites: Array<InviteMetaData>;
  userPageInvites: Array<PageInviteMeta>;
  userPagePermissionsBySpaceId: Array<UserPagePermission>;
  userSettings?: Maybe<UserSettings>;
  userSharedPages: Array<SharedPageInfo>;
};


export type QueryAdminSpaceListArgs = {
  input: AdminSpaceListInput;
};


export type QueryAdminUserListArgs = {
  input: AdminUserListInput;
};


export type QueryAdminUserListSharedCountArgs = {
  input: AdminUserListSharedCountInput;
};


export type QueryAllSharedPagesStatusesByUrlKeyArgs = {
  input: PagesByUrlKeyInput;
};


export type QueryBillingPortalArgs = {
  input: BillingPortalInput;
};


export type QueryChatThreadsArgs = {
  input: ChatThreadsInput;
};


export type QueryCollectionsByUrlKeyArgs = {
  input: CollectionsByUrlKeyInput;
};


export type QueryGoogleDriveDocumentArgs = {
  input: GoogleDriveFileInput;
};


export type QueryInviteMetaDataArgs = {
  input: InviteMetaDataInput;
};


export type QueryInvitesArgs = {
  input: InvitesInput;
};


export type QueryInvoicesArgs = {
  input: InvoicesInput;
};


export type QueryLinearIssueArgs = {
  input: LinearIssueInput;
};


export type QueryMembersArgs = {
  input: MembersInput;
};


export type QueryNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPageArgs = {
  input: PageInput;
};


export type QueryPageHistoryArgs = {
  input: PageHistoryInput;
};


export type QueryPageInviteMetaDataArgs = {
  input: PageInviteMetaInput;
};


export type QueryPageInvitesArgs = {
  input: PageInvitesInput;
};


export type QueryPageMembersArgs = {
  input: PageMembersInput;
};


export type QueryPagesByUrlKeyArgs = {
  input: PagesByUrlKeyInput;
};


export type QuerySearchIntegrationsArgs = {
  input: IntegrationSearchInput;
};


export type QuerySharedPageStatusArgs = {
  input: PageInput;
};


export type QuerySpaceByUrlKeyArgs = {
  input: SpaceByUrlKeyInput;
};


export type QuerySpaceEmbeddingsArgs = {
  input: EmbeddingSearchInput;
};


export type QuerySpacePermissionsArgs = {
  input: SpaceByUrlKeyInput;
};


export type QuerySubscriptionUpcomingArgs = {
  input: SubscriptionUpcomingInput;
};


export type QueryUserPagePermissionsBySpaceIdArgs = {
  input: UserPagePermissionsBySpaceIdInput;
};

export type RemoveAiPromptInput = {
  id: Scalars['ID']['input'];
};

export type RemoveMemberInput = {
  urlKey: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveSharedPageInput = {
  pageId: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type RemoveUserIntegrationInput = {
  id: Scalars['String']['input'];
};

export type RequestSignInLinkInput = {
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type RevokeInviteInput = {
  id: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type RevokePageInviteInput = {
  id: Scalars['String']['input'];
};

export enum Role {
  Member = 'MEMBER',
  Owner = 'OWNER',
  Viewer = 'VIEWER',
  Writer = 'WRITER'
}

export type SendNotificationInput = {
  blockId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};

export type SendTaskAssignmentNotificationInput = {
  action: TaskAssignAction;
  memberId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type SendTaskMentionNotificationInput = {
  blockId: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};

export type SharePageInput = {
  pageId: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type SharedPage = {
  __typename?: 'SharedPage';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  isPrivateInSpace: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  spaceId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SharedPageInfo = {
  __typename?: 'SharedPageInfo';
  icon?: Maybe<PageIcon>;
  page: SharedPage;
  permission: PagePermission;
  sharedBy: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SignupInput = {
  agreedToTerms: Scalars['Boolean']['input'];
  firstName: Scalars['String']['input'];
  language: Language;
  lastName: Scalars['String']['input'];
  optInTracking: Scalars['Boolean']['input'];
};

export type Space = {
  __typename?: 'Space';
  access: SpaceAccess;
  activeSubscription?: Maybe<SpaceSubscription>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isCopyWorkspaceEnabled: Scalars['Boolean']['output'];
  isEmbeddingEnabled: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  members: Array<Member>;
  owner: Scalars['String']['output'];
  permissions: Permissions;
  subscriptions: Array<Maybe<SpaceSubscription>>;
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
  useCases: Array<Scalars['String']['output']>;
};

export type SpaceAiSuggestion = {
  __typename?: 'SpaceAISuggestion';
  id: Scalars['ID']['output'];
  promptText: Scalars['String']['output'];
  promptTokens: Scalars['Int']['output'];
  responseText: Scalars['String']['output'];
  responseTokens: Scalars['Int']['output'];
  spaceId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SpaceAccess = {
  __typename?: 'SpaceAccess';
  read: Scalars['Boolean']['output'];
  write: Scalars['Boolean']['output'];
};

export type SpaceByUrlKeyInput = {
  urlKey: Scalars['String']['input'];
};

export type SpacePermissions = {
  __typename?: 'SpacePermissions';
  sagaAiStatus: Scalars['String']['output'];
};

export type SpaceSubscription = {
  __typename?: 'SpaceSubscription';
  canceled: Scalars['Boolean']['output'];
  currentPeriodEnd: Scalars['Date']['output'];
  currentPeriodStart: Scalars['Date']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  plan: SpaceSubscriptionPlan;
  planId: Scalars['String']['output'];
  price: SubscriptionPlanPrice;
  priceId: Scalars['String']['output'];
  spaceId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subscriptionId: Scalars['String']['output'];
};

export type SpaceSubscriptionPlan = {
  __typename?: 'SpaceSubscriptionPlan';
  featureSet: FeatureSet;
  id: Scalars['ID']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  permissionsUpdated: SpacePermissions;
  unreadNotificationsCounterUpdated: Scalars['Int']['output'];
  userPagePermissionsBySpaceId: Array<UserPagePermission>;
  userSharedPages?: Maybe<Array<SharedPageInfo>>;
};


export type SubscriptionPermissionsUpdatedArgs = {
  input: PermissionsUpdatedInput;
};


export type SubscriptionUserPagePermissionsBySpaceIdArgs = {
  input: UserPagePermissionsBySpaceIdInput;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  featureSet: FeatureSet;
  id: Scalars['String']['output'];
  price: Array<SubscriptionPlanPrice>;
  stripeId: Scalars['String']['output'];
};

export type SubscriptionPlanPrice = {
  __typename?: 'SubscriptionPlanPrice';
  amount: Scalars['Int']['output'];
  amountDecimal: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: SubscriptionPriceInterval;
  lookupKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stripeId: Scalars['String']['output'];
};

export enum SubscriptionPriceInterval {
  Month = 'month',
  Year = 'year'
}

export type SubscriptionSession = {
  __typename?: 'SubscriptionSession';
  session?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionUpcoming = {
  __typename?: 'SubscriptionUpcoming';
  created: Scalars['Date']['output'];
  paid: Scalars['Boolean']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  total: Scalars['Int']['output'];
};

export type SubscriptionUpcomingInput = {
  priceId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};

export enum TaskAssignAction {
  Assign = 'ASSIGN',
  Unassign = 'UNASSIGN'
}

export type TaskAssignmentNotification = Node & Notification & {
  __typename?: 'TaskAssignmentNotification';
  action: TaskAssignAction;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  readAt?: Maybe<Scalars['String']['output']>;
  spaceColor?: Maybe<Scalars['String']['output']>;
  spaceId: Scalars['String']['output'];
  spaceTitle: Scalars['String']['output'];
  spaceUrlKey: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskTitle: Scalars['String']['output'];
  taskUrl: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type TaskMentionNotification = Node & Notification & {
  __typename?: 'TaskMentionNotification';
  blockId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mentionBlockUrl: Scalars['String']['output'];
  readAt?: Maybe<Scalars['String']['output']>;
  spaceColor?: Maybe<Scalars['String']['output']>;
  spaceId: Scalars['String']['output'];
  spaceTitle: Scalars['String']['output'];
  spaceUrlKey: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskTitle: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type Template = Node & {
  __typename?: 'Template';
  aliases: Array<Scalars['String']['output']>;
  blocks: Scalars['JSON']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type UpdateAiPromptsInput = {
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CustomPromptType>;
};

export type UpdateMemberRoleInput = {
  role: Role;
  urlKey: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdatePageSharedToSpaceInput = {
  isPrivateInSpace: Scalars['Boolean']['input'];
  pageId: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type UpdateSpaceMetadataInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  isCopyWorkspaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEmbeddingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  urlKey: Scalars['String']['input'];
};

export type UpdateSpacePublicMetadataInput = {
  isCopyWorkspaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  urlKey: Scalars['String']['input'];
};

export type UpdateSpaceSortingInput = {
  sortedUrlKeys: Array<Scalars['String']['input']>;
};

export type UpdateSpaceUseCasesInput = {
  urlKey: Scalars['String']['input'];
  useCases: Array<Scalars['String']['input']>;
};

export type UpdateUserLanguageInput = {
  language: Language;
};

export type UpdateUserNameInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type UpdateUserPagePermissionInput = {
  pageId: Scalars['String']['input'];
  permission: PagePermission;
  spaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  userType: UserTypePagePermission;
};

export type UpdateUserSettingsInput = {
  editorFont?: InputMaybe<Scalars['String']['input']>;
  extendedSettings?: InputMaybe<ExtendedSettingsInput>;
  hiddenDefaultPrompts?: InputMaybe<Array<Scalars['String']['input']>>;
  interfaceFont?: InputMaybe<Scalars['String']['input']>;
  showInlinePageLinkIcons?: InputMaybe<Scalars['Boolean']['input']>;
  sortedSpaces?: InputMaybe<Array<Scalars['String']['input']>>;
  weekStartOnMonday?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['String']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  data: UserData;
  id: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type UserData = {
  __typename?: 'UserData';
  agreedToTerms: Scalars['Boolean']['output'];
  agreedToTermsDate?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  language: Language;
  lastName: Scalars['String']['output'];
  optInTracking: Scalars['Boolean']['output'];
  role: UserRole;
};

export type UserDelete = {
  __typename?: 'UserDelete';
  status: UserDeleteStatus;
  userId: Scalars['String']['output'];
};

export enum UserDeleteStatus {
  Deleted = 'DELETED',
  NotFound = 'NOT_FOUND',
  Success = 'SUCCESS'
}

export type UserIntegration = {
  __typename?: 'UserIntegration';
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  type: UserIntegrationType;
};

export enum UserIntegrationType {
  GoogleDrive = 'GOOGLE_DRIVE',
  Linear = 'LINEAR'
}

export type UserListSharedCount = {
  __typename?: 'UserListSharedCount';
  publicPagesCount: Scalars['Int']['output'];
  publicSpacesCount: Scalars['Int']['output'];
};

export type UserMembership = {
  __typename?: 'UserMembership';
  publicPages: Array<Maybe<SharedPage>>;
  role: Role;
  spaceDeletable: Scalars['Boolean']['output'];
  spaceId: Scalars['String']['output'];
  spaceName: Scalars['String']['output'];
};

export type UserPagePermission = {
  __typename?: 'UserPagePermission';
  pageId: Scalars['String']['output'];
  permission: PagePermission;
  spaceId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserPagePermissionsBySpaceIdInput = {
  spaceId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum UserRole {
  Admin = 'ADMIN',
  God = 'GOD',
  User = 'USER'
}

export type UserSettings = {
  __typename?: 'UserSettings';
  customAIPrompts: Array<CustomAiPrompt>;
  editorFont?: Maybe<Scalars['String']['output']>;
  extendedSettings?: Maybe<ExtendedSettings>;
  hiddenDefaultPrompts: Array<Scalars['String']['output']>;
  interfaceFont?: Maybe<Scalars['String']['output']>;
  showInlinePageLinkIcons: Scalars['Boolean']['output'];
  spaceSorting: Array<Scalars['String']['output']>;
  weekStartOnMonday: Scalars['Boolean']['output'];
};

export enum UserTypePagePermission {
  Guest = 'GUEST',
  Member = 'MEMBER'
}

export type UserWithDetails = {
  __typename?: 'UserWithDetails';
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrations: Array<UserIntegration>;
  lastName?: Maybe<Scalars['String']['output']>;
  membership?: Maybe<Array<UserMembership>>;
  role: UserRole;
  updatedAt: Scalars['Date']['output'];
};

export type WorkspaceCollaborationNotification = Node & Notification & {
  __typename?: 'WorkspaceCollaborationNotification';
  activeSubscription: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inviteId?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['String']['output']>;
  spaceColor?: Maybe<Scalars['String']['output']>;
  spaceId: Scalars['String']['output'];
  spaceTitle: Scalars['String']['output'];
  spaceUrlKey: Scalars['String']['output'];
  type: WorkspaceCollaborationNotificationType;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export enum WorkspaceCollaborationNotificationType {
  WorkspaceInvite = 'WorkspaceInvite',
  WorkspaceJoined = 'WorkspaceJoined',
  WorkspaceLeft = 'WorkspaceLeft',
  WorkspaceMemberRemoved = 'WorkspaceMemberRemoved'
}

export type SubscriptionFragmentFragment = { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } };

export type SpaceFragmentFragment = { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } };

export type SpaceWithMembersFragment = { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail?: string | null, role?: Role | null }>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } };

export type UserFragmentFragment = { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate?: string | null, optInTracking: boolean, language: Language, role: UserRole } };

export type UserSettingsFragment = { __typename?: 'UserSettings', spaceSorting: Array<string>, showInlinePageLinkIcons: boolean, weekStartOnMonday: boolean, hiddenDefaultPrompts: Array<string>, interfaceFont?: string | null, editorFont?: string | null, customAIPrompts: Array<{ __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType }>, extendedSettings?: { __typename?: 'ExtendedSettings', pagesColumnsOrder?: Array<string> | null, sharedPagesColumnsOrder?: Array<string> | null, tasksColumnsOrder?: Array<string> | null, collectionsColumnsOrder?: Array<string> | null, collectionPropertiesOrder?: Array<{ __typename?: 'CollectionPropertyOrder', collectionId: string, tagViewProperties: Array<string>, folderViewProperties: Array<string> }> | null } | null };

export type ExtendedSettingsFragment = { __typename?: 'ExtendedSettings', pagesColumnsOrder?: Array<string> | null, sharedPagesColumnsOrder?: Array<string> | null, tasksColumnsOrder?: Array<string> | null, collectionsColumnsOrder?: Array<string> | null, collectionPropertiesOrder?: Array<{ __typename?: 'CollectionPropertyOrder', collectionId: string, tagViewProperties: Array<string>, folderViewProperties: Array<string> }> | null };

export type CustomAiPromptsFragment = { __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType };

export type MemberFragmentFragment = { __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail?: string | null, role?: Role | null };

export type PublicMemberFragment = { __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string };

export type InviteFragmentFragment = { __typename?: 'Invite', id: string, userEmail: string, role: Role };

export type InviteMetaDataFragmentFragment = { __typename?: 'InviteMetaData', inviteId: string, workspaceTitle: string, workspaceOwnerEmail: string, workspaceMembersCount: number, userEmail: string };

export type PageInviteMetaFragmentFragment = { __typename?: 'PageInviteMeta', id: string, userEmail: string, inviterEmail: string, title: string, role: PagePermission };

export type PageInviteFragmentFragment = { __typename?: 'PageInvite', id: string, userEmail: string, role: PagePermission };

export type PageIconFragmentFragment = { __typename?: 'PageIcon', type: string, colons: string };

export type PageFragmentFragment = { __typename?: 'Page', id: string, title: string, collections: Array<string>, aliases: Array<string>, archivedAt?: string | null, isTemplate?: boolean | null, isPublicDuplicatable?: boolean | null, spaceId: string, staticBlocks: any, icon?: { __typename?: 'PageIcon', type: string, colons: string } | null, settings: { __typename?: 'PageSettings', fullWidth?: boolean | null } };

export type PageAndPermissionFragmentFragment = { __typename?: 'PageAndPermission', permission: PagePermission, page: { __typename?: 'Page', id: string, title: string, collections: Array<string>, aliases: Array<string>, archivedAt?: string | null, isTemplate?: boolean | null, isPublicDuplicatable?: boolean | null, spaceId: string, staticBlocks: any, icon?: { __typename?: 'PageIcon', type: string, colons: string } | null, settings: { __typename?: 'PageSettings', fullWidth?: boolean | null } } };

export type SharedPageFragmentFragment = { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any };

export type SharedPageInfoFragmentFragment = { __typename?: 'SharedPageInfo', title: string, permission: PagePermission, sharedBy: string, page: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any }, icon?: { __typename?: 'PageIcon', type: string, colons: string } | null };

export type AiChatMessageFragmentFragment = { __typename?: 'AIChatMessage', content?: string | null, role: AiChatRole, tool_calls?: any | null, tool_call_id?: string | null, createdAt: any };

export type AiChatThreadFragmentFragment = { __typename?: 'AIChatThread', id: string, spaceId: string, userId: string, messages: Array<{ __typename?: 'AIChatMessage', content?: string | null, role: AiChatRole, tool_calls?: any | null, tool_call_id?: string | null, createdAt: any }> };

export type CollectionFragmentFragment = { __typename?: 'Collection', id: string, title: string, updatedAt: string };

export type GoogleDriveFileFragment = { __typename?: 'GoogleDriveFile', id: string, name: string, webViewLink: string, iconLink?: string | null, thumbnailLink?: string | null, modifiedTime?: string | null, mimeType?: string | null, owners?: Array<{ __typename?: 'GoogleDriveOwner', displayName?: string | null } | null> | null };

export type LinearIssueFragment = { __typename?: 'LinearIssue', id: string, identifier: string, title: string, url: string, description?: string | null, updatedAt: any, priorityLabel?: string | null, priority: number, state?: { __typename?: 'LinearIssueState', name: string, color: string, type: string } | null, assignee?: { __typename?: 'LinearUser', name: string } | null };

export type LinearTeamFragment = { __typename?: 'LinearTeam', id: string, name: string };

export type MentionNotificationFragment = { __typename?: 'MentionNotification', id: string, spaceTitle: string, spaceColor?: string | null, pageTitle: string, pageId: string, blockId: string, spaceId: string, spaceUrlKey: string, userId: string, readAt?: string | null, createdAt: string, username: string, mentionBlockUrl: string };

export type TaskMentionNotificationFragment = { __typename?: 'TaskMentionNotification', id: string, spaceTitle: string, spaceColor?: string | null, taskTitle: string, taskId: string, blockId: string, spaceId: string, spaceUrlKey: string, userId: string, readAt?: string | null, createdAt: string, username: string, mentionBlockUrl: string };

export type TaskAssignmentNotificationFragment = { __typename?: 'TaskAssignmentNotification', id: string, spaceTitle: string, spaceColor?: string | null, taskId: string, taskTitle: string, taskUrl: string, action: TaskAssignAction, spaceId: string, spaceUrlKey: string, userId: string, readAt?: string | null, createdAt: string, username: string };

export type PageInviteNotificationFragment = { __typename?: 'PageInviteNotification', id: string, spaceTitle: string, spaceColor?: string | null, pageTitle: string, pageId: string, readAt?: string | null, createdAt: string, username: string, userId: string, inviteId?: string | null };

export type WorkspaceCollaborationNotificationFragment = { __typename?: 'WorkspaceCollaborationNotification', id: string, spaceTitle: string, spaceColor?: string | null, readAt?: string | null, createdAt: string, spaceId: string, spaceUrlKey: string, username: string, userId: string, type: WorkspaceCollaborationNotificationType, inviteId?: string | null, activeSubscription: boolean };

export type FullPageInfoFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type TemplateFragment = { __typename?: 'Template', id: string, title: string, icon?: string | null, blocks: any, aliases: Array<string> };

export type AiEmbeddingFragment = { __typename?: 'AIEmbedding', pageId: string, fromBlockId: string, toBlockId: string, distance: number };

export type UserPagePermissionFragmentFragment = { __typename?: 'UserPagePermission', userId: string, pageId: string, spaceId: string, permission: PagePermission };

export type PageMemberFragmentFragment = { __typename?: 'PageMember', firstName: string, lastName: string, userEmail?: string | null, userId: string, pageId: string, permission: PagePermission };

export type PageHistorySnapshotFragment = { __typename?: 'PageHistorySnapshot', updatedAt: any, buffer: string, authorEmail?: string | null };

export type NotificationsConnectionQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotificationsConnectionQuery = { __typename?: 'Query', notificationsConnection: { __typename?: 'NotificationsConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'NotificationEdge', cursor: string, node: { __typename: 'MentionNotification', id: string, createdAt: string, spaceTitle: string, spaceColor?: string | null, readAt?: string | null, pageTitle: string, pageId: string, blockId: string, spaceId: string, spaceUrlKey: string, userId: string, username: string, mentionBlockUrl: string } | { __typename: 'PageInviteNotification', id: string, createdAt: string, spaceTitle: string, spaceColor?: string | null, readAt?: string | null, pageTitle: string, pageId: string, username: string, userId: string, inviteId?: string | null } | { __typename: 'TaskAssignmentNotification', id: string, createdAt: string, spaceTitle: string, spaceColor?: string | null, readAt?: string | null, taskId: string, taskTitle: string, taskUrl: string, action: TaskAssignAction, spaceId: string, spaceUrlKey: string, userId: string, username: string } | { __typename: 'TaskMentionNotification', id: string, createdAt: string, spaceTitle: string, spaceColor?: string | null, readAt?: string | null, taskTitle: string, taskId: string, blockId: string, spaceId: string, spaceUrlKey: string, userId: string, username: string, mentionBlockUrl: string } | { __typename: 'WorkspaceCollaborationNotification', id: string, createdAt: string, spaceTitle: string, spaceColor?: string | null, readAt?: string | null, spaceId: string, spaceUrlKey: string, username: string, userId: string, type: WorkspaceCollaborationNotificationType, inviteId?: string | null, activeSubscription: boolean } }> } };

export type SpacesQueryVariables = Exact<{ [key: string]: never; }>;


export type SpacesQuery = { __typename?: 'Query', spaces: Array<{ __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } }> };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate?: string | null, optInTracking: boolean, language: Language, role: UserRole } } | null };

export type UserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDataQuery = { __typename?: 'Query', cannyToken?: string | null, currentUser?: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate?: string | null, optInTracking: boolean, language: Language, role: UserRole } } | null, getCustomToken: { __typename?: 'CustomToken', token: string }, spaces: Array<{ __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail?: string | null, role?: Role | null }>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } }>, userSettings?: { __typename?: 'UserSettings', spaceSorting: Array<string>, showInlinePageLinkIcons: boolean, weekStartOnMonday: boolean, hiddenDefaultPrompts: Array<string>, interfaceFont?: string | null, editorFont?: string | null, customAIPrompts: Array<{ __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType }>, extendedSettings?: { __typename?: 'ExtendedSettings', pagesColumnsOrder?: Array<string> | null, sharedPagesColumnsOrder?: Array<string> | null, tasksColumnsOrder?: Array<string> | null, collectionsColumnsOrder?: Array<string> | null, collectionPropertiesOrder?: Array<{ __typename?: 'CollectionPropertyOrder', collectionId: string, tagViewProperties: Array<string>, folderViewProperties: Array<string> }> | null } | null } | null };

export type UserInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInvitesQuery = { __typename?: 'Query', userInvites: Array<{ __typename?: 'InviteMetaData', inviteId: string, workspaceTitle: string, workspaceOwnerEmail: string, workspaceMembersCount: number, userEmail: string }> };

export type SpaceByUrlKeyQueryVariables = Exact<{
  input: SpaceByUrlKeyInput;
}>;


export type SpaceByUrlKeyQuery = { __typename?: 'Query', spaceByUrlKey?: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail?: string | null, role?: Role | null }>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } | null };

export type InvitesAndMembersQueryVariables = Exact<{
  urlKey: Scalars['String']['input'];
}>;


export type InvitesAndMembersQuery = { __typename?: 'Query', members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail?: string | null, role?: Role | null }>, invites: Array<{ __typename?: 'Invite', id: string, userEmail: string, role: Role }> };

export type MembersQueryVariables = Exact<{
  input: MembersInput;
}>;


export type MembersQuery = { __typename?: 'Query', members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string }> };

export type InviteMetaDataQueryVariables = Exact<{
  input: InviteMetaDataInput;
}>;


export type InviteMetaDataQuery = { __typename?: 'Query', inviteMetaData?: { __typename?: 'InviteMetaData', inviteId: string, workspaceTitle: string, workspaceOwnerEmail: string, workspaceMembersCount: number, userEmail: string } | null };

export type PageQueryVariables = Exact<{
  input: PageInput;
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'PageAndPermission', permission: PagePermission, page: { __typename?: 'Page', id: string, title: string, collections: Array<string>, aliases: Array<string>, archivedAt?: string | null, isTemplate?: boolean | null, isPublicDuplicatable?: boolean | null, spaceId: string, staticBlocks: any, icon?: { __typename?: 'PageIcon', type: string, colons: string } | null, settings: { __typename?: 'PageSettings', fullWidth?: boolean | null } } } | null };

export type SharedPageStatusQueryVariables = Exact<{
  input: PageInput;
}>;


export type SharedPageStatusQuery = { __typename?: 'Query', sharedPageStatus?: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any } | null };

export type AllSharedPagesStatusesByUrlKeyQueryVariables = Exact<{
  input: PagesByUrlKeyInput;
}>;


export type AllSharedPagesStatusesByUrlKeyQuery = { __typename?: 'Query', allSharedPagesStatusesByUrlKey: Array<{ __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any }> };

export type PagesByUrlKeyQueryVariables = Exact<{
  input: PagesByUrlKeyInput;
}>;


export type PagesByUrlKeyQuery = { __typename?: 'Query', pagesByUrlKey: Array<{ __typename?: 'Page', id: string, title: string, collections: Array<string>, aliases: Array<string>, archivedAt?: string | null, isTemplate?: boolean | null, isPublicDuplicatable?: boolean | null, spaceId: string, staticBlocks: any, icon?: { __typename?: 'PageIcon', type: string, colons: string } | null, settings: { __typename?: 'PageSettings', fullWidth?: boolean | null } }> };

export type CollectionsByUrlKeyQueryVariables = Exact<{
  input: CollectionsByUrlKeyInput;
}>;


export type CollectionsByUrlKeyQuery = { __typename?: 'Query', collectionsByUrlKey: Array<{ __typename?: 'Collection', id: string, title: string, updatedAt: string }> };

export type GetCustomTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomTokenQuery = { __typename?: 'Query', getCustomToken: { __typename?: 'CustomToken', token: string } };

export type SearchIntegrationsQueryVariables = Exact<{
  input: IntegrationSearchInput;
}>;


export type SearchIntegrationsQuery = { __typename?: 'Query', searchIntegrations: { __typename?: 'IntegrationSearchResult', googleDriveFiles: Array<{ __typename?: 'GoogleDriveFile', id: string, name: string, webViewLink: string, iconLink?: string | null, thumbnailLink?: string | null, modifiedTime?: string | null, mimeType?: string | null, owners?: Array<{ __typename?: 'GoogleDriveOwner', displayName?: string | null } | null> | null }>, linearIssues: Array<{ __typename?: 'LinearIssue', id: string, identifier: string, title: string, url: string, description?: string | null, updatedAt: any, priorityLabel?: string | null, priority: number, state?: { __typename?: 'LinearIssueState', name: string, color: string, type: string } | null, assignee?: { __typename?: 'LinearUser', name: string } | null }> } };

export type LinearIssueQueryVariables = Exact<{
  input: LinearIssueInput;
}>;


export type LinearIssueQuery = { __typename?: 'Query', linearIssue: { __typename?: 'LinearIssue', id: string, identifier: string, title: string, url: string, description?: string | null, updatedAt: any, priorityLabel?: string | null, priority: number, state?: { __typename?: 'LinearIssueState', name: string, color: string, type: string } | null, assignee?: { __typename?: 'LinearUser', name: string } | null } };

export type GoogleDriveDocumentQueryVariables = Exact<{
  input: GoogleDriveFileInput;
}>;


export type GoogleDriveDocumentQuery = { __typename?: 'Query', googleDriveDocument: { __typename?: 'GoogleDriveFile', id: string, name: string, webViewLink: string, iconLink?: string | null, thumbnailLink?: string | null, modifiedTime?: string | null, mimeType?: string | null, owners?: Array<{ __typename?: 'GoogleDriveOwner', displayName?: string | null } | null> | null } };

export type UserIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserIntegrationsQuery = { __typename?: 'Query', userIntegrations: Array<{ __typename?: 'UserIntegration', id: string, type: UserIntegrationType, isActive: boolean }> };

export type UnreadNotificationsCounterQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCounterQuery = { __typename?: 'Query', unreadNotificationsCounter?: number | null };

export type TemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplatesQuery = { __typename?: 'Query', templates: Array<{ __typename?: 'Template', id: string, title: string, icon?: string | null, blocks: any, aliases: Array<string> }> };

export type LinearTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type LinearTeamsQuery = { __typename?: 'Query', linearTeams: Array<{ __typename?: 'LinearTeam', id: string, name: string }> };

export type SubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPlansQuery = { __typename?: 'Query', subscriptionPlans: Array<{ __typename?: 'SubscriptionPlan', id: string, stripeId: string, featureSet: FeatureSet, price: Array<{ __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string }> }> };

export type InvoicesQueryVariables = Exact<{
  input: InvoicesInput;
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoices', id: string, subscriptionId: string, created: any, paid: boolean, total: number, pdfUrl?: string | null }> };

export type SubscriptionUpcomingQueryVariables = Exact<{
  input: SubscriptionUpcomingInput;
}>;


export type SubscriptionUpcomingQuery = { __typename?: 'Query', subscriptionUpcoming?: { __typename?: 'SubscriptionUpcoming', periodStart: any, periodEnd: any, paid: boolean, total: number, created: any } | null };

export type SpaceEmbeddingsQueryVariables = Exact<{
  input: EmbeddingSearchInput;
}>;


export type SpaceEmbeddingsQuery = { __typename?: 'Query', spaceEmbeddings: Array<{ __typename?: 'AIEmbedding', pageId: string, fromBlockId: string, toBlockId: string, distance: number }> };

export type AdminUserListQueryVariables = Exact<{
  input: AdminUserListInput;
}>;


export type AdminUserListQuery = { __typename?: 'Query', adminUserList: { __typename?: 'AdminUserList', users: Array<{ __typename?: 'AdminUser', id: string, email: string, names: string, role: UserRole, createdAt: string, updatedAt: string }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type AdminUserListSharedCountQueryVariables = Exact<{
  input: AdminUserListSharedCountInput;
}>;


export type AdminUserListSharedCountQuery = { __typename?: 'Query', adminUserListSharedCount: { __typename?: 'UserListSharedCount', publicPagesCount: number, publicSpacesCount: number } };

export type AdminSpaceListQueryVariables = Exact<{
  input: AdminSpaceListInput;
}>;


export type AdminSpaceListQuery = { __typename?: 'Query', adminSpaceList: { __typename?: 'AdminSpaceList', id: string, title: string, urlKey: string, createdAt: string, ownerIds: Array<string | null>, usedSpaceTokens: number, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, status: string, canceled: boolean, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, plan: { __typename?: 'SpaceSubscriptionPlan', id: string } } | null } };

export type SpacePermissionsQueryVariables = Exact<{
  input: SpaceByUrlKeyInput;
}>;


export type SpacePermissionsQuery = { __typename?: 'Query', spacePermissions: { __typename?: 'SpacePermissions', sagaAiStatus: string } };

export type BillingPortalQueryVariables = Exact<{
  input: BillingPortalInput;
}>;


export type BillingPortalQuery = { __typename?: 'Query', billingPortal: string };

export type UserPagePermissionsBySpaceIdQueryVariables = Exact<{
  input: UserPagePermissionsBySpaceIdInput;
}>;


export type UserPagePermissionsBySpaceIdQuery = { __typename?: 'Query', userPagePermissionsBySpaceId: Array<{ __typename?: 'UserPagePermission', userId: string, pageId: string, spaceId: string, permission: PagePermission }> };

export type PageInvitesAndMembersQueryVariables = Exact<{
  pageId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
}>;


export type PageInvitesAndMembersQuery = { __typename?: 'Query', pageMembers: Array<{ __typename?: 'PageMember', firstName: string, lastName: string, userEmail?: string | null, userId: string, pageId: string, permission: PagePermission }>, pageInvites: Array<{ __typename?: 'PageInvite', id: string, userEmail: string, role: PagePermission }> };

export type PageInviteMetaDataQueryVariables = Exact<{
  input: PageInviteMetaInput;
}>;


export type PageInviteMetaDataQuery = { __typename?: 'Query', pageInviteMetaData?: { __typename?: 'PageInviteMeta', id: string, userEmail: string, inviterEmail: string, title: string, role: PagePermission } | null };

export type UserPageInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPageInvitesQuery = { __typename?: 'Query', userPageInvites: Array<{ __typename?: 'PageInviteMeta', id: string, userEmail: string, inviterEmail: string, title: string, role: PagePermission }> };

export type UserSharedPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSharedPagesQuery = { __typename?: 'Query', userSharedPages: Array<{ __typename?: 'SharedPageInfo', title: string, permission: PagePermission, sharedBy: string, page: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any }, icon?: { __typename?: 'PageIcon', type: string, colons: string } | null }> };

export type ChatThreadsQueryVariables = Exact<{
  input: ChatThreadsInput;
}>;


export type ChatThreadsQuery = { __typename?: 'Query', chatThreads: Array<{ __typename?: 'AIChatThread', id: string, spaceId: string, userId: string, messages: Array<{ __typename?: 'AIChatMessage', content?: string | null, role: AiChatRole, tool_calls?: any | null, tool_call_id?: string | null, createdAt: any }> }> };

export type PageHistoryQueryVariables = Exact<{
  input: PageHistoryInput;
}>;


export type PageHistoryQuery = { __typename?: 'Query', pageHistory: Array<{ __typename?: 'PageHistorySnapshot', updatedAt: any, buffer: string, authorEmail?: string | null }> };

export type AdminUserDetailsMutationVariables = Exact<{
  input: AdminUserDetailsInput;
}>;


export type AdminUserDetailsMutation = { __typename?: 'Mutation', adminUserDetails: { __typename?: 'UserWithDetails', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, role: UserRole, createdAt: any, updatedAt: any, membership?: Array<{ __typename?: 'UserMembership', spaceId: string, spaceName: string, spaceDeletable: boolean, role: Role, publicPages: Array<{ __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any } | null> }> | null, integrations: Array<{ __typename?: 'UserIntegration', id: string, type: UserIntegrationType, isActive: boolean }> } };

export type AdminUserDeleteMutationVariables = Exact<{
  input: AdminUsersDeleteInput;
}>;


export type AdminUserDeleteMutation = { __typename?: 'Mutation', adminUserDelete: Array<{ __typename?: 'UserDelete', userId: string, status: UserDeleteStatus }> };

export type UpdateUserNameMutationVariables = Exact<{
  input: UpdateUserNameInput;
}>;


export type UpdateUserNameMutation = { __typename?: 'Mutation', updateUserName: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate?: string | null, optInTracking: boolean, language: Language, role: UserRole } } };

export type UpdateUserLanguageMutationVariables = Exact<{
  input: UpdateUserLanguageInput;
}>;


export type UpdateUserLanguageMutation = { __typename?: 'Mutation', updateUserLanguage: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate?: string | null, optInTracking: boolean, language: Language, role: UserRole } } };

export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, data: { __typename?: 'UserData', email: string, firstName: string, lastName: string, agreedToTerms: boolean, agreedToTermsDate?: string | null, optInTracking: boolean, language: Language, role: UserRole } } };

export type CreateSpaceMutationVariables = Exact<{
  input: CreateSpaceInput;
}>;


export type CreateSpaceMutation = { __typename?: 'Mutation', createSpace: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type CreatePageMutationVariables = Exact<{
  input: CreatePageInput;
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPage: { __typename?: 'Page', id: string, title: string, collections: Array<string>, aliases: Array<string>, archivedAt?: string | null, isTemplate?: boolean | null, isPublicDuplicatable?: boolean | null, spaceId: string, staticBlocks: any, icon?: { __typename?: 'PageIcon', type: string, colons: string } | null, settings: { __typename?: 'PageSettings', fullWidth?: boolean | null } } };

export type DeleteSpaceMutationVariables = Exact<{
  input: DeleteSpaceInput;
}>;


export type DeleteSpaceMutation = { __typename?: 'Mutation', deleteSpace: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type CopyWorkspaceMutationVariables = Exact<{
  input: CopyWorkspaceInput;
}>;


export type CopyWorkspaceMutation = { __typename?: 'Mutation', copyWorkspace: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type UpdateSpaceSortingMutationVariables = Exact<{
  input: UpdateSpaceSortingInput;
}>;


export type UpdateSpaceSortingMutation = { __typename?: 'Mutation', updateSpaceSorting: Array<{ __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } }> };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings: { __typename?: 'UserSettings', spaceSorting: Array<string>, showInlinePageLinkIcons: boolean, weekStartOnMonday: boolean, hiddenDefaultPrompts: Array<string>, interfaceFont?: string | null, editorFont?: string | null, customAIPrompts: Array<{ __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType }>, extendedSettings?: { __typename?: 'ExtendedSettings', pagesColumnsOrder?: Array<string> | null, sharedPagesColumnsOrder?: Array<string> | null, tasksColumnsOrder?: Array<string> | null, collectionsColumnsOrder?: Array<string> | null, collectionPropertiesOrder?: Array<{ __typename?: 'CollectionPropertyOrder', collectionId: string, tagViewProperties: Array<string>, folderViewProperties: Array<string> }> | null } | null } };

export type UpdateAiPromptsMutationVariables = Exact<{
  input: Array<UpdateAiPromptsInput> | UpdateAiPromptsInput;
}>;


export type UpdateAiPromptsMutation = { __typename?: 'Mutation', updateAIPrompts?: Array<{ __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType }> | null };

export type AddAiPromptMutationVariables = Exact<{
  input: AddAiPromptInput;
}>;


export type AddAiPromptMutation = { __typename?: 'Mutation', addAIPrompt: { __typename?: 'CustomAIPrompt', id: string, title: string, prompt: string, position: number, type: CustomPromptType } };

export type RemoveAiPromptMutationVariables = Exact<{
  input: RemoveAiPromptInput;
}>;


export type RemoveAiPromptMutation = { __typename?: 'Mutation', removeAIPrompt: boolean };

export type InviteMembersMutationVariables = Exact<{
  input: InviteMembersInput;
}>;


export type InviteMembersMutation = { __typename?: 'Mutation', inviteMembers: Array<{ __typename?: 'Invite', id: string, userEmail: string, role: Role }> };

export type RevokeInviteMutationVariables = Exact<{
  input: RevokeInviteInput;
}>;


export type RevokeInviteMutation = { __typename?: 'Mutation', revokeInvite: { __typename?: 'Invite', id: string, userEmail: string, role: Role } };

export type AcceptInvitationMutationVariables = Exact<{
  input: AcceptInvitationInput;
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type RemoveMemberMutationVariables = Exact<{
  input: RemoveMemberInput;
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMember: string };

export type UpdateMemberRoleMutationVariables = Exact<{
  input: UpdateMemberRoleInput;
}>;


export type UpdateMemberRoleMutation = { __typename?: 'Mutation', updateMemberRole: { __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail?: string | null, role?: Role | null } };

export type LeaveSpaceMutationVariables = Exact<{
  input: LeaveSpaceInput;
}>;


export type LeaveSpaceMutation = { __typename?: 'Mutation', leaveSpace: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type UpdateSpaceMetadataMutationVariables = Exact<{
  input: UpdateSpaceMetadataInput;
}>;


export type UpdateSpaceMetadataMutation = { __typename?: 'Mutation', updateSpaceMetadata: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type UpdateSpacePublicMetadataMutationVariables = Exact<{
  input: UpdateSpacePublicMetadataInput;
}>;


export type UpdateSpacePublicMetadataMutation = { __typename?: 'Mutation', updateSpacePublicMetadata: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type UpdateSpaceUseCasesMutationVariables = Exact<{
  input: UpdateSpaceUseCasesInput;
}>;


export type UpdateSpaceUseCasesMutation = { __typename?: 'Mutation', updateSpaceUseCases: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } };

export type RequestSignInLinkMutationVariables = Exact<{
  input: RequestSignInLinkInput;
}>;


export type RequestSignInLinkMutation = { __typename?: 'Mutation', requestSignInLink: boolean };

export type AddBlocksMutationVariables = Exact<{
  input: AddBlocksInput;
}>;


export type AddBlocksMutation = { __typename?: 'Mutation', addBlocks?: string | null };

export type SendTaskMentionNotificationMutationVariables = Exact<{
  input: SendTaskMentionNotificationInput;
}>;


export type SendTaskMentionNotificationMutation = { __typename?: 'Mutation', sendTaskMentionNotification: boolean };

export type SendTaskAssignmentNotificationMutationVariables = Exact<{
  input: SendTaskAssignmentNotificationInput;
}>;


export type SendTaskAssignmentNotificationMutation = { __typename?: 'Mutation', sendTaskAssignmentNotification: boolean };

export type SendNotificationMutationVariables = Exact<{
  input: SendNotificationInput;
}>;


export type SendNotificationMutation = { __typename?: 'Mutation', sendNotification: boolean };

export type RemoveUserIntegrationMutationVariables = Exact<{
  input: RemoveUserIntegrationInput;
}>;


export type RemoveUserIntegrationMutation = { __typename?: 'Mutation', removeUserIntegration: boolean };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  input: MarkNotificationsAsReadInput;
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', markNotificationsAsRead: Array<{ __typename: 'MentionNotification', id: string, readAt?: string | null } | { __typename: 'PageInviteNotification', id: string, readAt?: string | null } | { __typename: 'TaskAssignmentNotification', id: string, readAt?: string | null } | { __typename: 'TaskMentionNotification', id: string, readAt?: string | null } | { __typename: 'WorkspaceCollaborationNotification', id: string, readAt?: string | null }> };

export type SharePageMutationVariables = Exact<{
  input: SharePageInput;
}>;


export type SharePageMutation = { __typename?: 'Mutation', sharePage: { __typename?: 'SharedPage', id: string } };

export type RemoveSharedPageMutationVariables = Exact<{
  input: RemoveSharedPageInput;
}>;


export type RemoveSharedPageMutation = { __typename?: 'Mutation', removeSharedPage: boolean };

export type InvitePageMembersMutationVariables = Exact<{
  input: InvitePageMembersInput;
}>;


export type InvitePageMembersMutation = { __typename?: 'Mutation', invitePageMembers: Array<{ __typename?: 'PageInvite', id: string, userEmail: string, role: PagePermission }> };

export type RevokePageInviteMutationVariables = Exact<{
  input: RevokePageInviteInput;
}>;


export type RevokePageInviteMutation = { __typename?: 'Mutation', revokePageInvite: { __typename?: 'PageInvite', id: string, userEmail: string, role: PagePermission } };

export type AcceptPageInvitationMutationVariables = Exact<{
  input: AcceptPageInvitationInput;
}>;


export type AcceptPageInvitationMutation = { __typename?: 'Mutation', acceptPageInvitation: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any } };

export type LinearIssueCreateMutationVariables = Exact<{
  input: LinearIssueCreateInput;
}>;


export type LinearIssueCreateMutation = { __typename?: 'Mutation', linearIssueCreate: { __typename?: 'LinearIssue', id: string, identifier: string, title: string, url: string, description?: string | null, updatedAt: any, priorityLabel?: string | null, priority: number, state?: { __typename?: 'LinearIssueState', name: string, color: string, type: string } | null, assignee?: { __typename?: 'LinearUser', name: string } | null } };

export type LinearIssueDeleteMutationVariables = Exact<{
  input: LinearIssueDeleteInput;
}>;


export type LinearIssueDeleteMutation = { __typename?: 'Mutation', linearIssueDelete: boolean };

export type CreateSubscriptionSessionMutationVariables = Exact<{
  input: CreateSubscriptionSessionInput;
}>;


export type CreateSubscriptionSessionMutation = { __typename?: 'Mutation', createSubscriptionSession: { __typename?: 'SubscriptionSession', session?: string | null } };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription?: { __typename?: 'CreateSpaceSubscription', space?: { __typename?: 'Space', id: string, title: string, urlKey: string, createdAt: string, isPublic: boolean, isCopyWorkspaceEnabled: boolean, isEmbeddingEnabled: boolean, color?: string | null, owner: string, useCases: Array<string>, members: Array<{ __typename?: 'Member', id: string, spaceId: string, firstName: string, lastName: string, userEmail?: string | null, role?: Role | null }>, activeSubscription?: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null, subscriptions: Array<{ __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } | null>, access: { __typename?: 'SpaceAccess', write: boolean }, permissions: { __typename?: 'Permissions', editors: { __typename?: 'FeaturePermission', enabled: boolean, limit?: number | null }, guests: { __typename?: 'FeaturePermission', limit?: number | null }, tasks: { __typename?: 'FeaturePermission', enabled: boolean }, viewers: { __typename?: 'FeaturePermission', enabled: boolean }, fileUpload: { __typename?: 'FileUploadPermission', limitFile: number }, sagaAi: { __typename?: 'AIFeaturePermission', enabled: boolean, limit: number, model: string } } } | null } | null };

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } };

export type ChangeSubscriptionMutationVariables = Exact<{
  input: ChangeSubscriptionInput;
}>;


export type ChangeSubscriptionMutation = { __typename?: 'Mutation', changeSubscription: { __typename?: 'SpaceSubscription', id: string, subscriptionId: string, status: string, canceled: boolean, spaceId: string, customerId: string, currentPeriodEnd: any, currentPeriodStart: any, planId: string, priceId: string, plan: { __typename?: 'SpaceSubscriptionPlan', id: string, featureSet: FeatureSet }, price: { __typename?: 'SubscriptionPlanPrice', id: string, amount: number, amountDecimal: string, currency: string, stripeId: string, lookupKey: string, interval: SubscriptionPriceInterval, status: string } } };

export type DeleteAssetMutationVariables = Exact<{
  input: DeleteAssetInput;
}>;


export type DeleteAssetMutation = { __typename?: 'Mutation', deleteAsset: boolean };

export type DuplicatePageAssetsMutationVariables = Exact<{
  input: DuplicatePageAssetsInput;
}>;


export type DuplicatePageAssetsMutation = { __typename?: 'Mutation', duplicatePageAssets: boolean };

export type UpdateUserPagePermissionMutationVariables = Exact<{
  input: UpdateUserPagePermissionInput;
}>;


export type UpdateUserPagePermissionMutation = { __typename?: 'Mutation', updateUserPagePermission: Array<{ __typename?: 'PageMember', firstName: string, lastName: string, userEmail?: string | null, userId: string, pageId: string, permission: PagePermission }> };

export type UpdatePageSharedToSpaceMutationVariables = Exact<{
  input: UpdatePageSharedToSpaceInput;
}>;


export type UpdatePageSharedToSpaceMutation = { __typename?: 'Mutation', updatePageSharedToSpace: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any } };

export type HideAiThreadMutationVariables = Exact<{
  input: HideAiThreadInput;
}>;


export type HideAiThreadMutation = { __typename?: 'Mutation', hideAIThread: boolean };

export type UnreadNotificationsCounterUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCounterUpdatedSubscription = { __typename?: 'Subscription', unreadNotificationsCounterUpdated: number };

export type PermissionsUpdatedSubscriptionVariables = Exact<{
  input: PermissionsUpdatedInput;
}>;


export type PermissionsUpdatedSubscription = { __typename?: 'Subscription', permissionsUpdated: { __typename?: 'SpacePermissions', sagaAiStatus: string } };

export type UserPagePermissionsBySpaceIdUpdatedSubscriptionVariables = Exact<{
  input: UserPagePermissionsBySpaceIdInput;
}>;


export type UserPagePermissionsBySpaceIdUpdatedSubscription = { __typename?: 'Subscription', userPagePermissionsBySpaceId: Array<{ __typename?: 'UserPagePermission', userId: string, pageId: string, spaceId: string, permission: PagePermission }> };

export type UserSharedPagesUpdatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserSharedPagesUpdatedSubscription = { __typename?: 'Subscription', userSharedPages?: Array<{ __typename?: 'SharedPageInfo', title: string, permission: PagePermission, sharedBy: string, page: { __typename?: 'SharedPage', id: string, spaceId: string, isPrivateInSpace: boolean, isPublic: boolean, createdAt: any, updatedAt: any }, icon?: { __typename?: 'PageIcon', type: string, colons: string } | null }> | null };

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;


/** Mapping of interface types */
export type ResolversInterfaceTypes<RefType extends Record<string, unknown>> = ResolversObject<{
  Node: ( MentionNotification ) | ( PageInviteNotification ) | ( TaskAssignmentNotification ) | ( TaskMentionNotification ) | ( Template ) | ( WorkspaceCollaborationNotification );
  Notification: ( MentionNotification ) | ( PageInviteNotification ) | ( TaskAssignmentNotification ) | ( TaskMentionNotification ) | ( WorkspaceCollaborationNotification );
}>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AIChatMessage: ResolverTypeWrapper<AiChatMessage>;
  AIChatRole: AiChatRole;
  AIChatThread: ResolverTypeWrapper<AiChatThread>;
  AIEmbedding: ResolverTypeWrapper<AiEmbedding>;
  AIFeaturePermission: ResolverTypeWrapper<AiFeaturePermission>;
  AISugesstionInput: AiSugesstionInput;
  AcceptInvitationInput: AcceptInvitationInput;
  AcceptPageInvitationInput: AcceptPageInvitationInput;
  AddAIPromptInput: AddAiPromptInput;
  AddBlocksInput: AddBlocksInput;
  AdminSpaceList: ResolverTypeWrapper<AdminSpaceList>;
  AdminSpaceListInput: AdminSpaceListInput;
  AdminUser: ResolverTypeWrapper<AdminUser>;
  AdminUserDeleteInput: AdminUserDeleteInput;
  AdminUserDetailsInput: AdminUserDetailsInput;
  AdminUserList: ResolverTypeWrapper<AdminUserList>;
  AdminUserListInput: AdminUserListInput;
  AdminUserListSharedCountInput: AdminUserListSharedCountInput;
  AdminUsersDeleteInput: AdminUsersDeleteInput;
  ApiToken: ResolverTypeWrapper<ApiToken>;
  BillingPortalInput: BillingPortalInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Byte: ResolverTypeWrapper<Scalars['Byte']['output']>;
  CancelSubscriptionInput: CancelSubscriptionInput;
  ChangeSubscriptionInput: ChangeSubscriptionInput;
  ChatThreadsInput: ChatThreadsInput;
  Collection: ResolverTypeWrapper<Collection>;
  CollectionPropertiesOrderInput: CollectionPropertiesOrderInput;
  CollectionPropertyOrder: ResolverTypeWrapper<CollectionPropertyOrder>;
  CollectionsByUrlKeyInput: CollectionsByUrlKeyInput;
  CopyWorkspaceInput: CopyWorkspaceInput;
  CreateApiTokenInput: CreateApiTokenInput;
  CreatePageInput: CreatePageInput;
  CreateSpaceInput: CreateSpaceInput;
  CreateSpaceSubscription: ResolverTypeWrapper<CreateSpaceSubscription>;
  CreateSpaceTestInput: CreateSpaceTestInput;
  CreateSubscriptionInput: CreateSubscriptionInput;
  CreateSubscriptionSessionInput: CreateSubscriptionSessionInput;
  CustomAIPrompt: ResolverTypeWrapper<CustomAiPrompt>;
  CustomPromptType: CustomPromptType;
  CustomToken: ResolverTypeWrapper<CustomToken>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DeleteAssetInput: DeleteAssetInput;
  DeleteSpaceInput: DeleteSpaceInput;
  DuplicateAssetKeyInput: DuplicateAssetKeyInput;
  DuplicatePageAssetsInput: DuplicatePageAssetsInput;
  EmbeddingSearchInput: EmbeddingSearchInput;
  ExtendedSettings: ResolverTypeWrapper<ExtendedSettings>;
  ExtendedSettingsInput: ExtendedSettingsInput;
  FeaturePermission: ResolverTypeWrapper<FeaturePermission>;
  FeatureSet: FeatureSet;
  FileUploadPermission: ResolverTypeWrapper<FileUploadPermission>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GoogleDriveFile: ResolverTypeWrapper<GoogleDriveFile>;
  GoogleDriveFileInput: GoogleDriveFileInput;
  GoogleDriveOwner: ResolverTypeWrapper<GoogleDriveOwner>;
  HideAIThreadInput: HideAiThreadInput;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  IntegrationSearchInput: IntegrationSearchInput;
  IntegrationSearchResult: ResolverTypeWrapper<IntegrationSearchResult>;
  Invite: ResolverTypeWrapper<Invite>;
  InviteMembersInput: InviteMembersInput;
  InviteMetaData: ResolverTypeWrapper<InviteMetaData>;
  InviteMetaDataInput: InviteMetaDataInput;
  InvitePageMembersInput: InvitePageMembersInput;
  InvitesInput: InvitesInput;
  Invoices: ResolverTypeWrapper<Invoices>;
  InvoicesInput: InvoicesInput;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  Language: Language;
  LeaveSpaceInput: LeaveSpaceInput;
  LinearIssue: ResolverTypeWrapper<LinearIssue>;
  LinearIssueCreateInput: LinearIssueCreateInput;
  LinearIssueDeleteInput: LinearIssueDeleteInput;
  LinearIssueInput: LinearIssueInput;
  LinearIssueState: ResolverTypeWrapper<LinearIssueState>;
  LinearTeam: ResolverTypeWrapper<LinearTeam>;
  LinearUser: ResolverTypeWrapper<LinearUser>;
  MarkNotificationsAsReadInput: MarkNotificationsAsReadInput;
  Member: ResolverTypeWrapper<Member>;
  MembersInput: MembersInput;
  MentionNotification: ResolverTypeWrapper<MentionNotification>;
  Mutation: ResolverTypeWrapper<{}>;
  NewMemberInput: NewMemberInput;
  NewPageMemberInput: NewPageMemberInput;
  Node: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Node']>;
  Notification: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Notification']>;
  NotificationEdge: ResolverTypeWrapper<NotificationEdge>;
  NotificationsConnection: ResolverTypeWrapper<NotificationsConnection>;
  Page: ResolverTypeWrapper<Page>;
  PageAndPermission: ResolverTypeWrapper<PageAndPermission>;
  PageHistoryInput: PageHistoryInput;
  PageHistorySnapshot: ResolverTypeWrapper<PageHistorySnapshot>;
  PageIcon: ResolverTypeWrapper<PageIcon>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PageInput: PageInput;
  PageInvite: ResolverTypeWrapper<PageInvite>;
  PageInviteMeta: ResolverTypeWrapper<PageInviteMeta>;
  PageInviteMetaInput: PageInviteMetaInput;
  PageInviteNotification: ResolverTypeWrapper<PageInviteNotification>;
  PageInvitesInput: PageInvitesInput;
  PageMember: ResolverTypeWrapper<PageMember>;
  PageMembersInput: PageMembersInput;
  PagePermission: PagePermission;
  PageSettings: ResolverTypeWrapper<PageSettings>;
  PagesByUrlKeyInput: PagesByUrlKeyInput;
  Permissions: ResolverTypeWrapper<Permissions>;
  PermissionsUpdatedInput: PermissionsUpdatedInput;
  Query: ResolverTypeWrapper<{}>;
  RemoveAIPromptInput: RemoveAiPromptInput;
  RemoveMemberInput: RemoveMemberInput;
  RemoveSharedPageInput: RemoveSharedPageInput;
  RemoveUserIntegrationInput: RemoveUserIntegrationInput;
  RequestSignInLinkInput: RequestSignInLinkInput;
  RevokeInviteInput: RevokeInviteInput;
  RevokePageInviteInput: RevokePageInviteInput;
  Role: Role;
  SendNotificationInput: SendNotificationInput;
  SendTaskAssignmentNotificationInput: SendTaskAssignmentNotificationInput;
  SendTaskMentionNotificationInput: SendTaskMentionNotificationInput;
  SharePageInput: SharePageInput;
  SharedPage: ResolverTypeWrapper<SharedPage>;
  SharedPageInfo: ResolverTypeWrapper<SharedPageInfo>;
  SignupInput: SignupInput;
  Space: ResolverTypeWrapper<Space>;
  SpaceAISuggestion: ResolverTypeWrapper<SpaceAiSuggestion>;
  SpaceAccess: ResolverTypeWrapper<SpaceAccess>;
  SpaceByUrlKeyInput: SpaceByUrlKeyInput;
  SpacePermissions: ResolverTypeWrapper<SpacePermissions>;
  SpaceSubscription: ResolverTypeWrapper<SpaceSubscription>;
  SpaceSubscriptionPlan: ResolverTypeWrapper<SpaceSubscriptionPlan>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Subscription: ResolverTypeWrapper<{}>;
  SubscriptionPlan: ResolverTypeWrapper<SubscriptionPlan>;
  SubscriptionPlanPrice: ResolverTypeWrapper<SubscriptionPlanPrice>;
  SubscriptionPriceInterval: SubscriptionPriceInterval;
  SubscriptionSession: ResolverTypeWrapper<SubscriptionSession>;
  SubscriptionUpcoming: ResolverTypeWrapper<SubscriptionUpcoming>;
  SubscriptionUpcomingInput: SubscriptionUpcomingInput;
  TaskAssignAction: TaskAssignAction;
  TaskAssignmentNotification: ResolverTypeWrapper<TaskAssignmentNotification>;
  TaskMentionNotification: ResolverTypeWrapper<TaskMentionNotification>;
  Template: ResolverTypeWrapper<Template>;
  UpdateAIPromptsInput: UpdateAiPromptsInput;
  UpdateMemberRoleInput: UpdateMemberRoleInput;
  UpdatePageSharedToSpaceInput: UpdatePageSharedToSpaceInput;
  UpdateSpaceMetadataInput: UpdateSpaceMetadataInput;
  UpdateSpacePublicMetadataInput: UpdateSpacePublicMetadataInput;
  UpdateSpaceSortingInput: UpdateSpaceSortingInput;
  UpdateSpaceUseCasesInput: UpdateSpaceUseCasesInput;
  UpdateUserLanguageInput: UpdateUserLanguageInput;
  UpdateUserNameInput: UpdateUserNameInput;
  UpdateUserPagePermissionInput: UpdateUserPagePermissionInput;
  UpdateUserSettingsInput: UpdateUserSettingsInput;
  User: ResolverTypeWrapper<User>;
  UserData: ResolverTypeWrapper<UserData>;
  UserDelete: ResolverTypeWrapper<UserDelete>;
  UserDeleteStatus: UserDeleteStatus;
  UserIntegration: ResolverTypeWrapper<UserIntegration>;
  UserIntegrationType: UserIntegrationType;
  UserListSharedCount: ResolverTypeWrapper<UserListSharedCount>;
  UserMembership: ResolverTypeWrapper<UserMembership>;
  UserPagePermission: ResolverTypeWrapper<UserPagePermission>;
  UserPagePermissionsBySpaceIdInput: UserPagePermissionsBySpaceIdInput;
  UserRole: UserRole;
  UserSettings: ResolverTypeWrapper<UserSettings>;
  UserTypePagePermission: UserTypePagePermission;
  UserWithDetails: ResolverTypeWrapper<UserWithDetails>;
  WorkspaceCollaborationNotification: ResolverTypeWrapper<WorkspaceCollaborationNotification>;
  WorkspaceCollaborationNotificationType: WorkspaceCollaborationNotificationType;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AIChatMessage: AiChatMessage;
  AIChatThread: AiChatThread;
  AIEmbedding: AiEmbedding;
  AIFeaturePermission: AiFeaturePermission;
  AISugesstionInput: AiSugesstionInput;
  AcceptInvitationInput: AcceptInvitationInput;
  AcceptPageInvitationInput: AcceptPageInvitationInput;
  AddAIPromptInput: AddAiPromptInput;
  AddBlocksInput: AddBlocksInput;
  AdminSpaceList: AdminSpaceList;
  AdminSpaceListInput: AdminSpaceListInput;
  AdminUser: AdminUser;
  AdminUserDeleteInput: AdminUserDeleteInput;
  AdminUserDetailsInput: AdminUserDetailsInput;
  AdminUserList: AdminUserList;
  AdminUserListInput: AdminUserListInput;
  AdminUserListSharedCountInput: AdminUserListSharedCountInput;
  AdminUsersDeleteInput: AdminUsersDeleteInput;
  ApiToken: ApiToken;
  BillingPortalInput: BillingPortalInput;
  Boolean: Scalars['Boolean']['output'];
  Byte: Scalars['Byte']['output'];
  CancelSubscriptionInput: CancelSubscriptionInput;
  ChangeSubscriptionInput: ChangeSubscriptionInput;
  ChatThreadsInput: ChatThreadsInput;
  Collection: Collection;
  CollectionPropertiesOrderInput: CollectionPropertiesOrderInput;
  CollectionPropertyOrder: CollectionPropertyOrder;
  CollectionsByUrlKeyInput: CollectionsByUrlKeyInput;
  CopyWorkspaceInput: CopyWorkspaceInput;
  CreateApiTokenInput: CreateApiTokenInput;
  CreatePageInput: CreatePageInput;
  CreateSpaceInput: CreateSpaceInput;
  CreateSpaceSubscription: CreateSpaceSubscription;
  CreateSpaceTestInput: CreateSpaceTestInput;
  CreateSubscriptionInput: CreateSubscriptionInput;
  CreateSubscriptionSessionInput: CreateSubscriptionSessionInput;
  CustomAIPrompt: CustomAiPrompt;
  CustomToken: CustomToken;
  Date: Scalars['Date']['output'];
  DeleteAssetInput: DeleteAssetInput;
  DeleteSpaceInput: DeleteSpaceInput;
  DuplicateAssetKeyInput: DuplicateAssetKeyInput;
  DuplicatePageAssetsInput: DuplicatePageAssetsInput;
  EmbeddingSearchInput: EmbeddingSearchInput;
  ExtendedSettings: ExtendedSettings;
  ExtendedSettingsInput: ExtendedSettingsInput;
  FeaturePermission: FeaturePermission;
  FileUploadPermission: FileUploadPermission;
  Float: Scalars['Float']['output'];
  GoogleDriveFile: GoogleDriveFile;
  GoogleDriveFileInput: GoogleDriveFileInput;
  GoogleDriveOwner: GoogleDriveOwner;
  HideAIThreadInput: HideAiThreadInput;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  IntegrationSearchInput: IntegrationSearchInput;
  IntegrationSearchResult: IntegrationSearchResult;
  Invite: Invite;
  InviteMembersInput: InviteMembersInput;
  InviteMetaData: InviteMetaData;
  InviteMetaDataInput: InviteMetaDataInput;
  InvitePageMembersInput: InvitePageMembersInput;
  InvitesInput: InvitesInput;
  Invoices: Invoices;
  InvoicesInput: InvoicesInput;
  JSON: Scalars['JSON']['output'];
  LeaveSpaceInput: LeaveSpaceInput;
  LinearIssue: LinearIssue;
  LinearIssueCreateInput: LinearIssueCreateInput;
  LinearIssueDeleteInput: LinearIssueDeleteInput;
  LinearIssueInput: LinearIssueInput;
  LinearIssueState: LinearIssueState;
  LinearTeam: LinearTeam;
  LinearUser: LinearUser;
  MarkNotificationsAsReadInput: MarkNotificationsAsReadInput;
  Member: Member;
  MembersInput: MembersInput;
  MentionNotification: MentionNotification;
  Mutation: {};
  NewMemberInput: NewMemberInput;
  NewPageMemberInput: NewPageMemberInput;
  Node: ResolversInterfaceTypes<ResolversParentTypes>['Node'];
  Notification: ResolversInterfaceTypes<ResolversParentTypes>['Notification'];
  NotificationEdge: NotificationEdge;
  NotificationsConnection: NotificationsConnection;
  Page: Page;
  PageAndPermission: PageAndPermission;
  PageHistoryInput: PageHistoryInput;
  PageHistorySnapshot: PageHistorySnapshot;
  PageIcon: PageIcon;
  PageInfo: PageInfo;
  PageInput: PageInput;
  PageInvite: PageInvite;
  PageInviteMeta: PageInviteMeta;
  PageInviteMetaInput: PageInviteMetaInput;
  PageInviteNotification: PageInviteNotification;
  PageInvitesInput: PageInvitesInput;
  PageMember: PageMember;
  PageMembersInput: PageMembersInput;
  PageSettings: PageSettings;
  PagesByUrlKeyInput: PagesByUrlKeyInput;
  Permissions: Permissions;
  PermissionsUpdatedInput: PermissionsUpdatedInput;
  Query: {};
  RemoveAIPromptInput: RemoveAiPromptInput;
  RemoveMemberInput: RemoveMemberInput;
  RemoveSharedPageInput: RemoveSharedPageInput;
  RemoveUserIntegrationInput: RemoveUserIntegrationInput;
  RequestSignInLinkInput: RequestSignInLinkInput;
  RevokeInviteInput: RevokeInviteInput;
  RevokePageInviteInput: RevokePageInviteInput;
  SendNotificationInput: SendNotificationInput;
  SendTaskAssignmentNotificationInput: SendTaskAssignmentNotificationInput;
  SendTaskMentionNotificationInput: SendTaskMentionNotificationInput;
  SharePageInput: SharePageInput;
  SharedPage: SharedPage;
  SharedPageInfo: SharedPageInfo;
  SignupInput: SignupInput;
  Space: Space;
  SpaceAISuggestion: SpaceAiSuggestion;
  SpaceAccess: SpaceAccess;
  SpaceByUrlKeyInput: SpaceByUrlKeyInput;
  SpacePermissions: SpacePermissions;
  SpaceSubscription: SpaceSubscription;
  SpaceSubscriptionPlan: SpaceSubscriptionPlan;
  String: Scalars['String']['output'];
  Subscription: {};
  SubscriptionPlan: SubscriptionPlan;
  SubscriptionPlanPrice: SubscriptionPlanPrice;
  SubscriptionSession: SubscriptionSession;
  SubscriptionUpcoming: SubscriptionUpcoming;
  SubscriptionUpcomingInput: SubscriptionUpcomingInput;
  TaskAssignmentNotification: TaskAssignmentNotification;
  TaskMentionNotification: TaskMentionNotification;
  Template: Template;
  UpdateAIPromptsInput: UpdateAiPromptsInput;
  UpdateMemberRoleInput: UpdateMemberRoleInput;
  UpdatePageSharedToSpaceInput: UpdatePageSharedToSpaceInput;
  UpdateSpaceMetadataInput: UpdateSpaceMetadataInput;
  UpdateSpacePublicMetadataInput: UpdateSpacePublicMetadataInput;
  UpdateSpaceSortingInput: UpdateSpaceSortingInput;
  UpdateSpaceUseCasesInput: UpdateSpaceUseCasesInput;
  UpdateUserLanguageInput: UpdateUserLanguageInput;
  UpdateUserNameInput: UpdateUserNameInput;
  UpdateUserPagePermissionInput: UpdateUserPagePermissionInput;
  UpdateUserSettingsInput: UpdateUserSettingsInput;
  User: User;
  UserData: UserData;
  UserDelete: UserDelete;
  UserIntegration: UserIntegration;
  UserListSharedCount: UserListSharedCount;
  UserMembership: UserMembership;
  UserPagePermission: UserPagePermission;
  UserPagePermissionsBySpaceIdInput: UserPagePermissionsBySpaceIdInput;
  UserSettings: UserSettings;
  UserWithDetails: UserWithDetails;
  WorkspaceCollaborationNotification: WorkspaceCollaborationNotification;
}>;

export type AiChatMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AIChatMessage'] = ResolversParentTypes['AIChatMessage']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['AIChatRole'], ParentType, ContextType>;
  tool_call_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tool_calls?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AiChatThreadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AIChatThread'] = ResolversParentTypes['AIChatThread']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['AIChatMessage']>, ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AiEmbeddingResolvers<ContextType = any, ParentType extends ResolversParentTypes['AIEmbedding'] = ResolversParentTypes['AIEmbedding']> = ResolversObject<{
  distance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  fromBlockId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toBlockId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AiFeaturePermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AIFeaturePermission'] = ResolversParentTypes['AIFeaturePermission']> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AdminSpaceListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminSpaceList'] = ResolversParentTypes['AdminSpaceList']> = ResolversObject<{
  activeSubscription?: Resolver<Maybe<ResolversTypes['SpaceSubscription']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownerIds?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  urlKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usedSpaceTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AdminUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUser'] = ResolversParentTypes['AdminUser']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  names?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AdminUserListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdminUserList'] = ResolversParentTypes['AdminUserList']> = ResolversObject<{
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['AdminUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApiTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApiToken'] = ResolversParentTypes['ApiToken']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface ByteScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Byte'], any> {
  name: 'Byte';
}

export type CollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Collection'] = ResolversParentTypes['Collection']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CollectionPropertyOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CollectionPropertyOrder'] = ResolversParentTypes['CollectionPropertyOrder']> = ResolversObject<{
  collectionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  folderViewProperties?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  tagViewProperties?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateSpaceSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateSpaceSubscription'] = ResolversParentTypes['CreateSpaceSubscription']> = ResolversObject<{
  space?: Resolver<Maybe<ResolversTypes['Space']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomAiPromptResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomAIPrompt'] = ResolversParentTypes['CustomAIPrompt']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  prompt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CustomPromptType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CustomTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomToken'] = ResolversParentTypes['CustomToken']> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type ExtendedSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtendedSettings'] = ResolversParentTypes['ExtendedSettings']> = ResolversObject<{
  collectionPropertiesOrder?: Resolver<Maybe<Array<ResolversTypes['CollectionPropertyOrder']>>, ParentType, ContextType>;
  collectionsColumnsOrder?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  pagesColumnsOrder?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  sharedPagesColumnsOrder?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  tasksColumnsOrder?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeaturePermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeaturePermission'] = ResolversParentTypes['FeaturePermission']> = ResolversObject<{
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FileUploadPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FileUploadPermission'] = ResolversParentTypes['FileUploadPermission']> = ResolversObject<{
  limitFile?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GoogleDriveFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoogleDriveFile'] = ResolversParentTypes['GoogleDriveFile']> = ResolversObject<{
  iconLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owners?: Resolver<Maybe<Array<Maybe<ResolversTypes['GoogleDriveOwner']>>>, ParentType, ContextType>;
  thumbnailLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webViewLink?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GoogleDriveOwnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['GoogleDriveOwner'] = ResolversParentTypes['GoogleDriveOwner']> = ResolversObject<{
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IntegrationSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationSearchResult'] = ResolversParentTypes['IntegrationSearchResult']> = ResolversObject<{
  googleDriveFiles?: Resolver<Array<ResolversTypes['GoogleDriveFile']>, ParentType, ContextType>;
  linearIssues?: Resolver<Array<ResolversTypes['LinearIssue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InviteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invite'] = ResolversParentTypes['Invite']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InviteMetaDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['InviteMetaData'] = ResolversParentTypes['InviteMetaData']> = ResolversObject<{
  inviteId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  workspaceMembersCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  workspaceOwnerEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  workspaceTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvoicesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invoices'] = ResolversParentTypes['Invoices']> = ResolversObject<{
  created?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pdfUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type LinearIssueResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinearIssue'] = ResolversParentTypes['LinearIssue']> = ResolversObject<{
  assignee?: Resolver<Maybe<ResolversTypes['LinearUser']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  identifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  priority?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priorityLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['LinearIssueState']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LinearIssueStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinearIssueState'] = ResolversParentTypes['LinearIssueState']> = ResolversObject<{
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LinearTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinearTeam'] = ResolversParentTypes['LinearTeam']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LinearUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinearUser'] = ResolversParentTypes['LinearUser']> = ResolversObject<{
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['Member'] = ResolversParentTypes['Member']> = ResolversObject<{
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MentionNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MentionNotification'] = ResolversParentTypes['MentionNotification']> = ResolversObject<{
  blockId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mentionBlockUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spaceTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spaceUrlKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  acceptInvitation?: Resolver<ResolversTypes['Space'], ParentType, ContextType, RequireFields<MutationAcceptInvitationArgs, 'input'>>;
  acceptPageInvitation?: Resolver<ResolversTypes['SharedPage'], ParentType, ContextType, RequireFields<MutationAcceptPageInvitationArgs, 'input'>>;
  addAIPrompt?: Resolver<ResolversTypes['CustomAIPrompt'], ParentType, ContextType, RequireFields<MutationAddAiPromptArgs, 'input'>>;
  addBlocks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationAddBlocksArgs, 'input'>>;
  adminUserDelete?: Resolver<Array<ResolversTypes['UserDelete']>, ParentType, ContextType, RequireFields<MutationAdminUserDeleteArgs, 'input'>>;
  adminUserDetails?: Resolver<ResolversTypes['UserWithDetails'], ParentType, ContextType, RequireFields<MutationAdminUserDetailsArgs, 'input'>>;
  cancelSubscription?: Resolver<ResolversTypes['SpaceSubscription'], ParentType, ContextType, RequireFields<MutationCancelSubscriptionArgs, 'input'>>;
  changeSubscription?: Resolver<ResolversTypes['SpaceSubscription'], ParentType, ContextType, RequireFields<MutationChangeSubscriptionArgs, 'input'>>;
  copyWorkspace?: Resolver<ResolversTypes['Space'], ParentType, ContextType, RequireFields<MutationCopyWorkspaceArgs, 'input'>>;
  createApiToken?: Resolver<ResolversTypes['ApiToken'], ParentType, ContextType, RequireFields<MutationCreateApiTokenArgs, 'input'>>;
  createPage?: Resolver<ResolversTypes['Page'], ParentType, ContextType, RequireFields<MutationCreatePageArgs, 'input'>>;
  createSpace?: Resolver<ResolversTypes['Space'], ParentType, ContextType, RequireFields<MutationCreateSpaceArgs, 'input'>>;
  createSubscription?: Resolver<Maybe<ResolversTypes['CreateSpaceSubscription']>, ParentType, ContextType, RequireFields<MutationCreateSubscriptionArgs, 'input'>>;
  createSubscriptionSession?: Resolver<ResolversTypes['SubscriptionSession'], ParentType, ContextType, RequireFields<MutationCreateSubscriptionSessionArgs, 'input'>>;
  deleteAsset?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteAssetArgs, 'input'>>;
  deleteSpace?: Resolver<ResolversTypes['Space'], ParentType, ContextType, RequireFields<MutationDeleteSpaceArgs, 'input'>>;
  duplicatePageAssets?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDuplicatePageAssetsArgs, 'input'>>;
  hideAIThread?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationHideAiThreadArgs, 'input'>>;
  inviteMembers?: Resolver<Array<ResolversTypes['Invite']>, ParentType, ContextType, RequireFields<MutationInviteMembersArgs, 'input'>>;
  invitePageMembers?: Resolver<Array<ResolversTypes['PageInvite']>, ParentType, ContextType, RequireFields<MutationInvitePageMembersArgs, 'input'>>;
  leaveSpace?: Resolver<ResolversTypes['Space'], ParentType, ContextType, RequireFields<MutationLeaveSpaceArgs, 'input'>>;
  linearIssueCreate?: Resolver<ResolversTypes['LinearIssue'], ParentType, ContextType, RequireFields<MutationLinearIssueCreateArgs, 'input'>>;
  linearIssueDelete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationLinearIssueDeleteArgs, 'input'>>;
  markNotificationsAsRead?: Resolver<Array<ResolversTypes['Notification']>, ParentType, ContextType, RequireFields<MutationMarkNotificationsAsReadArgs, 'input'>>;
  removeAIPrompt?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveAiPromptArgs, 'input'>>;
  removeMember?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationRemoveMemberArgs, 'input'>>;
  removeSharedPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveSharedPageArgs, 'input'>>;
  removeUserIntegration?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveUserIntegrationArgs, 'input'>>;
  requestSignInLink?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRequestSignInLinkArgs, 'input'>>;
  revokeInvite?: Resolver<ResolversTypes['Invite'], ParentType, ContextType, RequireFields<MutationRevokeInviteArgs, 'input'>>;
  revokePageInvite?: Resolver<ResolversTypes['PageInvite'], ParentType, ContextType, RequireFields<MutationRevokePageInviteArgs, 'input'>>;
  sendNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendNotificationArgs, 'input'>>;
  sendTaskAssignmentNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendTaskAssignmentNotificationArgs, 'input'>>;
  sendTaskMentionNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendTaskMentionNotificationArgs, 'input'>>;
  sharePage?: Resolver<ResolversTypes['SharedPage'], ParentType, ContextType, RequireFields<MutationSharePageArgs, 'input'>>;
  signup?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationSignupArgs, 'input'>>;
  updateAIPrompts?: Resolver<Maybe<Array<ResolversTypes['CustomAIPrompt']>>, ParentType, ContextType, RequireFields<MutationUpdateAiPromptsArgs, 'input'>>;
  updateMemberRole?: Resolver<ResolversTypes['Member'], ParentType, ContextType, RequireFields<MutationUpdateMemberRoleArgs, 'input'>>;
  updatePageSharedToSpace?: Resolver<ResolversTypes['SharedPage'], ParentType, ContextType, RequireFields<MutationUpdatePageSharedToSpaceArgs, 'input'>>;
  updateSpaceMetadata?: Resolver<ResolversTypes['Space'], ParentType, ContextType, RequireFields<MutationUpdateSpaceMetadataArgs, 'input'>>;
  updateSpacePublicMetadata?: Resolver<ResolversTypes['Space'], ParentType, ContextType, RequireFields<MutationUpdateSpacePublicMetadataArgs, 'input'>>;
  updateSpaceSorting?: Resolver<Array<ResolversTypes['Space']>, ParentType, ContextType, RequireFields<MutationUpdateSpaceSortingArgs, 'input'>>;
  updateSpaceUseCases?: Resolver<ResolversTypes['Space'], ParentType, ContextType, RequireFields<MutationUpdateSpaceUseCasesArgs, 'input'>>;
  updateUserLanguage?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateUserLanguageArgs, 'input'>>;
  updateUserName?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateUserNameArgs, 'input'>>;
  updateUserPagePermission?: Resolver<Array<ResolversTypes['PageMember']>, ParentType, ContextType, RequireFields<MutationUpdateUserPagePermissionArgs, 'input'>>;
  updateUserSettings?: Resolver<ResolversTypes['UserSettings'], ParentType, ContextType, Partial<MutationUpdateUserSettingsArgs>>;
}>;

export type NodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node']> = ResolversObject<{
  __resolveType: TypeResolveFn<'MentionNotification' | 'PageInviteNotification' | 'TaskAssignmentNotification' | 'TaskMentionNotification' | 'Template' | 'WorkspaceCollaborationNotification', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
}>;

export type NotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = ResolversObject<{
  __resolveType: TypeResolveFn<'MentionNotification' | 'PageInviteNotification' | 'TaskAssignmentNotification' | 'TaskMentionNotification' | 'WorkspaceCollaborationNotification', ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
}>;

export type NotificationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationEdge'] = ResolversParentTypes['NotificationEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Notification'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NotificationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationsConnection'] = ResolversParentTypes['NotificationsConnection']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['NotificationEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Page'] = ResolversParentTypes['Page']> = ResolversObject<{
  aliases?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  collections?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['PageIcon']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isPublicDuplicatable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTemplate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['PageSettings'], ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  staticBlocks?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageAndPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageAndPermission'] = ResolversParentTypes['PageAndPermission']> = ResolversObject<{
  page?: Resolver<ResolversTypes['Page'], ParentType, ContextType>;
  permission?: Resolver<ResolversTypes['PagePermission'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageHistorySnapshotResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageHistorySnapshot'] = ResolversParentTypes['PageHistorySnapshot']> = ResolversObject<{
  authorEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buffer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageIconResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageIcon'] = ResolversParentTypes['PageIcon']> = ResolversObject<{
  colons?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = ResolversObject<{
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInviteResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInvite'] = ResolversParentTypes['PageInvite']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['PagePermission'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInviteMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInviteMeta'] = ResolversParentTypes['PageInviteMeta']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inviterEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['PagePermission'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInviteNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInviteNotification'] = ResolversParentTypes['PageInviteNotification']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inviteId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageMemberResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageMember'] = ResolversParentTypes['PageMember']> = ResolversObject<{
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permission?: Resolver<ResolversTypes['PagePermission'], ParentType, ContextType>;
  userEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageSettings'] = ResolversParentTypes['PageSettings']> = ResolversObject<{
  fullWidth?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PermissionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Permissions'] = ResolversParentTypes['Permissions']> = ResolversObject<{
  editors?: Resolver<ResolversTypes['FeaturePermission'], ParentType, ContextType>;
  fileUpload?: Resolver<ResolversTypes['FileUploadPermission'], ParentType, ContextType>;
  guests?: Resolver<ResolversTypes['FeaturePermission'], ParentType, ContextType>;
  sagaAi?: Resolver<ResolversTypes['AIFeaturePermission'], ParentType, ContextType>;
  tasks?: Resolver<ResolversTypes['FeaturePermission'], ParentType, ContextType>;
  viewers?: Resolver<ResolversTypes['FeaturePermission'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  adminSpaceList?: Resolver<ResolversTypes['AdminSpaceList'], ParentType, ContextType, RequireFields<QueryAdminSpaceListArgs, 'input'>>;
  adminUserList?: Resolver<ResolversTypes['AdminUserList'], ParentType, ContextType, RequireFields<QueryAdminUserListArgs, 'input'>>;
  adminUserListSharedCount?: Resolver<ResolversTypes['UserListSharedCount'], ParentType, ContextType, RequireFields<QueryAdminUserListSharedCountArgs, 'input'>>;
  allSharedPagesStatusesByUrlKey?: Resolver<Array<ResolversTypes['SharedPage']>, ParentType, ContextType, RequireFields<QueryAllSharedPagesStatusesByUrlKeyArgs, 'input'>>;
  billingPortal?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryBillingPortalArgs, 'input'>>;
  cannyToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  chatThreads?: Resolver<Array<ResolversTypes['AIChatThread']>, ParentType, ContextType, RequireFields<QueryChatThreadsArgs, 'input'>>;
  collectionsByUrlKey?: Resolver<Array<ResolversTypes['Collection']>, ParentType, ContextType, RequireFields<QueryCollectionsByUrlKeyArgs, 'input'>>;
  currentUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  getCustomToken?: Resolver<ResolversTypes['CustomToken'], ParentType, ContextType>;
  googleDriveDocument?: Resolver<ResolversTypes['GoogleDriveFile'], ParentType, ContextType, RequireFields<QueryGoogleDriveDocumentArgs, 'input'>>;
  inviteMetaData?: Resolver<Maybe<ResolversTypes['InviteMetaData']>, ParentType, ContextType, RequireFields<QueryInviteMetaDataArgs, 'input'>>;
  invites?: Resolver<Array<ResolversTypes['Invite']>, ParentType, ContextType, RequireFields<QueryInvitesArgs, 'input'>>;
  invoices?: Resolver<Array<ResolversTypes['Invoices']>, ParentType, ContextType, RequireFields<QueryInvoicesArgs, 'input'>>;
  linearIssue?: Resolver<ResolversTypes['LinearIssue'], ParentType, ContextType, RequireFields<QueryLinearIssueArgs, 'input'>>;
  linearTeams?: Resolver<Array<ResolversTypes['LinearTeam']>, ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['Member']>, ParentType, ContextType, RequireFields<QueryMembersArgs, 'input'>>;
  notificationsConnection?: Resolver<ResolversTypes['NotificationsConnection'], ParentType, ContextType, Partial<QueryNotificationsConnectionArgs>>;
  page?: Resolver<Maybe<ResolversTypes['PageAndPermission']>, ParentType, ContextType, RequireFields<QueryPageArgs, 'input'>>;
  pageHistory?: Resolver<Array<ResolversTypes['PageHistorySnapshot']>, ParentType, ContextType, RequireFields<QueryPageHistoryArgs, 'input'>>;
  pageInviteMetaData?: Resolver<Maybe<ResolversTypes['PageInviteMeta']>, ParentType, ContextType, RequireFields<QueryPageInviteMetaDataArgs, 'input'>>;
  pageInvites?: Resolver<Array<ResolversTypes['PageInvite']>, ParentType, ContextType, RequireFields<QueryPageInvitesArgs, 'input'>>;
  pageMembers?: Resolver<Array<ResolversTypes['PageMember']>, ParentType, ContextType, RequireFields<QueryPageMembersArgs, 'input'>>;
  pagesByUrlKey?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType, RequireFields<QueryPagesByUrlKeyArgs, 'input'>>;
  searchIntegrations?: Resolver<ResolversTypes['IntegrationSearchResult'], ParentType, ContextType, RequireFields<QuerySearchIntegrationsArgs, 'input'>>;
  sharedPageStatus?: Resolver<Maybe<ResolversTypes['SharedPage']>, ParentType, ContextType, RequireFields<QuerySharedPageStatusArgs, 'input'>>;
  spaceByUrlKey?: Resolver<Maybe<ResolversTypes['Space']>, ParentType, ContextType, RequireFields<QuerySpaceByUrlKeyArgs, 'input'>>;
  spaceEmbeddings?: Resolver<Array<ResolversTypes['AIEmbedding']>, ParentType, ContextType, RequireFields<QuerySpaceEmbeddingsArgs, 'input'>>;
  spacePermissions?: Resolver<ResolversTypes['SpacePermissions'], ParentType, ContextType, RequireFields<QuerySpacePermissionsArgs, 'input'>>;
  spaces?: Resolver<Array<ResolversTypes['Space']>, ParentType, ContextType>;
  subscriptionPlans?: Resolver<Array<ResolversTypes['SubscriptionPlan']>, ParentType, ContextType>;
  subscriptionUpcoming?: Resolver<Maybe<ResolversTypes['SubscriptionUpcoming']>, ParentType, ContextType, RequireFields<QuerySubscriptionUpcomingArgs, 'input'>>;
  templates?: Resolver<Array<ResolversTypes['Template']>, ParentType, ContextType>;
  unreadNotificationsCounter?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userIntegrations?: Resolver<Array<ResolversTypes['UserIntegration']>, ParentType, ContextType>;
  userInvites?: Resolver<Array<ResolversTypes['InviteMetaData']>, ParentType, ContextType>;
  userPageInvites?: Resolver<Array<ResolversTypes['PageInviteMeta']>, ParentType, ContextType>;
  userPagePermissionsBySpaceId?: Resolver<Array<ResolversTypes['UserPagePermission']>, ParentType, ContextType, RequireFields<QueryUserPagePermissionsBySpaceIdArgs, 'input'>>;
  userSettings?: Resolver<Maybe<ResolversTypes['UserSettings']>, ParentType, ContextType>;
  userSharedPages?: Resolver<Array<ResolversTypes['SharedPageInfo']>, ParentType, ContextType>;
}>;

export type SharedPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedPage'] = ResolversParentTypes['SharedPage']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isPrivateInSpace?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SharedPageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedPageInfo'] = ResolversParentTypes['SharedPageInfo']> = ResolversObject<{
  icon?: Resolver<Maybe<ResolversTypes['PageIcon']>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['SharedPage'], ParentType, ContextType>;
  permission?: Resolver<ResolversTypes['PagePermission'], ParentType, ContextType>;
  sharedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SpaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Space'] = ResolversParentTypes['Space']> = ResolversObject<{
  access?: Resolver<ResolversTypes['SpaceAccess'], ParentType, ContextType>;
  activeSubscription?: Resolver<Maybe<ResolversTypes['SpaceSubscription']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isCopyWorkspaceEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEmbeddingEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['Member']>, ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permissions?: Resolver<ResolversTypes['Permissions'], ParentType, ContextType>;
  subscriptions?: Resolver<Array<Maybe<ResolversTypes['SpaceSubscription']>>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  urlKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  useCases?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SpaceAiSuggestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpaceAISuggestion'] = ResolversParentTypes['SpaceAISuggestion']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  promptText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  promptTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  responseText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responseTokens?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SpaceAccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpaceAccess'] = ResolversParentTypes['SpaceAccess']> = ResolversObject<{
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  write?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SpacePermissionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpacePermissions'] = ResolversParentTypes['SpacePermissions']> = ResolversObject<{
  sagaAiStatus?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SpaceSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpaceSubscription'] = ResolversParentTypes['SpaceSubscription']> = ResolversObject<{
  canceled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  currentPeriodEnd?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  currentPeriodStart?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  customerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  plan?: Resolver<ResolversTypes['SpaceSubscriptionPlan'], ParentType, ContextType>;
  planId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['SubscriptionPlanPrice'], ParentType, ContextType>;
  priceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscriptionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SpaceSubscriptionPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpaceSubscriptionPlan'] = ResolversParentTypes['SpaceSubscriptionPlan']> = ResolversObject<{
  featureSet?: Resolver<ResolversTypes['FeatureSet'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = ResolversObject<{
  permissionsUpdated?: SubscriptionResolver<ResolversTypes['SpacePermissions'], "permissionsUpdated", ParentType, ContextType, RequireFields<SubscriptionPermissionsUpdatedArgs, 'input'>>;
  unreadNotificationsCounterUpdated?: SubscriptionResolver<ResolversTypes['Int'], "unreadNotificationsCounterUpdated", ParentType, ContextType>;
  userPagePermissionsBySpaceId?: SubscriptionResolver<Array<ResolversTypes['UserPagePermission']>, "userPagePermissionsBySpaceId", ParentType, ContextType, RequireFields<SubscriptionUserPagePermissionsBySpaceIdArgs, 'input'>>;
  userSharedPages?: SubscriptionResolver<Maybe<Array<ResolversTypes['SharedPageInfo']>>, "userSharedPages", ParentType, ContextType>;
}>;

export type SubscriptionPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionPlan'] = ResolversParentTypes['SubscriptionPlan']> = ResolversObject<{
  featureSet?: Resolver<ResolversTypes['FeatureSet'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<Array<ResolversTypes['SubscriptionPlanPrice']>, ParentType, ContextType>;
  stripeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionPlanPriceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionPlanPrice'] = ResolversParentTypes['SubscriptionPlanPrice']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  amountDecimal?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  interval?: Resolver<ResolversTypes['SubscriptionPriceInterval'], ParentType, ContextType>;
  lookupKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stripeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionSession'] = ResolversParentTypes['SubscriptionSession']> = ResolversObject<{
  session?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionUpcomingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionUpcoming'] = ResolversParentTypes['SubscriptionUpcoming']> = ResolversObject<{
  created?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  paid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  periodEnd?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  periodStart?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TaskAssignmentNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskAssignmentNotification'] = ResolversParentTypes['TaskAssignmentNotification']> = ResolversObject<{
  action?: Resolver<ResolversTypes['TaskAssignAction'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spaceTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spaceUrlKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TaskMentionNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskMentionNotification'] = ResolversParentTypes['TaskMentionNotification']> = ResolversObject<{
  blockId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mentionBlockUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spaceTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spaceUrlKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taskTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Template'] = ResolversParentTypes['Template']> = ResolversObject<{
  aliases?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  blocks?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  data?: Resolver<ResolversTypes['UserData'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserData'] = ResolversParentTypes['UserData']> = ResolversObject<{
  agreedToTerms?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  agreedToTermsDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  language?: Resolver<ResolversTypes['Language'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  optInTracking?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserDeleteResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDelete'] = ResolversParentTypes['UserDelete']> = ResolversObject<{
  status?: Resolver<ResolversTypes['UserDeleteStatus'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserIntegrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserIntegration'] = ResolversParentTypes['UserIntegration']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['UserIntegrationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserListSharedCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserListSharedCount'] = ResolversParentTypes['UserListSharedCount']> = ResolversObject<{
  publicPagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  publicSpacesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMembership'] = ResolversParentTypes['UserMembership']> = ResolversObject<{
  publicPages?: Resolver<Array<Maybe<ResolversTypes['SharedPage']>>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  spaceDeletable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spaceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserPagePermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPagePermission'] = ResolversParentTypes['UserPagePermission']> = ResolversObject<{
  pageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permission?: Resolver<ResolversTypes['PagePermission'], ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSettings'] = ResolversParentTypes['UserSettings']> = ResolversObject<{
  customAIPrompts?: Resolver<Array<ResolversTypes['CustomAIPrompt']>, ParentType, ContextType>;
  editorFont?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extendedSettings?: Resolver<Maybe<ResolversTypes['ExtendedSettings']>, ParentType, ContextType>;
  hiddenDefaultPrompts?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  interfaceFont?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showInlinePageLinkIcons?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  spaceSorting?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  weekStartOnMonday?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserWithDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserWithDetails'] = ResolversParentTypes['UserWithDetails']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  integrations?: Resolver<Array<ResolversTypes['UserIntegration']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  membership?: Resolver<Maybe<Array<ResolversTypes['UserMembership']>>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['UserRole'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WorkspaceCollaborationNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkspaceCollaborationNotification'] = ResolversParentTypes['WorkspaceCollaborationNotification']> = ResolversObject<{
  activeSubscription?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inviteId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spaceTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spaceUrlKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['WorkspaceCollaborationNotificationType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  AIChatMessage?: AiChatMessageResolvers<ContextType>;
  AIChatThread?: AiChatThreadResolvers<ContextType>;
  AIEmbedding?: AiEmbeddingResolvers<ContextType>;
  AIFeaturePermission?: AiFeaturePermissionResolvers<ContextType>;
  AdminSpaceList?: AdminSpaceListResolvers<ContextType>;
  AdminUser?: AdminUserResolvers<ContextType>;
  AdminUserList?: AdminUserListResolvers<ContextType>;
  ApiToken?: ApiTokenResolvers<ContextType>;
  Byte?: GraphQLScalarType;
  Collection?: CollectionResolvers<ContextType>;
  CollectionPropertyOrder?: CollectionPropertyOrderResolvers<ContextType>;
  CreateSpaceSubscription?: CreateSpaceSubscriptionResolvers<ContextType>;
  CustomAIPrompt?: CustomAiPromptResolvers<ContextType>;
  CustomToken?: CustomTokenResolvers<ContextType>;
  Date?: GraphQLScalarType;
  ExtendedSettings?: ExtendedSettingsResolvers<ContextType>;
  FeaturePermission?: FeaturePermissionResolvers<ContextType>;
  FileUploadPermission?: FileUploadPermissionResolvers<ContextType>;
  GoogleDriveFile?: GoogleDriveFileResolvers<ContextType>;
  GoogleDriveOwner?: GoogleDriveOwnerResolvers<ContextType>;
  IntegrationSearchResult?: IntegrationSearchResultResolvers<ContextType>;
  Invite?: InviteResolvers<ContextType>;
  InviteMetaData?: InviteMetaDataResolvers<ContextType>;
  Invoices?: InvoicesResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  LinearIssue?: LinearIssueResolvers<ContextType>;
  LinearIssueState?: LinearIssueStateResolvers<ContextType>;
  LinearTeam?: LinearTeamResolvers<ContextType>;
  LinearUser?: LinearUserResolvers<ContextType>;
  Member?: MemberResolvers<ContextType>;
  MentionNotification?: MentionNotificationResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Node?: NodeResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  NotificationEdge?: NotificationEdgeResolvers<ContextType>;
  NotificationsConnection?: NotificationsConnectionResolvers<ContextType>;
  Page?: PageResolvers<ContextType>;
  PageAndPermission?: PageAndPermissionResolvers<ContextType>;
  PageHistorySnapshot?: PageHistorySnapshotResolvers<ContextType>;
  PageIcon?: PageIconResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PageInvite?: PageInviteResolvers<ContextType>;
  PageInviteMeta?: PageInviteMetaResolvers<ContextType>;
  PageInviteNotification?: PageInviteNotificationResolvers<ContextType>;
  PageMember?: PageMemberResolvers<ContextType>;
  PageSettings?: PageSettingsResolvers<ContextType>;
  Permissions?: PermissionsResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  SharedPage?: SharedPageResolvers<ContextType>;
  SharedPageInfo?: SharedPageInfoResolvers<ContextType>;
  Space?: SpaceResolvers<ContextType>;
  SpaceAISuggestion?: SpaceAiSuggestionResolvers<ContextType>;
  SpaceAccess?: SpaceAccessResolvers<ContextType>;
  SpacePermissions?: SpacePermissionsResolvers<ContextType>;
  SpaceSubscription?: SpaceSubscriptionResolvers<ContextType>;
  SpaceSubscriptionPlan?: SpaceSubscriptionPlanResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SubscriptionPlan?: SubscriptionPlanResolvers<ContextType>;
  SubscriptionPlanPrice?: SubscriptionPlanPriceResolvers<ContextType>;
  SubscriptionSession?: SubscriptionSessionResolvers<ContextType>;
  SubscriptionUpcoming?: SubscriptionUpcomingResolvers<ContextType>;
  TaskAssignmentNotification?: TaskAssignmentNotificationResolvers<ContextType>;
  TaskMentionNotification?: TaskMentionNotificationResolvers<ContextType>;
  Template?: TemplateResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserData?: UserDataResolvers<ContextType>;
  UserDelete?: UserDeleteResolvers<ContextType>;
  UserIntegration?: UserIntegrationResolvers<ContextType>;
  UserListSharedCount?: UserListSharedCountResolvers<ContextType>;
  UserMembership?: UserMembershipResolvers<ContextType>;
  UserPagePermission?: UserPagePermissionResolvers<ContextType>;
  UserSettings?: UserSettingsResolvers<ContextType>;
  UserWithDetails?: UserWithDetailsResolvers<ContextType>;
  WorkspaceCollaborationNotification?: WorkspaceCollaborationNotificationResolvers<ContextType>;
}>;


export const SubscriptionFragmentFragmentDoc = gql`
    fragment SubscriptionFragment on SpaceSubscription {
  id
  subscriptionId
  status
  canceled
  spaceId
  customerId
  currentPeriodEnd
  currentPeriodStart
  planId
  priceId
  plan {
    id
    featureSet
  }
  price {
    id
    amount
    amountDecimal
    currency
    stripeId
    lookupKey
    interval
    status
  }
}
    `;
export const SpaceFragmentFragmentDoc = gql`
    fragment SpaceFragment on Space {
  id
  title
  urlKey
  createdAt
  isPublic
  isCopyWorkspaceEnabled
  isEmbeddingEnabled
  color
  owner
  useCases
  activeSubscription {
    ...SubscriptionFragment
  }
  subscriptions {
    ...SubscriptionFragment
  }
  access {
    write
  }
  permissions {
    editors {
      enabled
      limit
    }
    guests {
      limit
    }
    tasks {
      enabled
    }
    viewers {
      enabled
    }
    fileUpload {
      limitFile
    }
    sagaAi {
      enabled
      limit
      model
    }
  }
}
    ${SubscriptionFragmentFragmentDoc}`;
export const MemberFragmentFragmentDoc = gql`
    fragment MemberFragment on Member {
  id
  spaceId
  firstName
  lastName
  userEmail
  role
}
    `;
export const SpaceWithMembersFragmentDoc = gql`
    fragment SpaceWithMembers on Space {
  ...SpaceFragment
  members {
    ...MemberFragment
  }
}
    ${SpaceFragmentFragmentDoc}
${MemberFragmentFragmentDoc}`;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  id
  data {
    email
    firstName
    lastName
    agreedToTerms
    agreedToTermsDate
    optInTracking
    language
    role
  }
  createdAt
  updatedAt
}
    `;
export const CustomAiPromptsFragmentDoc = gql`
    fragment CustomAIPrompts on CustomAIPrompt {
  id
  title
  prompt
  position
  type
}
    `;
export const ExtendedSettingsFragmentDoc = gql`
    fragment ExtendedSettings on ExtendedSettings {
  pagesColumnsOrder
  sharedPagesColumnsOrder
  tasksColumnsOrder
  collectionsColumnsOrder
  collectionPropertiesOrder {
    collectionId
    tagViewProperties
    folderViewProperties
  }
}
    `;
export const UserSettingsFragmentDoc = gql`
    fragment UserSettings on UserSettings {
  spaceSorting
  showInlinePageLinkIcons
  weekStartOnMonday
  customAIPrompts {
    ...CustomAIPrompts
  }
  hiddenDefaultPrompts
  interfaceFont
  editorFont
  extendedSettings {
    ...ExtendedSettings
  }
}
    ${CustomAiPromptsFragmentDoc}
${ExtendedSettingsFragmentDoc}`;
export const PublicMemberFragmentDoc = gql`
    fragment PublicMember on Member {
  id
  spaceId
  firstName
  lastName
}
    `;
export const InviteFragmentFragmentDoc = gql`
    fragment InviteFragment on Invite {
  id
  userEmail
  role
}
    `;
export const InviteMetaDataFragmentFragmentDoc = gql`
    fragment InviteMetaDataFragment on InviteMetaData {
  inviteId
  workspaceTitle
  workspaceOwnerEmail
  workspaceMembersCount
  userEmail
}
    `;
export const PageInviteMetaFragmentFragmentDoc = gql`
    fragment PageInviteMetaFragment on PageInviteMeta {
  id
  userEmail
  inviterEmail
  title
  role
}
    `;
export const PageInviteFragmentFragmentDoc = gql`
    fragment PageInviteFragment on PageInvite {
  id
  userEmail
  role
}
    `;
export const PageIconFragmentFragmentDoc = gql`
    fragment PageIconFragment on PageIcon {
  type
  colons
}
    `;
export const PageFragmentFragmentDoc = gql`
    fragment PageFragment on Page {
  id
  title
  icon {
    ...PageIconFragment
  }
  collections
  aliases
  archivedAt
  isTemplate
  isPublicDuplicatable
  settings {
    fullWidth
  }
  spaceId
  staticBlocks
}
    ${PageIconFragmentFragmentDoc}`;
export const PageAndPermissionFragmentFragmentDoc = gql`
    fragment PageAndPermissionFragment on PageAndPermission {
  page {
    ...PageFragment
  }
  permission
}
    ${PageFragmentFragmentDoc}`;
export const SharedPageFragmentFragmentDoc = gql`
    fragment SharedPageFragment on SharedPage {
  id
  spaceId
  isPrivateInSpace
  isPublic
  createdAt
  updatedAt
}
    `;
export const SharedPageInfoFragmentFragmentDoc = gql`
    fragment SharedPageInfoFragment on SharedPageInfo {
  page {
    ...SharedPageFragment
  }
  title
  icon {
    ...PageIconFragment
  }
  permission
  sharedBy
}
    ${SharedPageFragmentFragmentDoc}
${PageIconFragmentFragmentDoc}`;
export const AiChatMessageFragmentFragmentDoc = gql`
    fragment AIChatMessageFragment on AIChatMessage {
  content
  role
  tool_calls
  tool_call_id
  createdAt
}
    `;
export const AiChatThreadFragmentFragmentDoc = gql`
    fragment AIChatThreadFragment on AIChatThread {
  id
  spaceId
  userId
  messages {
    ...AIChatMessageFragment
  }
}
    ${AiChatMessageFragmentFragmentDoc}`;
export const CollectionFragmentFragmentDoc = gql`
    fragment CollectionFragment on Collection {
  id
  title
  updatedAt
}
    `;
export const GoogleDriveFileFragmentDoc = gql`
    fragment GoogleDriveFile on GoogleDriveFile {
  id
  name
  webViewLink
  iconLink
  thumbnailLink
  modifiedTime
  mimeType
  owners {
    displayName
  }
}
    `;
export const LinearIssueFragmentDoc = gql`
    fragment LinearIssue on LinearIssue {
  id
  identifier
  title
  url
  description
  updatedAt
  priorityLabel
  priority
  state {
    name
    color
    type
  }
  assignee {
    name
  }
}
    `;
export const LinearTeamFragmentDoc = gql`
    fragment LinearTeam on LinearTeam {
  id
  name
}
    `;
export const MentionNotificationFragmentDoc = gql`
    fragment MentionNotification on MentionNotification {
  id
  spaceTitle
  spaceColor
  pageTitle
  pageId
  blockId
  spaceId
  spaceUrlKey
  userId
  readAt
  createdAt
  username
  mentionBlockUrl
}
    `;
export const TaskMentionNotificationFragmentDoc = gql`
    fragment TaskMentionNotification on TaskMentionNotification {
  id
  spaceTitle
  spaceColor
  taskTitle
  taskId
  blockId
  spaceId
  spaceUrlKey
  userId
  readAt
  createdAt
  username
  mentionBlockUrl
}
    `;
export const TaskAssignmentNotificationFragmentDoc = gql`
    fragment TaskAssignmentNotification on TaskAssignmentNotification {
  id
  spaceTitle
  spaceColor
  taskId
  taskTitle
  taskUrl
  action
  spaceId
  spaceUrlKey
  userId
  readAt
  createdAt
  username
}
    `;
export const PageInviteNotificationFragmentDoc = gql`
    fragment PageInviteNotification on PageInviteNotification {
  id
  spaceTitle
  spaceColor
  pageTitle
  pageId
  readAt
  createdAt
  username
  userId
  inviteId
}
    `;
export const WorkspaceCollaborationNotificationFragmentDoc = gql`
    fragment WorkspaceCollaborationNotification on WorkspaceCollaborationNotification {
  id
  spaceTitle
  spaceColor
  readAt
  createdAt
  spaceId
  spaceUrlKey
  username
  userId
  type
  inviteId
  activeSubscription
}
    `;
export const FullPageInfoFragmentDoc = gql`
    fragment FullPageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const TemplateFragmentDoc = gql`
    fragment Template on Template {
  id
  title
  icon
  blocks
  aliases
}
    `;
export const AiEmbeddingFragmentDoc = gql`
    fragment AIEmbedding on AIEmbedding {
  pageId
  fromBlockId
  toBlockId
  distance
}
    `;
export const UserPagePermissionFragmentFragmentDoc = gql`
    fragment UserPagePermissionFragment on UserPagePermission {
  userId
  pageId
  spaceId
  permission
}
    `;
export const PageMemberFragmentFragmentDoc = gql`
    fragment PageMemberFragment on PageMember {
  firstName
  lastName
  userEmail
  userId
  pageId
  permission
}
    `;
export const PageHistorySnapshotFragmentDoc = gql`
    fragment PageHistorySnapshot on PageHistorySnapshot {
  updatedAt
  buffer
  authorEmail
}
    `;
export const NotificationsConnectionDocument = gql`
    query NotificationsConnection($first: Int, $last: Int, $after: String, $before: String) {
  notificationsConnection(
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      ...FullPageInfo
    }
    edges {
      cursor
      node {
        __typename
        id
        createdAt
        spaceTitle
        spaceColor
        readAt
        ... on TaskMentionNotification {
          ...TaskMentionNotification
        }
        ... on TaskAssignmentNotification {
          ...TaskAssignmentNotification
        }
        ... on MentionNotification {
          ...MentionNotification
        }
        ... on PageInviteNotification {
          ...PageInviteNotification
        }
        ... on WorkspaceCollaborationNotification {
          ...WorkspaceCollaborationNotification
        }
      }
    }
  }
}
    ${FullPageInfoFragmentDoc}
${TaskMentionNotificationFragmentDoc}
${TaskAssignmentNotificationFragmentDoc}
${MentionNotificationFragmentDoc}
${PageInviteNotificationFragmentDoc}
${WorkspaceCollaborationNotificationFragmentDoc}`;

/**
 * __useNotificationsConnectionQuery__
 *
 * To run a query within a React component, call `useNotificationsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsConnectionQuery({
 *   variables: {
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useNotificationsConnectionQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsConnectionQuery, NotificationsConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsConnectionQuery, NotificationsConnectionQueryVariables>(NotificationsConnectionDocument, options);
      }
export function useNotificationsConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsConnectionQuery, NotificationsConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsConnectionQuery, NotificationsConnectionQueryVariables>(NotificationsConnectionDocument, options);
        }
export function useNotificationsConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationsConnectionQuery, NotificationsConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsConnectionQuery, NotificationsConnectionQueryVariables>(NotificationsConnectionDocument, options);
        }
export type NotificationsConnectionQueryHookResult = ReturnType<typeof useNotificationsConnectionQuery>;
export type NotificationsConnectionLazyQueryHookResult = ReturnType<typeof useNotificationsConnectionLazyQuery>;
export type NotificationsConnectionSuspenseQueryHookResult = ReturnType<typeof useNotificationsConnectionSuspenseQuery>;
export type NotificationsConnectionQueryResult = Apollo.QueryResult<NotificationsConnectionQuery, NotificationsConnectionQueryVariables>;
export const SpacesDocument = gql`
    query Spaces {
  spaces {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;

/**
 * __useSpacesQuery__
 *
 * To run a query within a React component, call `useSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpacesQuery(baseOptions?: Apollo.QueryHookOptions<SpacesQuery, SpacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpacesQuery, SpacesQueryVariables>(SpacesDocument, options);
      }
export function useSpacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpacesQuery, SpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpacesQuery, SpacesQueryVariables>(SpacesDocument, options);
        }
export function useSpacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SpacesQuery, SpacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpacesQuery, SpacesQueryVariables>(SpacesDocument, options);
        }
export type SpacesQueryHookResult = ReturnType<typeof useSpacesQuery>;
export type SpacesLazyQueryHookResult = ReturnType<typeof useSpacesLazyQuery>;
export type SpacesSuspenseQueryHookResult = ReturnType<typeof useSpacesSuspenseQuery>;
export type SpacesQueryResult = Apollo.QueryResult<SpacesQuery, SpacesQueryVariables>;
export const UserDocument = gql`
    query User {
  currentUser {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserDataDocument = gql`
    query UserData {
  currentUser {
    ...UserFragment
  }
  getCustomToken {
    token
  }
  cannyToken
  spaces {
    ...SpaceWithMembers
  }
  userSettings {
    ...UserSettings
  }
}
    ${UserFragmentFragmentDoc}
${SpaceWithMembersFragmentDoc}
${UserSettingsFragmentDoc}`;

/**
 * __useUserDataQuery__
 *
 * To run a query within a React component, call `useUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDataQuery(baseOptions?: Apollo.QueryHookOptions<UserDataQuery, UserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDataQuery, UserDataQueryVariables>(UserDataDocument, options);
      }
export function useUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDataQuery, UserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDataQuery, UserDataQueryVariables>(UserDataDocument, options);
        }
export function useUserDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserDataQuery, UserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDataQuery, UserDataQueryVariables>(UserDataDocument, options);
        }
export type UserDataQueryHookResult = ReturnType<typeof useUserDataQuery>;
export type UserDataLazyQueryHookResult = ReturnType<typeof useUserDataLazyQuery>;
export type UserDataSuspenseQueryHookResult = ReturnType<typeof useUserDataSuspenseQuery>;
export type UserDataQueryResult = Apollo.QueryResult<UserDataQuery, UserDataQueryVariables>;
export const UserInvitesDocument = gql`
    query UserInvites {
  userInvites {
    ...InviteMetaDataFragment
  }
}
    ${InviteMetaDataFragmentFragmentDoc}`;

/**
 * __useUserInvitesQuery__
 *
 * To run a query within a React component, call `useUserInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInvitesQuery(baseOptions?: Apollo.QueryHookOptions<UserInvitesQuery, UserInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInvitesQuery, UserInvitesQueryVariables>(UserInvitesDocument, options);
      }
export function useUserInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInvitesQuery, UserInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInvitesQuery, UserInvitesQueryVariables>(UserInvitesDocument, options);
        }
export function useUserInvitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserInvitesQuery, UserInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserInvitesQuery, UserInvitesQueryVariables>(UserInvitesDocument, options);
        }
export type UserInvitesQueryHookResult = ReturnType<typeof useUserInvitesQuery>;
export type UserInvitesLazyQueryHookResult = ReturnType<typeof useUserInvitesLazyQuery>;
export type UserInvitesSuspenseQueryHookResult = ReturnType<typeof useUserInvitesSuspenseQuery>;
export type UserInvitesQueryResult = Apollo.QueryResult<UserInvitesQuery, UserInvitesQueryVariables>;
export const SpaceByUrlKeyDocument = gql`
    query SpaceByUrlKey($input: SpaceByUrlKeyInput!) {
  spaceByUrlKey(input: $input) {
    ...SpaceWithMembers
  }
}
    ${SpaceWithMembersFragmentDoc}`;

/**
 * __useSpaceByUrlKeyQuery__
 *
 * To run a query within a React component, call `useSpaceByUrlKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceByUrlKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceByUrlKeyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSpaceByUrlKeyQuery(baseOptions: Apollo.QueryHookOptions<SpaceByUrlKeyQuery, SpaceByUrlKeyQueryVariables> & ({ variables: SpaceByUrlKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpaceByUrlKeyQuery, SpaceByUrlKeyQueryVariables>(SpaceByUrlKeyDocument, options);
      }
export function useSpaceByUrlKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpaceByUrlKeyQuery, SpaceByUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpaceByUrlKeyQuery, SpaceByUrlKeyQueryVariables>(SpaceByUrlKeyDocument, options);
        }
export function useSpaceByUrlKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SpaceByUrlKeyQuery, SpaceByUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpaceByUrlKeyQuery, SpaceByUrlKeyQueryVariables>(SpaceByUrlKeyDocument, options);
        }
export type SpaceByUrlKeyQueryHookResult = ReturnType<typeof useSpaceByUrlKeyQuery>;
export type SpaceByUrlKeyLazyQueryHookResult = ReturnType<typeof useSpaceByUrlKeyLazyQuery>;
export type SpaceByUrlKeySuspenseQueryHookResult = ReturnType<typeof useSpaceByUrlKeySuspenseQuery>;
export type SpaceByUrlKeyQueryResult = Apollo.QueryResult<SpaceByUrlKeyQuery, SpaceByUrlKeyQueryVariables>;
export const InvitesAndMembersDocument = gql`
    query InvitesAndMembers($urlKey: String!) {
  members(input: {urlKey: $urlKey}) {
    ...MemberFragment
  }
  invites(input: {urlKey: $urlKey}) {
    ...InviteFragment
  }
}
    ${MemberFragmentFragmentDoc}
${InviteFragmentFragmentDoc}`;

/**
 * __useInvitesAndMembersQuery__
 *
 * To run a query within a React component, call `useInvitesAndMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesAndMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesAndMembersQuery({
 *   variables: {
 *      urlKey: // value for 'urlKey'
 *   },
 * });
 */
export function useInvitesAndMembersQuery(baseOptions: Apollo.QueryHookOptions<InvitesAndMembersQuery, InvitesAndMembersQueryVariables> & ({ variables: InvitesAndMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitesAndMembersQuery, InvitesAndMembersQueryVariables>(InvitesAndMembersDocument, options);
      }
export function useInvitesAndMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitesAndMembersQuery, InvitesAndMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitesAndMembersQuery, InvitesAndMembersQueryVariables>(InvitesAndMembersDocument, options);
        }
export function useInvitesAndMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvitesAndMembersQuery, InvitesAndMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvitesAndMembersQuery, InvitesAndMembersQueryVariables>(InvitesAndMembersDocument, options);
        }
export type InvitesAndMembersQueryHookResult = ReturnType<typeof useInvitesAndMembersQuery>;
export type InvitesAndMembersLazyQueryHookResult = ReturnType<typeof useInvitesAndMembersLazyQuery>;
export type InvitesAndMembersSuspenseQueryHookResult = ReturnType<typeof useInvitesAndMembersSuspenseQuery>;
export type InvitesAndMembersQueryResult = Apollo.QueryResult<InvitesAndMembersQuery, InvitesAndMembersQueryVariables>;
export const MembersDocument = gql`
    query Members($input: MembersInput!) {
  members(input: $input) {
    ...PublicMember
  }
}
    ${PublicMemberFragmentDoc}`;

/**
 * __useMembersQuery__
 *
 * To run a query within a React component, call `useMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMembersQuery(baseOptions: Apollo.QueryHookOptions<MembersQuery, MembersQueryVariables> & ({ variables: MembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembersQuery, MembersQueryVariables>(MembersDocument, options);
      }
export function useMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembersQuery, MembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembersQuery, MembersQueryVariables>(MembersDocument, options);
        }
export function useMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MembersQuery, MembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MembersQuery, MembersQueryVariables>(MembersDocument, options);
        }
export type MembersQueryHookResult = ReturnType<typeof useMembersQuery>;
export type MembersLazyQueryHookResult = ReturnType<typeof useMembersLazyQuery>;
export type MembersSuspenseQueryHookResult = ReturnType<typeof useMembersSuspenseQuery>;
export type MembersQueryResult = Apollo.QueryResult<MembersQuery, MembersQueryVariables>;
export const InviteMetaDataDocument = gql`
    query InviteMetaData($input: InviteMetaDataInput!) {
  inviteMetaData(input: $input) {
    ...InviteMetaDataFragment
  }
}
    ${InviteMetaDataFragmentFragmentDoc}`;

/**
 * __useInviteMetaDataQuery__
 *
 * To run a query within a React component, call `useInviteMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteMetaDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteMetaDataQuery(baseOptions: Apollo.QueryHookOptions<InviteMetaDataQuery, InviteMetaDataQueryVariables> & ({ variables: InviteMetaDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteMetaDataQuery, InviteMetaDataQueryVariables>(InviteMetaDataDocument, options);
      }
export function useInviteMetaDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteMetaDataQuery, InviteMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteMetaDataQuery, InviteMetaDataQueryVariables>(InviteMetaDataDocument, options);
        }
export function useInviteMetaDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InviteMetaDataQuery, InviteMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InviteMetaDataQuery, InviteMetaDataQueryVariables>(InviteMetaDataDocument, options);
        }
export type InviteMetaDataQueryHookResult = ReturnType<typeof useInviteMetaDataQuery>;
export type InviteMetaDataLazyQueryHookResult = ReturnType<typeof useInviteMetaDataLazyQuery>;
export type InviteMetaDataSuspenseQueryHookResult = ReturnType<typeof useInviteMetaDataSuspenseQuery>;
export type InviteMetaDataQueryResult = Apollo.QueryResult<InviteMetaDataQuery, InviteMetaDataQueryVariables>;
export const PageDocument = gql`
    query Page($input: PageInput!) {
  page(input: $input) {
    ...PageAndPermissionFragment
  }
}
    ${PageAndPermissionFragmentFragmentDoc}`;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables> & ({ variables: PageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export function usePageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageSuspenseQueryHookResult = ReturnType<typeof usePageSuspenseQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const SharedPageStatusDocument = gql`
    query SharedPageStatus($input: PageInput!) {
  sharedPageStatus(input: $input) {
    ...SharedPageFragment
  }
}
    ${SharedPageFragmentFragmentDoc}`;

/**
 * __useSharedPageStatusQuery__
 *
 * To run a query within a React component, call `useSharedPageStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedPageStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedPageStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSharedPageStatusQuery(baseOptions: Apollo.QueryHookOptions<SharedPageStatusQuery, SharedPageStatusQueryVariables> & ({ variables: SharedPageStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedPageStatusQuery, SharedPageStatusQueryVariables>(SharedPageStatusDocument, options);
      }
export function useSharedPageStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedPageStatusQuery, SharedPageStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedPageStatusQuery, SharedPageStatusQueryVariables>(SharedPageStatusDocument, options);
        }
export function useSharedPageStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SharedPageStatusQuery, SharedPageStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SharedPageStatusQuery, SharedPageStatusQueryVariables>(SharedPageStatusDocument, options);
        }
export type SharedPageStatusQueryHookResult = ReturnType<typeof useSharedPageStatusQuery>;
export type SharedPageStatusLazyQueryHookResult = ReturnType<typeof useSharedPageStatusLazyQuery>;
export type SharedPageStatusSuspenseQueryHookResult = ReturnType<typeof useSharedPageStatusSuspenseQuery>;
export type SharedPageStatusQueryResult = Apollo.QueryResult<SharedPageStatusQuery, SharedPageStatusQueryVariables>;
export const AllSharedPagesStatusesByUrlKeyDocument = gql`
    query AllSharedPagesStatusesByUrlKey($input: PagesByUrlKeyInput!) {
  allSharedPagesStatusesByUrlKey(input: $input) {
    ...SharedPageFragment
  }
}
    ${SharedPageFragmentFragmentDoc}`;

/**
 * __useAllSharedPagesStatusesByUrlKeyQuery__
 *
 * To run a query within a React component, call `useAllSharedPagesStatusesByUrlKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSharedPagesStatusesByUrlKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSharedPagesStatusesByUrlKeyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllSharedPagesStatusesByUrlKeyQuery(baseOptions: Apollo.QueryHookOptions<AllSharedPagesStatusesByUrlKeyQuery, AllSharedPagesStatusesByUrlKeyQueryVariables> & ({ variables: AllSharedPagesStatusesByUrlKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSharedPagesStatusesByUrlKeyQuery, AllSharedPagesStatusesByUrlKeyQueryVariables>(AllSharedPagesStatusesByUrlKeyDocument, options);
      }
export function useAllSharedPagesStatusesByUrlKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSharedPagesStatusesByUrlKeyQuery, AllSharedPagesStatusesByUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSharedPagesStatusesByUrlKeyQuery, AllSharedPagesStatusesByUrlKeyQueryVariables>(AllSharedPagesStatusesByUrlKeyDocument, options);
        }
export function useAllSharedPagesStatusesByUrlKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllSharedPagesStatusesByUrlKeyQuery, AllSharedPagesStatusesByUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSharedPagesStatusesByUrlKeyQuery, AllSharedPagesStatusesByUrlKeyQueryVariables>(AllSharedPagesStatusesByUrlKeyDocument, options);
        }
export type AllSharedPagesStatusesByUrlKeyQueryHookResult = ReturnType<typeof useAllSharedPagesStatusesByUrlKeyQuery>;
export type AllSharedPagesStatusesByUrlKeyLazyQueryHookResult = ReturnType<typeof useAllSharedPagesStatusesByUrlKeyLazyQuery>;
export type AllSharedPagesStatusesByUrlKeySuspenseQueryHookResult = ReturnType<typeof useAllSharedPagesStatusesByUrlKeySuspenseQuery>;
export type AllSharedPagesStatusesByUrlKeyQueryResult = Apollo.QueryResult<AllSharedPagesStatusesByUrlKeyQuery, AllSharedPagesStatusesByUrlKeyQueryVariables>;
export const PagesByUrlKeyDocument = gql`
    query PagesByUrlKey($input: PagesByUrlKeyInput!) {
  pagesByUrlKey(input: $input) {
    ...PageFragment
  }
}
    ${PageFragmentFragmentDoc}`;

/**
 * __usePagesByUrlKeyQuery__
 *
 * To run a query within a React component, call `usePagesByUrlKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesByUrlKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesByUrlKeyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePagesByUrlKeyQuery(baseOptions: Apollo.QueryHookOptions<PagesByUrlKeyQuery, PagesByUrlKeyQueryVariables> & ({ variables: PagesByUrlKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesByUrlKeyQuery, PagesByUrlKeyQueryVariables>(PagesByUrlKeyDocument, options);
      }
export function usePagesByUrlKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesByUrlKeyQuery, PagesByUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesByUrlKeyQuery, PagesByUrlKeyQueryVariables>(PagesByUrlKeyDocument, options);
        }
export function usePagesByUrlKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PagesByUrlKeyQuery, PagesByUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesByUrlKeyQuery, PagesByUrlKeyQueryVariables>(PagesByUrlKeyDocument, options);
        }
export type PagesByUrlKeyQueryHookResult = ReturnType<typeof usePagesByUrlKeyQuery>;
export type PagesByUrlKeyLazyQueryHookResult = ReturnType<typeof usePagesByUrlKeyLazyQuery>;
export type PagesByUrlKeySuspenseQueryHookResult = ReturnType<typeof usePagesByUrlKeySuspenseQuery>;
export type PagesByUrlKeyQueryResult = Apollo.QueryResult<PagesByUrlKeyQuery, PagesByUrlKeyQueryVariables>;
export const CollectionsByUrlKeyDocument = gql`
    query CollectionsByUrlKey($input: CollectionsByUrlKeyInput!) {
  collectionsByUrlKey(input: $input) {
    ...CollectionFragment
  }
}
    ${CollectionFragmentFragmentDoc}`;

/**
 * __useCollectionsByUrlKeyQuery__
 *
 * To run a query within a React component, call `useCollectionsByUrlKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsByUrlKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsByUrlKeyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectionsByUrlKeyQuery(baseOptions: Apollo.QueryHookOptions<CollectionsByUrlKeyQuery, CollectionsByUrlKeyQueryVariables> & ({ variables: CollectionsByUrlKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionsByUrlKeyQuery, CollectionsByUrlKeyQueryVariables>(CollectionsByUrlKeyDocument, options);
      }
export function useCollectionsByUrlKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionsByUrlKeyQuery, CollectionsByUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionsByUrlKeyQuery, CollectionsByUrlKeyQueryVariables>(CollectionsByUrlKeyDocument, options);
        }
export function useCollectionsByUrlKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CollectionsByUrlKeyQuery, CollectionsByUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollectionsByUrlKeyQuery, CollectionsByUrlKeyQueryVariables>(CollectionsByUrlKeyDocument, options);
        }
export type CollectionsByUrlKeyQueryHookResult = ReturnType<typeof useCollectionsByUrlKeyQuery>;
export type CollectionsByUrlKeyLazyQueryHookResult = ReturnType<typeof useCollectionsByUrlKeyLazyQuery>;
export type CollectionsByUrlKeySuspenseQueryHookResult = ReturnType<typeof useCollectionsByUrlKeySuspenseQuery>;
export type CollectionsByUrlKeyQueryResult = Apollo.QueryResult<CollectionsByUrlKeyQuery, CollectionsByUrlKeyQueryVariables>;
export const GetCustomTokenDocument = gql`
    query GetCustomToken {
  getCustomToken {
    token
  }
}
    `;

/**
 * __useGetCustomTokenQuery__
 *
 * To run a query within a React component, call `useGetCustomTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomTokenQuery, GetCustomTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomTokenQuery, GetCustomTokenQueryVariables>(GetCustomTokenDocument, options);
      }
export function useGetCustomTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomTokenQuery, GetCustomTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomTokenQuery, GetCustomTokenQueryVariables>(GetCustomTokenDocument, options);
        }
export function useGetCustomTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomTokenQuery, GetCustomTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomTokenQuery, GetCustomTokenQueryVariables>(GetCustomTokenDocument, options);
        }
export type GetCustomTokenQueryHookResult = ReturnType<typeof useGetCustomTokenQuery>;
export type GetCustomTokenLazyQueryHookResult = ReturnType<typeof useGetCustomTokenLazyQuery>;
export type GetCustomTokenSuspenseQueryHookResult = ReturnType<typeof useGetCustomTokenSuspenseQuery>;
export type GetCustomTokenQueryResult = Apollo.QueryResult<GetCustomTokenQuery, GetCustomTokenQueryVariables>;
export const SearchIntegrationsDocument = gql`
    query SearchIntegrations($input: IntegrationSearchInput!) {
  searchIntegrations(input: $input) {
    googleDriveFiles {
      ...GoogleDriveFile
    }
    linearIssues {
      ...LinearIssue
    }
  }
}
    ${GoogleDriveFileFragmentDoc}
${LinearIssueFragmentDoc}`;

/**
 * __useSearchIntegrationsQuery__
 *
 * To run a query within a React component, call `useSearchIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIntegrationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<SearchIntegrationsQuery, SearchIntegrationsQueryVariables> & ({ variables: SearchIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchIntegrationsQuery, SearchIntegrationsQueryVariables>(SearchIntegrationsDocument, options);
      }
export function useSearchIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchIntegrationsQuery, SearchIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchIntegrationsQuery, SearchIntegrationsQueryVariables>(SearchIntegrationsDocument, options);
        }
export function useSearchIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchIntegrationsQuery, SearchIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchIntegrationsQuery, SearchIntegrationsQueryVariables>(SearchIntegrationsDocument, options);
        }
export type SearchIntegrationsQueryHookResult = ReturnType<typeof useSearchIntegrationsQuery>;
export type SearchIntegrationsLazyQueryHookResult = ReturnType<typeof useSearchIntegrationsLazyQuery>;
export type SearchIntegrationsSuspenseQueryHookResult = ReturnType<typeof useSearchIntegrationsSuspenseQuery>;
export type SearchIntegrationsQueryResult = Apollo.QueryResult<SearchIntegrationsQuery, SearchIntegrationsQueryVariables>;
export const LinearIssueDocument = gql`
    query LinearIssue($input: LinearIssueInput!) {
  linearIssue(input: $input) {
    ...LinearIssue
  }
}
    ${LinearIssueFragmentDoc}`;

/**
 * __useLinearIssueQuery__
 *
 * To run a query within a React component, call `useLinearIssueQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinearIssueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinearIssueQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinearIssueQuery(baseOptions: Apollo.QueryHookOptions<LinearIssueQuery, LinearIssueQueryVariables> & ({ variables: LinearIssueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinearIssueQuery, LinearIssueQueryVariables>(LinearIssueDocument, options);
      }
export function useLinearIssueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinearIssueQuery, LinearIssueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinearIssueQuery, LinearIssueQueryVariables>(LinearIssueDocument, options);
        }
export function useLinearIssueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LinearIssueQuery, LinearIssueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinearIssueQuery, LinearIssueQueryVariables>(LinearIssueDocument, options);
        }
export type LinearIssueQueryHookResult = ReturnType<typeof useLinearIssueQuery>;
export type LinearIssueLazyQueryHookResult = ReturnType<typeof useLinearIssueLazyQuery>;
export type LinearIssueSuspenseQueryHookResult = ReturnType<typeof useLinearIssueSuspenseQuery>;
export type LinearIssueQueryResult = Apollo.QueryResult<LinearIssueQuery, LinearIssueQueryVariables>;
export const GoogleDriveDocumentDocument = gql`
    query GoogleDriveDocument($input: GoogleDriveFileInput!) {
  googleDriveDocument(input: $input) {
    ...GoogleDriveFile
  }
}
    ${GoogleDriveFileFragmentDoc}`;

/**
 * __useGoogleDriveDocumentQuery__
 *
 * To run a query within a React component, call `useGoogleDriveDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleDriveDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleDriveDocumentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoogleDriveDocumentQuery(baseOptions: Apollo.QueryHookOptions<GoogleDriveDocumentQuery, GoogleDriveDocumentQueryVariables> & ({ variables: GoogleDriveDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleDriveDocumentQuery, GoogleDriveDocumentQueryVariables>(GoogleDriveDocumentDocument, options);
      }
export function useGoogleDriveDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleDriveDocumentQuery, GoogleDriveDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleDriveDocumentQuery, GoogleDriveDocumentQueryVariables>(GoogleDriveDocumentDocument, options);
        }
export function useGoogleDriveDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoogleDriveDocumentQuery, GoogleDriveDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoogleDriveDocumentQuery, GoogleDriveDocumentQueryVariables>(GoogleDriveDocumentDocument, options);
        }
export type GoogleDriveDocumentQueryHookResult = ReturnType<typeof useGoogleDriveDocumentQuery>;
export type GoogleDriveDocumentLazyQueryHookResult = ReturnType<typeof useGoogleDriveDocumentLazyQuery>;
export type GoogleDriveDocumentSuspenseQueryHookResult = ReturnType<typeof useGoogleDriveDocumentSuspenseQuery>;
export type GoogleDriveDocumentQueryResult = Apollo.QueryResult<GoogleDriveDocumentQuery, GoogleDriveDocumentQueryVariables>;
export const UserIntegrationsDocument = gql`
    query UserIntegrations {
  userIntegrations {
    id
    type
    isActive
  }
}
    `;

/**
 * __useUserIntegrationsQuery__
 *
 * To run a query within a React component, call `useUserIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<UserIntegrationsQuery, UserIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserIntegrationsQuery, UserIntegrationsQueryVariables>(UserIntegrationsDocument, options);
      }
export function useUserIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserIntegrationsQuery, UserIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserIntegrationsQuery, UserIntegrationsQueryVariables>(UserIntegrationsDocument, options);
        }
export function useUserIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserIntegrationsQuery, UserIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserIntegrationsQuery, UserIntegrationsQueryVariables>(UserIntegrationsDocument, options);
        }
export type UserIntegrationsQueryHookResult = ReturnType<typeof useUserIntegrationsQuery>;
export type UserIntegrationsLazyQueryHookResult = ReturnType<typeof useUserIntegrationsLazyQuery>;
export type UserIntegrationsSuspenseQueryHookResult = ReturnType<typeof useUserIntegrationsSuspenseQuery>;
export type UserIntegrationsQueryResult = Apollo.QueryResult<UserIntegrationsQuery, UserIntegrationsQueryVariables>;
export const UnreadNotificationsCounterDocument = gql`
    query UnreadNotificationsCounter {
  unreadNotificationsCounter
}
    `;

/**
 * __useUnreadNotificationsCounterQuery__
 *
 * To run a query within a React component, call `useUnreadNotificationsCounterQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationsCounterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationsCounterQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadNotificationsCounterQuery(baseOptions?: Apollo.QueryHookOptions<UnreadNotificationsCounterQuery, UnreadNotificationsCounterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadNotificationsCounterQuery, UnreadNotificationsCounterQueryVariables>(UnreadNotificationsCounterDocument, options);
      }
export function useUnreadNotificationsCounterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadNotificationsCounterQuery, UnreadNotificationsCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadNotificationsCounterQuery, UnreadNotificationsCounterQueryVariables>(UnreadNotificationsCounterDocument, options);
        }
export function useUnreadNotificationsCounterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnreadNotificationsCounterQuery, UnreadNotificationsCounterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnreadNotificationsCounterQuery, UnreadNotificationsCounterQueryVariables>(UnreadNotificationsCounterDocument, options);
        }
export type UnreadNotificationsCounterQueryHookResult = ReturnType<typeof useUnreadNotificationsCounterQuery>;
export type UnreadNotificationsCounterLazyQueryHookResult = ReturnType<typeof useUnreadNotificationsCounterLazyQuery>;
export type UnreadNotificationsCounterSuspenseQueryHookResult = ReturnType<typeof useUnreadNotificationsCounterSuspenseQuery>;
export type UnreadNotificationsCounterQueryResult = Apollo.QueryResult<UnreadNotificationsCounterQuery, UnreadNotificationsCounterQueryVariables>;
export const TemplatesDocument = gql`
    query Templates {
  templates {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
      }
export function useTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
export function useTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>;
export type TemplatesLazyQueryHookResult = ReturnType<typeof useTemplatesLazyQuery>;
export type TemplatesSuspenseQueryHookResult = ReturnType<typeof useTemplatesSuspenseQuery>;
export type TemplatesQueryResult = Apollo.QueryResult<TemplatesQuery, TemplatesQueryVariables>;
export const LinearTeamsDocument = gql`
    query LinearTeams {
  linearTeams {
    ...LinearTeam
  }
}
    ${LinearTeamFragmentDoc}`;

/**
 * __useLinearTeamsQuery__
 *
 * To run a query within a React component, call `useLinearTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinearTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinearTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinearTeamsQuery(baseOptions?: Apollo.QueryHookOptions<LinearTeamsQuery, LinearTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinearTeamsQuery, LinearTeamsQueryVariables>(LinearTeamsDocument, options);
      }
export function useLinearTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinearTeamsQuery, LinearTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinearTeamsQuery, LinearTeamsQueryVariables>(LinearTeamsDocument, options);
        }
export function useLinearTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LinearTeamsQuery, LinearTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinearTeamsQuery, LinearTeamsQueryVariables>(LinearTeamsDocument, options);
        }
export type LinearTeamsQueryHookResult = ReturnType<typeof useLinearTeamsQuery>;
export type LinearTeamsLazyQueryHookResult = ReturnType<typeof useLinearTeamsLazyQuery>;
export type LinearTeamsSuspenseQueryHookResult = ReturnType<typeof useLinearTeamsSuspenseQuery>;
export type LinearTeamsQueryResult = Apollo.QueryResult<LinearTeamsQuery, LinearTeamsQueryVariables>;
export const SubscriptionPlansDocument = gql`
    query SubscriptionPlans {
  subscriptionPlans {
    id
    stripeId
    featureSet
    price {
      id
      amount
      amountDecimal
      currency
      stripeId
      lookupKey
      interval
      status
    }
  }
}
    `;

/**
 * __useSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionPlansQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
      }
export function useSubscriptionPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
        }
export function useSubscriptionPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
        }
export type SubscriptionPlansQueryHookResult = ReturnType<typeof useSubscriptionPlansQuery>;
export type SubscriptionPlansLazyQueryHookResult = ReturnType<typeof useSubscriptionPlansLazyQuery>;
export type SubscriptionPlansSuspenseQueryHookResult = ReturnType<typeof useSubscriptionPlansSuspenseQuery>;
export type SubscriptionPlansQueryResult = Apollo.QueryResult<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices($input: InvoicesInput!) {
  invoices(input: $input) {
    id
    subscriptionId
    created
    paid
    total
    pdfUrl
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables> & ({ variables: InvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export function useInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesSuspenseQueryHookResult = ReturnType<typeof useInvoicesSuspenseQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const SubscriptionUpcomingDocument = gql`
    query SubscriptionUpcoming($input: SubscriptionUpcomingInput!) {
  subscriptionUpcoming(input: $input) {
    periodStart
    periodEnd
    paid
    total
    created
  }
}
    `;

/**
 * __useSubscriptionUpcomingQuery__
 *
 * To run a query within a React component, call `useSubscriptionUpcomingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionUpcomingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionUpcomingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscriptionUpcomingQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionUpcomingQuery, SubscriptionUpcomingQueryVariables> & ({ variables: SubscriptionUpcomingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionUpcomingQuery, SubscriptionUpcomingQueryVariables>(SubscriptionUpcomingDocument, options);
      }
export function useSubscriptionUpcomingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionUpcomingQuery, SubscriptionUpcomingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionUpcomingQuery, SubscriptionUpcomingQueryVariables>(SubscriptionUpcomingDocument, options);
        }
export function useSubscriptionUpcomingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionUpcomingQuery, SubscriptionUpcomingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionUpcomingQuery, SubscriptionUpcomingQueryVariables>(SubscriptionUpcomingDocument, options);
        }
export type SubscriptionUpcomingQueryHookResult = ReturnType<typeof useSubscriptionUpcomingQuery>;
export type SubscriptionUpcomingLazyQueryHookResult = ReturnType<typeof useSubscriptionUpcomingLazyQuery>;
export type SubscriptionUpcomingSuspenseQueryHookResult = ReturnType<typeof useSubscriptionUpcomingSuspenseQuery>;
export type SubscriptionUpcomingQueryResult = Apollo.QueryResult<SubscriptionUpcomingQuery, SubscriptionUpcomingQueryVariables>;
export const SpaceEmbeddingsDocument = gql`
    query SpaceEmbeddings($input: EmbeddingSearchInput!) {
  spaceEmbeddings(input: $input) {
    ...AIEmbedding
  }
}
    ${AiEmbeddingFragmentDoc}`;

/**
 * __useSpaceEmbeddingsQuery__
 *
 * To run a query within a React component, call `useSpaceEmbeddingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceEmbeddingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceEmbeddingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSpaceEmbeddingsQuery(baseOptions: Apollo.QueryHookOptions<SpaceEmbeddingsQuery, SpaceEmbeddingsQueryVariables> & ({ variables: SpaceEmbeddingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpaceEmbeddingsQuery, SpaceEmbeddingsQueryVariables>(SpaceEmbeddingsDocument, options);
      }
export function useSpaceEmbeddingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpaceEmbeddingsQuery, SpaceEmbeddingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpaceEmbeddingsQuery, SpaceEmbeddingsQueryVariables>(SpaceEmbeddingsDocument, options);
        }
export function useSpaceEmbeddingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SpaceEmbeddingsQuery, SpaceEmbeddingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpaceEmbeddingsQuery, SpaceEmbeddingsQueryVariables>(SpaceEmbeddingsDocument, options);
        }
export type SpaceEmbeddingsQueryHookResult = ReturnType<typeof useSpaceEmbeddingsQuery>;
export type SpaceEmbeddingsLazyQueryHookResult = ReturnType<typeof useSpaceEmbeddingsLazyQuery>;
export type SpaceEmbeddingsSuspenseQueryHookResult = ReturnType<typeof useSpaceEmbeddingsSuspenseQuery>;
export type SpaceEmbeddingsQueryResult = Apollo.QueryResult<SpaceEmbeddingsQuery, SpaceEmbeddingsQueryVariables>;
export const AdminUserListDocument = gql`
    query AdminUserList($input: AdminUserListInput!) {
  adminUserList(input: $input) {
    users {
      id
      email
      names
      role
      createdAt
      updatedAt
    }
    pageInfo {
      ...FullPageInfo
    }
  }
}
    ${FullPageInfoFragmentDoc}`;

/**
 * __useAdminUserListQuery__
 *
 * To run a query within a React component, call `useAdminUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUserListQuery(baseOptions: Apollo.QueryHookOptions<AdminUserListQuery, AdminUserListQueryVariables> & ({ variables: AdminUserListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserListQuery, AdminUserListQueryVariables>(AdminUserListDocument, options);
      }
export function useAdminUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserListQuery, AdminUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserListQuery, AdminUserListQueryVariables>(AdminUserListDocument, options);
        }
export function useAdminUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminUserListQuery, AdminUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminUserListQuery, AdminUserListQueryVariables>(AdminUserListDocument, options);
        }
export type AdminUserListQueryHookResult = ReturnType<typeof useAdminUserListQuery>;
export type AdminUserListLazyQueryHookResult = ReturnType<typeof useAdminUserListLazyQuery>;
export type AdminUserListSuspenseQueryHookResult = ReturnType<typeof useAdminUserListSuspenseQuery>;
export type AdminUserListQueryResult = Apollo.QueryResult<AdminUserListQuery, AdminUserListQueryVariables>;
export const AdminUserListSharedCountDocument = gql`
    query AdminUserListSharedCount($input: AdminUserListSharedCountInput!) {
  adminUserListSharedCount(input: $input) {
    publicPagesCount
    publicSpacesCount
  }
}
    `;

/**
 * __useAdminUserListSharedCountQuery__
 *
 * To run a query within a React component, call `useAdminUserListSharedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserListSharedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserListSharedCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUserListSharedCountQuery(baseOptions: Apollo.QueryHookOptions<AdminUserListSharedCountQuery, AdminUserListSharedCountQueryVariables> & ({ variables: AdminUserListSharedCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserListSharedCountQuery, AdminUserListSharedCountQueryVariables>(AdminUserListSharedCountDocument, options);
      }
export function useAdminUserListSharedCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserListSharedCountQuery, AdminUserListSharedCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserListSharedCountQuery, AdminUserListSharedCountQueryVariables>(AdminUserListSharedCountDocument, options);
        }
export function useAdminUserListSharedCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminUserListSharedCountQuery, AdminUserListSharedCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminUserListSharedCountQuery, AdminUserListSharedCountQueryVariables>(AdminUserListSharedCountDocument, options);
        }
export type AdminUserListSharedCountQueryHookResult = ReturnType<typeof useAdminUserListSharedCountQuery>;
export type AdminUserListSharedCountLazyQueryHookResult = ReturnType<typeof useAdminUserListSharedCountLazyQuery>;
export type AdminUserListSharedCountSuspenseQueryHookResult = ReturnType<typeof useAdminUserListSharedCountSuspenseQuery>;
export type AdminUserListSharedCountQueryResult = Apollo.QueryResult<AdminUserListSharedCountQuery, AdminUserListSharedCountQueryVariables>;
export const AdminSpaceListDocument = gql`
    query AdminSpaceList($input: AdminSpaceListInput!) {
  adminSpaceList(input: $input) {
    id
    title
    urlKey
    createdAt
    ownerIds
    usedSpaceTokens
    activeSubscription {
      id
      status
      canceled
      customerId
      currentPeriodEnd
      currentPeriodStart
      plan {
        id
      }
    }
  }
}
    `;

/**
 * __useAdminSpaceListQuery__
 *
 * To run a query within a React component, call `useAdminSpaceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminSpaceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminSpaceListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSpaceListQuery(baseOptions: Apollo.QueryHookOptions<AdminSpaceListQuery, AdminSpaceListQueryVariables> & ({ variables: AdminSpaceListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminSpaceListQuery, AdminSpaceListQueryVariables>(AdminSpaceListDocument, options);
      }
export function useAdminSpaceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminSpaceListQuery, AdminSpaceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminSpaceListQuery, AdminSpaceListQueryVariables>(AdminSpaceListDocument, options);
        }
export function useAdminSpaceListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminSpaceListQuery, AdminSpaceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminSpaceListQuery, AdminSpaceListQueryVariables>(AdminSpaceListDocument, options);
        }
export type AdminSpaceListQueryHookResult = ReturnType<typeof useAdminSpaceListQuery>;
export type AdminSpaceListLazyQueryHookResult = ReturnType<typeof useAdminSpaceListLazyQuery>;
export type AdminSpaceListSuspenseQueryHookResult = ReturnType<typeof useAdminSpaceListSuspenseQuery>;
export type AdminSpaceListQueryResult = Apollo.QueryResult<AdminSpaceListQuery, AdminSpaceListQueryVariables>;
export const SpacePermissionsDocument = gql`
    query SpacePermissions($input: SpaceByUrlKeyInput!) {
  spacePermissions(input: $input) {
    sagaAiStatus
  }
}
    `;

/**
 * __useSpacePermissionsQuery__
 *
 * To run a query within a React component, call `useSpacePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpacePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpacePermissionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSpacePermissionsQuery(baseOptions: Apollo.QueryHookOptions<SpacePermissionsQuery, SpacePermissionsQueryVariables> & ({ variables: SpacePermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpacePermissionsQuery, SpacePermissionsQueryVariables>(SpacePermissionsDocument, options);
      }
export function useSpacePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpacePermissionsQuery, SpacePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpacePermissionsQuery, SpacePermissionsQueryVariables>(SpacePermissionsDocument, options);
        }
export function useSpacePermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SpacePermissionsQuery, SpacePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpacePermissionsQuery, SpacePermissionsQueryVariables>(SpacePermissionsDocument, options);
        }
export type SpacePermissionsQueryHookResult = ReturnType<typeof useSpacePermissionsQuery>;
export type SpacePermissionsLazyQueryHookResult = ReturnType<typeof useSpacePermissionsLazyQuery>;
export type SpacePermissionsSuspenseQueryHookResult = ReturnType<typeof useSpacePermissionsSuspenseQuery>;
export type SpacePermissionsQueryResult = Apollo.QueryResult<SpacePermissionsQuery, SpacePermissionsQueryVariables>;
export const BillingPortalDocument = gql`
    query BillingPortal($input: BillingPortalInput!) {
  billingPortal(input: $input)
}
    `;

/**
 * __useBillingPortalQuery__
 *
 * To run a query within a React component, call `useBillingPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPortalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBillingPortalQuery(baseOptions: Apollo.QueryHookOptions<BillingPortalQuery, BillingPortalQueryVariables> & ({ variables: BillingPortalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingPortalQuery, BillingPortalQueryVariables>(BillingPortalDocument, options);
      }
export function useBillingPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingPortalQuery, BillingPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingPortalQuery, BillingPortalQueryVariables>(BillingPortalDocument, options);
        }
export function useBillingPortalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BillingPortalQuery, BillingPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingPortalQuery, BillingPortalQueryVariables>(BillingPortalDocument, options);
        }
export type BillingPortalQueryHookResult = ReturnType<typeof useBillingPortalQuery>;
export type BillingPortalLazyQueryHookResult = ReturnType<typeof useBillingPortalLazyQuery>;
export type BillingPortalSuspenseQueryHookResult = ReturnType<typeof useBillingPortalSuspenseQuery>;
export type BillingPortalQueryResult = Apollo.QueryResult<BillingPortalQuery, BillingPortalQueryVariables>;
export const UserPagePermissionsBySpaceIdDocument = gql`
    query UserPagePermissionsBySpaceId($input: UserPagePermissionsBySpaceIdInput!) {
  userPagePermissionsBySpaceId(input: $input) {
    ...UserPagePermissionFragment
  }
}
    ${UserPagePermissionFragmentFragmentDoc}`;

/**
 * __useUserPagePermissionsBySpaceIdQuery__
 *
 * To run a query within a React component, call `useUserPagePermissionsBySpaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPagePermissionsBySpaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPagePermissionsBySpaceIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserPagePermissionsBySpaceIdQuery(baseOptions: Apollo.QueryHookOptions<UserPagePermissionsBySpaceIdQuery, UserPagePermissionsBySpaceIdQueryVariables> & ({ variables: UserPagePermissionsBySpaceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPagePermissionsBySpaceIdQuery, UserPagePermissionsBySpaceIdQueryVariables>(UserPagePermissionsBySpaceIdDocument, options);
      }
export function useUserPagePermissionsBySpaceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPagePermissionsBySpaceIdQuery, UserPagePermissionsBySpaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPagePermissionsBySpaceIdQuery, UserPagePermissionsBySpaceIdQueryVariables>(UserPagePermissionsBySpaceIdDocument, options);
        }
export function useUserPagePermissionsBySpaceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserPagePermissionsBySpaceIdQuery, UserPagePermissionsBySpaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserPagePermissionsBySpaceIdQuery, UserPagePermissionsBySpaceIdQueryVariables>(UserPagePermissionsBySpaceIdDocument, options);
        }
export type UserPagePermissionsBySpaceIdQueryHookResult = ReturnType<typeof useUserPagePermissionsBySpaceIdQuery>;
export type UserPagePermissionsBySpaceIdLazyQueryHookResult = ReturnType<typeof useUserPagePermissionsBySpaceIdLazyQuery>;
export type UserPagePermissionsBySpaceIdSuspenseQueryHookResult = ReturnType<typeof useUserPagePermissionsBySpaceIdSuspenseQuery>;
export type UserPagePermissionsBySpaceIdQueryResult = Apollo.QueryResult<UserPagePermissionsBySpaceIdQuery, UserPagePermissionsBySpaceIdQueryVariables>;
export const PageInvitesAndMembersDocument = gql`
    query PageInvitesAndMembers($pageId: String!, $spaceId: String!) {
  pageMembers(input: {spaceId: $spaceId, pageId: $pageId}) {
    ...PageMemberFragment
  }
  pageInvites(input: {spaceId: $spaceId, pageId: $pageId}) {
    ...PageInviteFragment
  }
}
    ${PageMemberFragmentFragmentDoc}
${PageInviteFragmentFragmentDoc}`;

/**
 * __usePageInvitesAndMembersQuery__
 *
 * To run a query within a React component, call `usePageInvitesAndMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInvitesAndMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInvitesAndMembersQuery({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      spaceId: // value for 'spaceId'
 *   },
 * });
 */
export function usePageInvitesAndMembersQuery(baseOptions: Apollo.QueryHookOptions<PageInvitesAndMembersQuery, PageInvitesAndMembersQueryVariables> & ({ variables: PageInvitesAndMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInvitesAndMembersQuery, PageInvitesAndMembersQueryVariables>(PageInvitesAndMembersDocument, options);
      }
export function usePageInvitesAndMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInvitesAndMembersQuery, PageInvitesAndMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInvitesAndMembersQuery, PageInvitesAndMembersQueryVariables>(PageInvitesAndMembersDocument, options);
        }
export function usePageInvitesAndMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInvitesAndMembersQuery, PageInvitesAndMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInvitesAndMembersQuery, PageInvitesAndMembersQueryVariables>(PageInvitesAndMembersDocument, options);
        }
export type PageInvitesAndMembersQueryHookResult = ReturnType<typeof usePageInvitesAndMembersQuery>;
export type PageInvitesAndMembersLazyQueryHookResult = ReturnType<typeof usePageInvitesAndMembersLazyQuery>;
export type PageInvitesAndMembersSuspenseQueryHookResult = ReturnType<typeof usePageInvitesAndMembersSuspenseQuery>;
export type PageInvitesAndMembersQueryResult = Apollo.QueryResult<PageInvitesAndMembersQuery, PageInvitesAndMembersQueryVariables>;
export const PageInviteMetaDataDocument = gql`
    query PageInviteMetaData($input: PageInviteMetaInput!) {
  pageInviteMetaData(input: $input) {
    ...PageInviteMetaFragment
  }
}
    ${PageInviteMetaFragmentFragmentDoc}`;

/**
 * __usePageInviteMetaDataQuery__
 *
 * To run a query within a React component, call `usePageInviteMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageInviteMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageInviteMetaDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePageInviteMetaDataQuery(baseOptions: Apollo.QueryHookOptions<PageInviteMetaDataQuery, PageInviteMetaDataQueryVariables> & ({ variables: PageInviteMetaDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageInviteMetaDataQuery, PageInviteMetaDataQueryVariables>(PageInviteMetaDataDocument, options);
      }
export function usePageInviteMetaDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageInviteMetaDataQuery, PageInviteMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageInviteMetaDataQuery, PageInviteMetaDataQueryVariables>(PageInviteMetaDataDocument, options);
        }
export function usePageInviteMetaDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageInviteMetaDataQuery, PageInviteMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageInviteMetaDataQuery, PageInviteMetaDataQueryVariables>(PageInviteMetaDataDocument, options);
        }
export type PageInviteMetaDataQueryHookResult = ReturnType<typeof usePageInviteMetaDataQuery>;
export type PageInviteMetaDataLazyQueryHookResult = ReturnType<typeof usePageInviteMetaDataLazyQuery>;
export type PageInviteMetaDataSuspenseQueryHookResult = ReturnType<typeof usePageInviteMetaDataSuspenseQuery>;
export type PageInviteMetaDataQueryResult = Apollo.QueryResult<PageInviteMetaDataQuery, PageInviteMetaDataQueryVariables>;
export const UserPageInvitesDocument = gql`
    query UserPageInvites {
  userPageInvites {
    ...PageInviteMetaFragment
  }
}
    ${PageInviteMetaFragmentFragmentDoc}`;

/**
 * __useUserPageInvitesQuery__
 *
 * To run a query within a React component, call `useUserPageInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPageInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPageInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPageInvitesQuery(baseOptions?: Apollo.QueryHookOptions<UserPageInvitesQuery, UserPageInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPageInvitesQuery, UserPageInvitesQueryVariables>(UserPageInvitesDocument, options);
      }
export function useUserPageInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPageInvitesQuery, UserPageInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPageInvitesQuery, UserPageInvitesQueryVariables>(UserPageInvitesDocument, options);
        }
export function useUserPageInvitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserPageInvitesQuery, UserPageInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserPageInvitesQuery, UserPageInvitesQueryVariables>(UserPageInvitesDocument, options);
        }
export type UserPageInvitesQueryHookResult = ReturnType<typeof useUserPageInvitesQuery>;
export type UserPageInvitesLazyQueryHookResult = ReturnType<typeof useUserPageInvitesLazyQuery>;
export type UserPageInvitesSuspenseQueryHookResult = ReturnType<typeof useUserPageInvitesSuspenseQuery>;
export type UserPageInvitesQueryResult = Apollo.QueryResult<UserPageInvitesQuery, UserPageInvitesQueryVariables>;
export const UserSharedPagesDocument = gql`
    query UserSharedPages {
  userSharedPages {
    ...SharedPageInfoFragment
  }
}
    ${SharedPageInfoFragmentFragmentDoc}`;

/**
 * __useUserSharedPagesQuery__
 *
 * To run a query within a React component, call `useUserSharedPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSharedPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSharedPagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSharedPagesQuery(baseOptions?: Apollo.QueryHookOptions<UserSharedPagesQuery, UserSharedPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSharedPagesQuery, UserSharedPagesQueryVariables>(UserSharedPagesDocument, options);
      }
export function useUserSharedPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSharedPagesQuery, UserSharedPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSharedPagesQuery, UserSharedPagesQueryVariables>(UserSharedPagesDocument, options);
        }
export function useUserSharedPagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserSharedPagesQuery, UserSharedPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSharedPagesQuery, UserSharedPagesQueryVariables>(UserSharedPagesDocument, options);
        }
export type UserSharedPagesQueryHookResult = ReturnType<typeof useUserSharedPagesQuery>;
export type UserSharedPagesLazyQueryHookResult = ReturnType<typeof useUserSharedPagesLazyQuery>;
export type UserSharedPagesSuspenseQueryHookResult = ReturnType<typeof useUserSharedPagesSuspenseQuery>;
export type UserSharedPagesQueryResult = Apollo.QueryResult<UserSharedPagesQuery, UserSharedPagesQueryVariables>;
export const ChatThreadsDocument = gql`
    query ChatThreads($input: ChatThreadsInput!) {
  chatThreads(input: $input) {
    ...AIChatThreadFragment
  }
}
    ${AiChatThreadFragmentFragmentDoc}`;

/**
 * __useChatThreadsQuery__
 *
 * To run a query within a React component, call `useChatThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatThreadsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatThreadsQuery(baseOptions: Apollo.QueryHookOptions<ChatThreadsQuery, ChatThreadsQueryVariables> & ({ variables: ChatThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatThreadsQuery, ChatThreadsQueryVariables>(ChatThreadsDocument, options);
      }
export function useChatThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatThreadsQuery, ChatThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatThreadsQuery, ChatThreadsQueryVariables>(ChatThreadsDocument, options);
        }
export function useChatThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatThreadsQuery, ChatThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatThreadsQuery, ChatThreadsQueryVariables>(ChatThreadsDocument, options);
        }
export type ChatThreadsQueryHookResult = ReturnType<typeof useChatThreadsQuery>;
export type ChatThreadsLazyQueryHookResult = ReturnType<typeof useChatThreadsLazyQuery>;
export type ChatThreadsSuspenseQueryHookResult = ReturnType<typeof useChatThreadsSuspenseQuery>;
export type ChatThreadsQueryResult = Apollo.QueryResult<ChatThreadsQuery, ChatThreadsQueryVariables>;
export const PageHistoryDocument = gql`
    query PageHistory($input: PageHistoryInput!) {
  pageHistory(input: $input) {
    ...PageHistorySnapshot
  }
}
    ${PageHistorySnapshotFragmentDoc}`;

/**
 * __usePageHistoryQuery__
 *
 * To run a query within a React component, call `usePageHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePageHistoryQuery(baseOptions: Apollo.QueryHookOptions<PageHistoryQuery, PageHistoryQueryVariables> & ({ variables: PageHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageHistoryQuery, PageHistoryQueryVariables>(PageHistoryDocument, options);
      }
export function usePageHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageHistoryQuery, PageHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageHistoryQuery, PageHistoryQueryVariables>(PageHistoryDocument, options);
        }
export function usePageHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PageHistoryQuery, PageHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageHistoryQuery, PageHistoryQueryVariables>(PageHistoryDocument, options);
        }
export type PageHistoryQueryHookResult = ReturnType<typeof usePageHistoryQuery>;
export type PageHistoryLazyQueryHookResult = ReturnType<typeof usePageHistoryLazyQuery>;
export type PageHistorySuspenseQueryHookResult = ReturnType<typeof usePageHistorySuspenseQuery>;
export type PageHistoryQueryResult = Apollo.QueryResult<PageHistoryQuery, PageHistoryQueryVariables>;
export const AdminUserDetailsDocument = gql`
    mutation AdminUserDetails($input: AdminUserDetailsInput!) {
  adminUserDetails(input: $input) {
    id
    email
    firstName
    lastName
    role
    createdAt
    updatedAt
    membership {
      spaceId
      spaceName
      publicPages {
        ...SharedPageFragment
      }
      spaceDeletable
      role
    }
    integrations {
      id
      type
      isActive
    }
  }
}
    ${SharedPageFragmentFragmentDoc}`;
export type AdminUserDetailsMutationFn = Apollo.MutationFunction<AdminUserDetailsMutation, AdminUserDetailsMutationVariables>;

/**
 * __useAdminUserDetailsMutation__
 *
 * To run a mutation, you first call `useAdminUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUserDetailsMutation, { data, loading, error }] = useAdminUserDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUserDetailsMutation, AdminUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUserDetailsMutation, AdminUserDetailsMutationVariables>(AdminUserDetailsDocument, options);
      }
export type AdminUserDetailsMutationHookResult = ReturnType<typeof useAdminUserDetailsMutation>;
export type AdminUserDetailsMutationResult = Apollo.MutationResult<AdminUserDetailsMutation>;
export type AdminUserDetailsMutationOptions = Apollo.BaseMutationOptions<AdminUserDetailsMutation, AdminUserDetailsMutationVariables>;
export const AdminUserDeleteDocument = gql`
    mutation AdminUserDelete($input: AdminUsersDeleteInput!) {
  adminUserDelete(input: $input) {
    userId
    status
  }
}
    `;
export type AdminUserDeleteMutationFn = Apollo.MutationFunction<AdminUserDeleteMutation, AdminUserDeleteMutationVariables>;

/**
 * __useAdminUserDeleteMutation__
 *
 * To run a mutation, you first call `useAdminUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUserDeleteMutation, { data, loading, error }] = useAdminUserDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUserDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AdminUserDeleteMutation, AdminUserDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUserDeleteMutation, AdminUserDeleteMutationVariables>(AdminUserDeleteDocument, options);
      }
export type AdminUserDeleteMutationHookResult = ReturnType<typeof useAdminUserDeleteMutation>;
export type AdminUserDeleteMutationResult = Apollo.MutationResult<AdminUserDeleteMutation>;
export type AdminUserDeleteMutationOptions = Apollo.BaseMutationOptions<AdminUserDeleteMutation, AdminUserDeleteMutationVariables>;
export const UpdateUserNameDocument = gql`
    mutation UpdateUserName($input: UpdateUserNameInput!) {
  updateUserName(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserNameMutationFn = Apollo.MutationFunction<UpdateUserNameMutation, UpdateUserNameMutationVariables>;

/**
 * __useUpdateUserNameMutation__
 *
 * To run a mutation, you first call `useUpdateUserNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNameMutation, { data, loading, error }] = useUpdateUserNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNameMutation, UpdateUserNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNameMutation, UpdateUserNameMutationVariables>(UpdateUserNameDocument, options);
      }
export type UpdateUserNameMutationHookResult = ReturnType<typeof useUpdateUserNameMutation>;
export type UpdateUserNameMutationResult = Apollo.MutationResult<UpdateUserNameMutation>;
export type UpdateUserNameMutationOptions = Apollo.BaseMutationOptions<UpdateUserNameMutation, UpdateUserNameMutationVariables>;
export const UpdateUserLanguageDocument = gql`
    mutation updateUserLanguage($input: UpdateUserLanguageInput!) {
  updateUserLanguage(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserLanguageMutationFn = Apollo.MutationFunction<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>;

/**
 * __useUpdateUserLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateUserLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLanguageMutation, { data, loading, error }] = useUpdateUserLanguageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserLanguageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(UpdateUserLanguageDocument, options);
      }
export type UpdateUserLanguageMutationHookResult = ReturnType<typeof useUpdateUserLanguageMutation>;
export type UpdateUserLanguageMutationResult = Apollo.MutationResult<UpdateUserLanguageMutation>;
export type UpdateUserLanguageMutationOptions = Apollo.BaseMutationOptions<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>;
export const SignupDocument = gql`
    mutation Signup($input: SignupInput!) {
  signup(input: $input) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const CreateSpaceDocument = gql`
    mutation CreateSpace($input: CreateSpaceInput!) {
  createSpace(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export type CreateSpaceMutationFn = Apollo.MutationFunction<CreateSpaceMutation, CreateSpaceMutationVariables>;

/**
 * __useCreateSpaceMutation__
 *
 * To run a mutation, you first call `useCreateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpaceMutation, { data, loading, error }] = useCreateSpaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateSpaceMutation, CreateSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSpaceMutation, CreateSpaceMutationVariables>(CreateSpaceDocument, options);
      }
export type CreateSpaceMutationHookResult = ReturnType<typeof useCreateSpaceMutation>;
export type CreateSpaceMutationResult = Apollo.MutationResult<CreateSpaceMutation>;
export type CreateSpaceMutationOptions = Apollo.BaseMutationOptions<CreateSpaceMutation, CreateSpaceMutationVariables>;
export const CreatePageDocument = gql`
    mutation CreatePage($input: CreatePageInput!) {
  createPage(input: $input) {
    ...PageFragment
  }
}
    ${PageFragmentFragmentDoc}`;
export type CreatePageMutationFn = Apollo.MutationFunction<CreatePageMutation, CreatePageMutationVariables>;

/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageMutation, CreatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageMutation, CreatePageMutationVariables>(CreatePageDocument, options);
      }
export type CreatePageMutationHookResult = ReturnType<typeof useCreatePageMutation>;
export type CreatePageMutationResult = Apollo.MutationResult<CreatePageMutation>;
export type CreatePageMutationOptions = Apollo.BaseMutationOptions<CreatePageMutation, CreatePageMutationVariables>;
export const DeleteSpaceDocument = gql`
    mutation DeleteSpace($input: DeleteSpaceInput!) {
  deleteSpace(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export type DeleteSpaceMutationFn = Apollo.MutationFunction<DeleteSpaceMutation, DeleteSpaceMutationVariables>;

/**
 * __useDeleteSpaceMutation__
 *
 * To run a mutation, you first call `useDeleteSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpaceMutation, { data, loading, error }] = useDeleteSpaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSpaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSpaceMutation, DeleteSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSpaceMutation, DeleteSpaceMutationVariables>(DeleteSpaceDocument, options);
      }
export type DeleteSpaceMutationHookResult = ReturnType<typeof useDeleteSpaceMutation>;
export type DeleteSpaceMutationResult = Apollo.MutationResult<DeleteSpaceMutation>;
export type DeleteSpaceMutationOptions = Apollo.BaseMutationOptions<DeleteSpaceMutation, DeleteSpaceMutationVariables>;
export const CopyWorkspaceDocument = gql`
    mutation CopyWorkspace($input: CopyWorkspaceInput!) {
  copyWorkspace(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export type CopyWorkspaceMutationFn = Apollo.MutationFunction<CopyWorkspaceMutation, CopyWorkspaceMutationVariables>;

/**
 * __useCopyWorkspaceMutation__
 *
 * To run a mutation, you first call `useCopyWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyWorkspaceMutation, { data, loading, error }] = useCopyWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CopyWorkspaceMutation, CopyWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyWorkspaceMutation, CopyWorkspaceMutationVariables>(CopyWorkspaceDocument, options);
      }
export type CopyWorkspaceMutationHookResult = ReturnType<typeof useCopyWorkspaceMutation>;
export type CopyWorkspaceMutationResult = Apollo.MutationResult<CopyWorkspaceMutation>;
export type CopyWorkspaceMutationOptions = Apollo.BaseMutationOptions<CopyWorkspaceMutation, CopyWorkspaceMutationVariables>;
export const UpdateSpaceSortingDocument = gql`
    mutation UpdateSpaceSorting($input: UpdateSpaceSortingInput!) {
  updateSpaceSorting(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export type UpdateSpaceSortingMutationFn = Apollo.MutationFunction<UpdateSpaceSortingMutation, UpdateSpaceSortingMutationVariables>;

/**
 * __useUpdateSpaceSortingMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceSortingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceSortingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceSortingMutation, { data, loading, error }] = useUpdateSpaceSortingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpaceSortingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpaceSortingMutation, UpdateSpaceSortingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpaceSortingMutation, UpdateSpaceSortingMutationVariables>(UpdateSpaceSortingDocument, options);
      }
export type UpdateSpaceSortingMutationHookResult = ReturnType<typeof useUpdateSpaceSortingMutation>;
export type UpdateSpaceSortingMutationResult = Apollo.MutationResult<UpdateSpaceSortingMutation>;
export type UpdateSpaceSortingMutationOptions = Apollo.BaseMutationOptions<UpdateSpaceSortingMutation, UpdateSpaceSortingMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation UpdateUserSettings($input: UpdateUserSettingsInput!) {
  updateUserSettings(input: $input) {
    ...UserSettings
  }
}
    ${UserSettingsFragmentDoc}`;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const UpdateAiPromptsDocument = gql`
    mutation UpdateAIPrompts($input: [UpdateAIPromptsInput!]!) {
  updateAIPrompts(input: $input) {
    ...CustomAIPrompts
  }
}
    ${CustomAiPromptsFragmentDoc}`;
export type UpdateAiPromptsMutationFn = Apollo.MutationFunction<UpdateAiPromptsMutation, UpdateAiPromptsMutationVariables>;

/**
 * __useUpdateAiPromptsMutation__
 *
 * To run a mutation, you first call `useUpdateAiPromptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiPromptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiPromptsMutation, { data, loading, error }] = useUpdateAiPromptsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAiPromptsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiPromptsMutation, UpdateAiPromptsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiPromptsMutation, UpdateAiPromptsMutationVariables>(UpdateAiPromptsDocument, options);
      }
export type UpdateAiPromptsMutationHookResult = ReturnType<typeof useUpdateAiPromptsMutation>;
export type UpdateAiPromptsMutationResult = Apollo.MutationResult<UpdateAiPromptsMutation>;
export type UpdateAiPromptsMutationOptions = Apollo.BaseMutationOptions<UpdateAiPromptsMutation, UpdateAiPromptsMutationVariables>;
export const AddAiPromptDocument = gql`
    mutation AddAIPrompt($input: AddAIPromptInput!) {
  addAIPrompt(input: $input) {
    ...CustomAIPrompts
  }
}
    ${CustomAiPromptsFragmentDoc}`;
export type AddAiPromptMutationFn = Apollo.MutationFunction<AddAiPromptMutation, AddAiPromptMutationVariables>;

/**
 * __useAddAiPromptMutation__
 *
 * To run a mutation, you first call `useAddAiPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAiPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAiPromptMutation, { data, loading, error }] = useAddAiPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAiPromptMutation(baseOptions?: Apollo.MutationHookOptions<AddAiPromptMutation, AddAiPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAiPromptMutation, AddAiPromptMutationVariables>(AddAiPromptDocument, options);
      }
export type AddAiPromptMutationHookResult = ReturnType<typeof useAddAiPromptMutation>;
export type AddAiPromptMutationResult = Apollo.MutationResult<AddAiPromptMutation>;
export type AddAiPromptMutationOptions = Apollo.BaseMutationOptions<AddAiPromptMutation, AddAiPromptMutationVariables>;
export const RemoveAiPromptDocument = gql`
    mutation RemoveAIPrompt($input: RemoveAIPromptInput!) {
  removeAIPrompt(input: $input)
}
    `;
export type RemoveAiPromptMutationFn = Apollo.MutationFunction<RemoveAiPromptMutation, RemoveAiPromptMutationVariables>;

/**
 * __useRemoveAiPromptMutation__
 *
 * To run a mutation, you first call `useRemoveAiPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAiPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAiPromptMutation, { data, loading, error }] = useRemoveAiPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAiPromptMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAiPromptMutation, RemoveAiPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAiPromptMutation, RemoveAiPromptMutationVariables>(RemoveAiPromptDocument, options);
      }
export type RemoveAiPromptMutationHookResult = ReturnType<typeof useRemoveAiPromptMutation>;
export type RemoveAiPromptMutationResult = Apollo.MutationResult<RemoveAiPromptMutation>;
export type RemoveAiPromptMutationOptions = Apollo.BaseMutationOptions<RemoveAiPromptMutation, RemoveAiPromptMutationVariables>;
export const InviteMembersDocument = gql`
    mutation InviteMembers($input: InviteMembersInput!) {
  inviteMembers(input: $input) {
    ...InviteFragment
  }
}
    ${InviteFragmentFragmentDoc}`;
export type InviteMembersMutationFn = Apollo.MutationFunction<InviteMembersMutation, InviteMembersMutationVariables>;

/**
 * __useInviteMembersMutation__
 *
 * To run a mutation, you first call `useInviteMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMembersMutation, { data, loading, error }] = useInviteMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteMembersMutation(baseOptions?: Apollo.MutationHookOptions<InviteMembersMutation, InviteMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMembersMutation, InviteMembersMutationVariables>(InviteMembersDocument, options);
      }
export type InviteMembersMutationHookResult = ReturnType<typeof useInviteMembersMutation>;
export type InviteMembersMutationResult = Apollo.MutationResult<InviteMembersMutation>;
export type InviteMembersMutationOptions = Apollo.BaseMutationOptions<InviteMembersMutation, InviteMembersMutationVariables>;
export const RevokeInviteDocument = gql`
    mutation RevokeInvite($input: RevokeInviteInput!) {
  revokeInvite(input: $input) {
    ...InviteFragment
  }
}
    ${InviteFragmentFragmentDoc}`;
export type RevokeInviteMutationFn = Apollo.MutationFunction<RevokeInviteMutation, RevokeInviteMutationVariables>;

/**
 * __useRevokeInviteMutation__
 *
 * To run a mutation, you first call `useRevokeInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeInviteMutation, { data, loading, error }] = useRevokeInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeInviteMutation(baseOptions?: Apollo.MutationHookOptions<RevokeInviteMutation, RevokeInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeInviteMutation, RevokeInviteMutationVariables>(RevokeInviteDocument, options);
      }
export type RevokeInviteMutationHookResult = ReturnType<typeof useRevokeInviteMutation>;
export type RevokeInviteMutationResult = Apollo.MutationResult<RevokeInviteMutation>;
export type RevokeInviteMutationOptions = Apollo.BaseMutationOptions<RevokeInviteMutation, RevokeInviteMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($input: AcceptInvitationInput!) {
  acceptInvitation(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<AcceptInvitationMutation, AcceptInvitationMutationVariables>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($input: RemoveMemberInput!) {
  removeMember(input: $input)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const UpdateMemberRoleDocument = gql`
    mutation UpdateMemberRole($input: UpdateMemberRoleInput!) {
  updateMemberRole(input: $input) {
    ...MemberFragment
  }
}
    ${MemberFragmentFragmentDoc}`;
export type UpdateMemberRoleMutationFn = Apollo.MutationFunction<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;

/**
 * __useUpdateMemberRoleMutation__
 *
 * To run a mutation, you first call `useUpdateMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberRoleMutation, { data, loading, error }] = useUpdateMemberRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>(UpdateMemberRoleDocument, options);
      }
export type UpdateMemberRoleMutationHookResult = ReturnType<typeof useUpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationResult = Apollo.MutationResult<UpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationOptions = Apollo.BaseMutationOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;
export const LeaveSpaceDocument = gql`
    mutation LeaveSpace($input: LeaveSpaceInput!) {
  leaveSpace(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export type LeaveSpaceMutationFn = Apollo.MutationFunction<LeaveSpaceMutation, LeaveSpaceMutationVariables>;

/**
 * __useLeaveSpaceMutation__
 *
 * To run a mutation, you first call `useLeaveSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveSpaceMutation, { data, loading, error }] = useLeaveSpaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaveSpaceMutation(baseOptions?: Apollo.MutationHookOptions<LeaveSpaceMutation, LeaveSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveSpaceMutation, LeaveSpaceMutationVariables>(LeaveSpaceDocument, options);
      }
export type LeaveSpaceMutationHookResult = ReturnType<typeof useLeaveSpaceMutation>;
export type LeaveSpaceMutationResult = Apollo.MutationResult<LeaveSpaceMutation>;
export type LeaveSpaceMutationOptions = Apollo.BaseMutationOptions<LeaveSpaceMutation, LeaveSpaceMutationVariables>;
export const UpdateSpaceMetadataDocument = gql`
    mutation updateSpaceMetadata($input: UpdateSpaceMetadataInput!) {
  updateSpaceMetadata(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export type UpdateSpaceMetadataMutationFn = Apollo.MutationFunction<UpdateSpaceMetadataMutation, UpdateSpaceMetadataMutationVariables>;

/**
 * __useUpdateSpaceMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceMetadataMutation, { data, loading, error }] = useUpdateSpaceMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpaceMetadataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpaceMetadataMutation, UpdateSpaceMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpaceMetadataMutation, UpdateSpaceMetadataMutationVariables>(UpdateSpaceMetadataDocument, options);
      }
export type UpdateSpaceMetadataMutationHookResult = ReturnType<typeof useUpdateSpaceMetadataMutation>;
export type UpdateSpaceMetadataMutationResult = Apollo.MutationResult<UpdateSpaceMetadataMutation>;
export type UpdateSpaceMetadataMutationOptions = Apollo.BaseMutationOptions<UpdateSpaceMetadataMutation, UpdateSpaceMetadataMutationVariables>;
export const UpdateSpacePublicMetadataDocument = gql`
    mutation updateSpacePublicMetadata($input: UpdateSpacePublicMetadataInput!) {
  updateSpacePublicMetadata(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export type UpdateSpacePublicMetadataMutationFn = Apollo.MutationFunction<UpdateSpacePublicMetadataMutation, UpdateSpacePublicMetadataMutationVariables>;

/**
 * __useUpdateSpacePublicMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateSpacePublicMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpacePublicMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpacePublicMetadataMutation, { data, loading, error }] = useUpdateSpacePublicMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpacePublicMetadataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpacePublicMetadataMutation, UpdateSpacePublicMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpacePublicMetadataMutation, UpdateSpacePublicMetadataMutationVariables>(UpdateSpacePublicMetadataDocument, options);
      }
export type UpdateSpacePublicMetadataMutationHookResult = ReturnType<typeof useUpdateSpacePublicMetadataMutation>;
export type UpdateSpacePublicMetadataMutationResult = Apollo.MutationResult<UpdateSpacePublicMetadataMutation>;
export type UpdateSpacePublicMetadataMutationOptions = Apollo.BaseMutationOptions<UpdateSpacePublicMetadataMutation, UpdateSpacePublicMetadataMutationVariables>;
export const UpdateSpaceUseCasesDocument = gql`
    mutation UpdateSpaceUseCases($input: UpdateSpaceUseCasesInput!) {
  updateSpaceUseCases(input: $input) {
    ...SpaceFragment
  }
}
    ${SpaceFragmentFragmentDoc}`;
export type UpdateSpaceUseCasesMutationFn = Apollo.MutationFunction<UpdateSpaceUseCasesMutation, UpdateSpaceUseCasesMutationVariables>;

/**
 * __useUpdateSpaceUseCasesMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceUseCasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceUseCasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceUseCasesMutation, { data, loading, error }] = useUpdateSpaceUseCasesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpaceUseCasesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpaceUseCasesMutation, UpdateSpaceUseCasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpaceUseCasesMutation, UpdateSpaceUseCasesMutationVariables>(UpdateSpaceUseCasesDocument, options);
      }
export type UpdateSpaceUseCasesMutationHookResult = ReturnType<typeof useUpdateSpaceUseCasesMutation>;
export type UpdateSpaceUseCasesMutationResult = Apollo.MutationResult<UpdateSpaceUseCasesMutation>;
export type UpdateSpaceUseCasesMutationOptions = Apollo.BaseMutationOptions<UpdateSpaceUseCasesMutation, UpdateSpaceUseCasesMutationVariables>;
export const RequestSignInLinkDocument = gql`
    mutation RequestSignInLink($input: RequestSignInLinkInput!) {
  requestSignInLink(input: $input)
}
    `;
export type RequestSignInLinkMutationFn = Apollo.MutationFunction<RequestSignInLinkMutation, RequestSignInLinkMutationVariables>;

/**
 * __useRequestSignInLinkMutation__
 *
 * To run a mutation, you first call `useRequestSignInLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSignInLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSignInLinkMutation, { data, loading, error }] = useRequestSignInLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestSignInLinkMutation(baseOptions?: Apollo.MutationHookOptions<RequestSignInLinkMutation, RequestSignInLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestSignInLinkMutation, RequestSignInLinkMutationVariables>(RequestSignInLinkDocument, options);
      }
export type RequestSignInLinkMutationHookResult = ReturnType<typeof useRequestSignInLinkMutation>;
export type RequestSignInLinkMutationResult = Apollo.MutationResult<RequestSignInLinkMutation>;
export type RequestSignInLinkMutationOptions = Apollo.BaseMutationOptions<RequestSignInLinkMutation, RequestSignInLinkMutationVariables>;
export const AddBlocksDocument = gql`
    mutation AddBlocks($input: AddBlocksInput!) {
  addBlocks(input: $input)
}
    `;
export type AddBlocksMutationFn = Apollo.MutationFunction<AddBlocksMutation, AddBlocksMutationVariables>;

/**
 * __useAddBlocksMutation__
 *
 * To run a mutation, you first call `useAddBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBlocksMutation, { data, loading, error }] = useAddBlocksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBlocksMutation(baseOptions?: Apollo.MutationHookOptions<AddBlocksMutation, AddBlocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBlocksMutation, AddBlocksMutationVariables>(AddBlocksDocument, options);
      }
export type AddBlocksMutationHookResult = ReturnType<typeof useAddBlocksMutation>;
export type AddBlocksMutationResult = Apollo.MutationResult<AddBlocksMutation>;
export type AddBlocksMutationOptions = Apollo.BaseMutationOptions<AddBlocksMutation, AddBlocksMutationVariables>;
export const SendTaskMentionNotificationDocument = gql`
    mutation SendTaskMentionNotification($input: SendTaskMentionNotificationInput!) {
  sendTaskMentionNotification(input: $input)
}
    `;
export type SendTaskMentionNotificationMutationFn = Apollo.MutationFunction<SendTaskMentionNotificationMutation, SendTaskMentionNotificationMutationVariables>;

/**
 * __useSendTaskMentionNotificationMutation__
 *
 * To run a mutation, you first call `useSendTaskMentionNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTaskMentionNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTaskMentionNotificationMutation, { data, loading, error }] = useSendTaskMentionNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTaskMentionNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendTaskMentionNotificationMutation, SendTaskMentionNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTaskMentionNotificationMutation, SendTaskMentionNotificationMutationVariables>(SendTaskMentionNotificationDocument, options);
      }
export type SendTaskMentionNotificationMutationHookResult = ReturnType<typeof useSendTaskMentionNotificationMutation>;
export type SendTaskMentionNotificationMutationResult = Apollo.MutationResult<SendTaskMentionNotificationMutation>;
export type SendTaskMentionNotificationMutationOptions = Apollo.BaseMutationOptions<SendTaskMentionNotificationMutation, SendTaskMentionNotificationMutationVariables>;
export const SendTaskAssignmentNotificationDocument = gql`
    mutation SendTaskAssignmentNotification($input: SendTaskAssignmentNotificationInput!) {
  sendTaskAssignmentNotification(input: $input)
}
    `;
export type SendTaskAssignmentNotificationMutationFn = Apollo.MutationFunction<SendTaskAssignmentNotificationMutation, SendTaskAssignmentNotificationMutationVariables>;

/**
 * __useSendTaskAssignmentNotificationMutation__
 *
 * To run a mutation, you first call `useSendTaskAssignmentNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTaskAssignmentNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTaskAssignmentNotificationMutation, { data, loading, error }] = useSendTaskAssignmentNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTaskAssignmentNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendTaskAssignmentNotificationMutation, SendTaskAssignmentNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTaskAssignmentNotificationMutation, SendTaskAssignmentNotificationMutationVariables>(SendTaskAssignmentNotificationDocument, options);
      }
export type SendTaskAssignmentNotificationMutationHookResult = ReturnType<typeof useSendTaskAssignmentNotificationMutation>;
export type SendTaskAssignmentNotificationMutationResult = Apollo.MutationResult<SendTaskAssignmentNotificationMutation>;
export type SendTaskAssignmentNotificationMutationOptions = Apollo.BaseMutationOptions<SendTaskAssignmentNotificationMutation, SendTaskAssignmentNotificationMutationVariables>;
export const SendNotificationDocument = gql`
    mutation SendNotification($input: SendNotificationInput!) {
  sendNotification(input: $input)
}
    `;
export type SendNotificationMutationFn = Apollo.MutationFunction<SendNotificationMutation, SendNotificationMutationVariables>;

/**
 * __useSendNotificationMutation__
 *
 * To run a mutation, you first call `useSendNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNotificationMutation, { data, loading, error }] = useSendNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendNotificationMutation, SendNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNotificationMutation, SendNotificationMutationVariables>(SendNotificationDocument, options);
      }
export type SendNotificationMutationHookResult = ReturnType<typeof useSendNotificationMutation>;
export type SendNotificationMutationResult = Apollo.MutationResult<SendNotificationMutation>;
export type SendNotificationMutationOptions = Apollo.BaseMutationOptions<SendNotificationMutation, SendNotificationMutationVariables>;
export const RemoveUserIntegrationDocument = gql`
    mutation removeUserIntegration($input: RemoveUserIntegrationInput!) {
  removeUserIntegration(input: $input)
}
    `;
export type RemoveUserIntegrationMutationFn = Apollo.MutationFunction<RemoveUserIntegrationMutation, RemoveUserIntegrationMutationVariables>;

/**
 * __useRemoveUserIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveUserIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserIntegrationMutation, { data, loading, error }] = useRemoveUserIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserIntegrationMutation, RemoveUserIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserIntegrationMutation, RemoveUserIntegrationMutationVariables>(RemoveUserIntegrationDocument, options);
      }
export type RemoveUserIntegrationMutationHookResult = ReturnType<typeof useRemoveUserIntegrationMutation>;
export type RemoveUserIntegrationMutationResult = Apollo.MutationResult<RemoveUserIntegrationMutation>;
export type RemoveUserIntegrationMutationOptions = Apollo.BaseMutationOptions<RemoveUserIntegrationMutation, RemoveUserIntegrationMutationVariables>;
export const MarkNotificationsAsReadDocument = gql`
    mutation MarkNotificationsAsRead($input: MarkNotificationsAsReadInput!) {
  markNotificationsAsRead(input: $input) {
    __typename
    id
    readAt
  }
}
    `;
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
      }
export type MarkNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationResult = Apollo.MutationResult<MarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const SharePageDocument = gql`
    mutation SharePage($input: SharePageInput!) {
  sharePage(input: $input) {
    id
  }
}
    `;
export type SharePageMutationFn = Apollo.MutationFunction<SharePageMutation, SharePageMutationVariables>;

/**
 * __useSharePageMutation__
 *
 * To run a mutation, you first call `useSharePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharePageMutation, { data, loading, error }] = useSharePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSharePageMutation(baseOptions?: Apollo.MutationHookOptions<SharePageMutation, SharePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SharePageMutation, SharePageMutationVariables>(SharePageDocument, options);
      }
export type SharePageMutationHookResult = ReturnType<typeof useSharePageMutation>;
export type SharePageMutationResult = Apollo.MutationResult<SharePageMutation>;
export type SharePageMutationOptions = Apollo.BaseMutationOptions<SharePageMutation, SharePageMutationVariables>;
export const RemoveSharedPageDocument = gql`
    mutation RemoveSharedPage($input: RemoveSharedPageInput!) {
  removeSharedPage(input: $input)
}
    `;
export type RemoveSharedPageMutationFn = Apollo.MutationFunction<RemoveSharedPageMutation, RemoveSharedPageMutationVariables>;

/**
 * __useRemoveSharedPageMutation__
 *
 * To run a mutation, you first call `useRemoveSharedPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSharedPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSharedPageMutation, { data, loading, error }] = useRemoveSharedPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSharedPageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSharedPageMutation, RemoveSharedPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSharedPageMutation, RemoveSharedPageMutationVariables>(RemoveSharedPageDocument, options);
      }
export type RemoveSharedPageMutationHookResult = ReturnType<typeof useRemoveSharedPageMutation>;
export type RemoveSharedPageMutationResult = Apollo.MutationResult<RemoveSharedPageMutation>;
export type RemoveSharedPageMutationOptions = Apollo.BaseMutationOptions<RemoveSharedPageMutation, RemoveSharedPageMutationVariables>;
export const InvitePageMembersDocument = gql`
    mutation InvitePageMembers($input: InvitePageMembersInput!) {
  invitePageMembers(input: $input) {
    ...PageInviteFragment
  }
}
    ${PageInviteFragmentFragmentDoc}`;
export type InvitePageMembersMutationFn = Apollo.MutationFunction<InvitePageMembersMutation, InvitePageMembersMutationVariables>;

/**
 * __useInvitePageMembersMutation__
 *
 * To run a mutation, you first call `useInvitePageMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitePageMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitePageMembersMutation, { data, loading, error }] = useInvitePageMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvitePageMembersMutation(baseOptions?: Apollo.MutationHookOptions<InvitePageMembersMutation, InvitePageMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitePageMembersMutation, InvitePageMembersMutationVariables>(InvitePageMembersDocument, options);
      }
export type InvitePageMembersMutationHookResult = ReturnType<typeof useInvitePageMembersMutation>;
export type InvitePageMembersMutationResult = Apollo.MutationResult<InvitePageMembersMutation>;
export type InvitePageMembersMutationOptions = Apollo.BaseMutationOptions<InvitePageMembersMutation, InvitePageMembersMutationVariables>;
export const RevokePageInviteDocument = gql`
    mutation RevokePageInvite($input: RevokePageInviteInput!) {
  revokePageInvite(input: $input) {
    ...PageInviteFragment
  }
}
    ${PageInviteFragmentFragmentDoc}`;
export type RevokePageInviteMutationFn = Apollo.MutationFunction<RevokePageInviteMutation, RevokePageInviteMutationVariables>;

/**
 * __useRevokePageInviteMutation__
 *
 * To run a mutation, you first call `useRevokePageInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokePageInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokePageInviteMutation, { data, loading, error }] = useRevokePageInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokePageInviteMutation(baseOptions?: Apollo.MutationHookOptions<RevokePageInviteMutation, RevokePageInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokePageInviteMutation, RevokePageInviteMutationVariables>(RevokePageInviteDocument, options);
      }
export type RevokePageInviteMutationHookResult = ReturnType<typeof useRevokePageInviteMutation>;
export type RevokePageInviteMutationResult = Apollo.MutationResult<RevokePageInviteMutation>;
export type RevokePageInviteMutationOptions = Apollo.BaseMutationOptions<RevokePageInviteMutation, RevokePageInviteMutationVariables>;
export const AcceptPageInvitationDocument = gql`
    mutation AcceptPageInvitation($input: AcceptPageInvitationInput!) {
  acceptPageInvitation(input: $input) {
    ...SharedPageFragment
  }
}
    ${SharedPageFragmentFragmentDoc}`;
export type AcceptPageInvitationMutationFn = Apollo.MutationFunction<AcceptPageInvitationMutation, AcceptPageInvitationMutationVariables>;

/**
 * __useAcceptPageInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptPageInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptPageInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptPageInvitationMutation, { data, loading, error }] = useAcceptPageInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptPageInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptPageInvitationMutation, AcceptPageInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptPageInvitationMutation, AcceptPageInvitationMutationVariables>(AcceptPageInvitationDocument, options);
      }
export type AcceptPageInvitationMutationHookResult = ReturnType<typeof useAcceptPageInvitationMutation>;
export type AcceptPageInvitationMutationResult = Apollo.MutationResult<AcceptPageInvitationMutation>;
export type AcceptPageInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptPageInvitationMutation, AcceptPageInvitationMutationVariables>;
export const LinearIssueCreateDocument = gql`
    mutation LinearIssueCreate($input: LinearIssueCreateInput!) {
  linearIssueCreate(input: $input) {
    ...LinearIssue
  }
}
    ${LinearIssueFragmentDoc}`;
export type LinearIssueCreateMutationFn = Apollo.MutationFunction<LinearIssueCreateMutation, LinearIssueCreateMutationVariables>;

/**
 * __useLinearIssueCreateMutation__
 *
 * To run a mutation, you first call `useLinearIssueCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinearIssueCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linearIssueCreateMutation, { data, loading, error }] = useLinearIssueCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinearIssueCreateMutation(baseOptions?: Apollo.MutationHookOptions<LinearIssueCreateMutation, LinearIssueCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinearIssueCreateMutation, LinearIssueCreateMutationVariables>(LinearIssueCreateDocument, options);
      }
export type LinearIssueCreateMutationHookResult = ReturnType<typeof useLinearIssueCreateMutation>;
export type LinearIssueCreateMutationResult = Apollo.MutationResult<LinearIssueCreateMutation>;
export type LinearIssueCreateMutationOptions = Apollo.BaseMutationOptions<LinearIssueCreateMutation, LinearIssueCreateMutationVariables>;
export const LinearIssueDeleteDocument = gql`
    mutation LinearIssueDelete($input: LinearIssueDeleteInput!) {
  linearIssueDelete(input: $input)
}
    `;
export type LinearIssueDeleteMutationFn = Apollo.MutationFunction<LinearIssueDeleteMutation, LinearIssueDeleteMutationVariables>;

/**
 * __useLinearIssueDeleteMutation__
 *
 * To run a mutation, you first call `useLinearIssueDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinearIssueDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linearIssueDeleteMutation, { data, loading, error }] = useLinearIssueDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinearIssueDeleteMutation(baseOptions?: Apollo.MutationHookOptions<LinearIssueDeleteMutation, LinearIssueDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinearIssueDeleteMutation, LinearIssueDeleteMutationVariables>(LinearIssueDeleteDocument, options);
      }
export type LinearIssueDeleteMutationHookResult = ReturnType<typeof useLinearIssueDeleteMutation>;
export type LinearIssueDeleteMutationResult = Apollo.MutationResult<LinearIssueDeleteMutation>;
export type LinearIssueDeleteMutationOptions = Apollo.BaseMutationOptions<LinearIssueDeleteMutation, LinearIssueDeleteMutationVariables>;
export const CreateSubscriptionSessionDocument = gql`
    mutation CreateSubscriptionSession($input: CreateSubscriptionSessionInput!) {
  createSubscriptionSession(input: $input) {
    session
  }
}
    `;
export type CreateSubscriptionSessionMutationFn = Apollo.MutationFunction<CreateSubscriptionSessionMutation, CreateSubscriptionSessionMutationVariables>;

/**
 * __useCreateSubscriptionSessionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionSessionMutation, { data, loading, error }] = useCreateSubscriptionSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionSessionMutation, CreateSubscriptionSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionSessionMutation, CreateSubscriptionSessionMutationVariables>(CreateSubscriptionSessionDocument, options);
      }
export type CreateSubscriptionSessionMutationHookResult = ReturnType<typeof useCreateSubscriptionSessionMutation>;
export type CreateSubscriptionSessionMutationResult = Apollo.MutationResult<CreateSubscriptionSessionMutation>;
export type CreateSubscriptionSessionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionSessionMutation, CreateSubscriptionSessionMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($input: CreateSubscriptionInput!) {
  createSubscription(input: $input) {
    space {
      ...SpaceFragment
      members {
        ...MemberFragment
      }
    }
  }
}
    ${SpaceFragmentFragmentDoc}
${MemberFragmentFragmentDoc}`;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($input: CancelSubscriptionInput!) {
  cancelSubscription(input: $input) {
    ...SubscriptionFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}`;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const ChangeSubscriptionDocument = gql`
    mutation ChangeSubscription($input: ChangeSubscriptionInput!) {
  changeSubscription(input: $input) {
    ...SubscriptionFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}`;
export type ChangeSubscriptionMutationFn = Apollo.MutationFunction<ChangeSubscriptionMutation, ChangeSubscriptionMutationVariables>;

/**
 * __useChangeSubscriptionMutation__
 *
 * To run a mutation, you first call `useChangeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeSubscriptionMutation, { data, loading, error }] = useChangeSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ChangeSubscriptionMutation, ChangeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeSubscriptionMutation, ChangeSubscriptionMutationVariables>(ChangeSubscriptionDocument, options);
      }
export type ChangeSubscriptionMutationHookResult = ReturnType<typeof useChangeSubscriptionMutation>;
export type ChangeSubscriptionMutationResult = Apollo.MutationResult<ChangeSubscriptionMutation>;
export type ChangeSubscriptionMutationOptions = Apollo.BaseMutationOptions<ChangeSubscriptionMutation, ChangeSubscriptionMutationVariables>;
export const DeleteAssetDocument = gql`
    mutation DeleteAsset($input: DeleteAssetInput!) {
  deleteAsset(input: $input)
}
    `;
export type DeleteAssetMutationFn = Apollo.MutationFunction<DeleteAssetMutation, DeleteAssetMutationVariables>;

/**
 * __useDeleteAssetMutation__
 *
 * To run a mutation, you first call `useDeleteAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetMutation, { data, loading, error }] = useDeleteAssetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetMutation, DeleteAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetMutation, DeleteAssetMutationVariables>(DeleteAssetDocument, options);
      }
export type DeleteAssetMutationHookResult = ReturnType<typeof useDeleteAssetMutation>;
export type DeleteAssetMutationResult = Apollo.MutationResult<DeleteAssetMutation>;
export type DeleteAssetMutationOptions = Apollo.BaseMutationOptions<DeleteAssetMutation, DeleteAssetMutationVariables>;
export const DuplicatePageAssetsDocument = gql`
    mutation DuplicatePageAssets($input: DuplicatePageAssetsInput!) {
  duplicatePageAssets(input: $input)
}
    `;
export type DuplicatePageAssetsMutationFn = Apollo.MutationFunction<DuplicatePageAssetsMutation, DuplicatePageAssetsMutationVariables>;

/**
 * __useDuplicatePageAssetsMutation__
 *
 * To run a mutation, you first call `useDuplicatePageAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePageAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePageAssetsMutation, { data, loading, error }] = useDuplicatePageAssetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicatePageAssetsMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePageAssetsMutation, DuplicatePageAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePageAssetsMutation, DuplicatePageAssetsMutationVariables>(DuplicatePageAssetsDocument, options);
      }
export type DuplicatePageAssetsMutationHookResult = ReturnType<typeof useDuplicatePageAssetsMutation>;
export type DuplicatePageAssetsMutationResult = Apollo.MutationResult<DuplicatePageAssetsMutation>;
export type DuplicatePageAssetsMutationOptions = Apollo.BaseMutationOptions<DuplicatePageAssetsMutation, DuplicatePageAssetsMutationVariables>;
export const UpdateUserPagePermissionDocument = gql`
    mutation UpdateUserPagePermission($input: UpdateUserPagePermissionInput!) {
  updateUserPagePermission(input: $input) {
    ...PageMemberFragment
  }
}
    ${PageMemberFragmentFragmentDoc}`;
export type UpdateUserPagePermissionMutationFn = Apollo.MutationFunction<UpdateUserPagePermissionMutation, UpdateUserPagePermissionMutationVariables>;

/**
 * __useUpdateUserPagePermissionMutation__
 *
 * To run a mutation, you first call `useUpdateUserPagePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPagePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPagePermissionMutation, { data, loading, error }] = useUpdateUserPagePermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPagePermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPagePermissionMutation, UpdateUserPagePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPagePermissionMutation, UpdateUserPagePermissionMutationVariables>(UpdateUserPagePermissionDocument, options);
      }
export type UpdateUserPagePermissionMutationHookResult = ReturnType<typeof useUpdateUserPagePermissionMutation>;
export type UpdateUserPagePermissionMutationResult = Apollo.MutationResult<UpdateUserPagePermissionMutation>;
export type UpdateUserPagePermissionMutationOptions = Apollo.BaseMutationOptions<UpdateUserPagePermissionMutation, UpdateUserPagePermissionMutationVariables>;
export const UpdatePageSharedToSpaceDocument = gql`
    mutation UpdatePageSharedToSpace($input: UpdatePageSharedToSpaceInput!) {
  updatePageSharedToSpace(input: $input) {
    ...SharedPageFragment
  }
}
    ${SharedPageFragmentFragmentDoc}`;
export type UpdatePageSharedToSpaceMutationFn = Apollo.MutationFunction<UpdatePageSharedToSpaceMutation, UpdatePageSharedToSpaceMutationVariables>;

/**
 * __useUpdatePageSharedToSpaceMutation__
 *
 * To run a mutation, you first call `useUpdatePageSharedToSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageSharedToSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageSharedToSpaceMutation, { data, loading, error }] = useUpdatePageSharedToSpaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageSharedToSpaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageSharedToSpaceMutation, UpdatePageSharedToSpaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageSharedToSpaceMutation, UpdatePageSharedToSpaceMutationVariables>(UpdatePageSharedToSpaceDocument, options);
      }
export type UpdatePageSharedToSpaceMutationHookResult = ReturnType<typeof useUpdatePageSharedToSpaceMutation>;
export type UpdatePageSharedToSpaceMutationResult = Apollo.MutationResult<UpdatePageSharedToSpaceMutation>;
export type UpdatePageSharedToSpaceMutationOptions = Apollo.BaseMutationOptions<UpdatePageSharedToSpaceMutation, UpdatePageSharedToSpaceMutationVariables>;
export const HideAiThreadDocument = gql`
    mutation HideAIThread($input: HideAIThreadInput!) {
  hideAIThread(input: $input)
}
    `;
export type HideAiThreadMutationFn = Apollo.MutationFunction<HideAiThreadMutation, HideAiThreadMutationVariables>;

/**
 * __useHideAiThreadMutation__
 *
 * To run a mutation, you first call `useHideAiThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideAiThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideAiThreadMutation, { data, loading, error }] = useHideAiThreadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHideAiThreadMutation(baseOptions?: Apollo.MutationHookOptions<HideAiThreadMutation, HideAiThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideAiThreadMutation, HideAiThreadMutationVariables>(HideAiThreadDocument, options);
      }
export type HideAiThreadMutationHookResult = ReturnType<typeof useHideAiThreadMutation>;
export type HideAiThreadMutationResult = Apollo.MutationResult<HideAiThreadMutation>;
export type HideAiThreadMutationOptions = Apollo.BaseMutationOptions<HideAiThreadMutation, HideAiThreadMutationVariables>;
export const UnreadNotificationsCounterUpdatedDocument = gql`
    subscription UnreadNotificationsCounterUpdated {
  unreadNotificationsCounterUpdated
}
    `;

/**
 * __useUnreadNotificationsCounterUpdatedSubscription__
 *
 * To run a query within a React component, call `useUnreadNotificationsCounterUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationsCounterUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationsCounterUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUnreadNotificationsCounterUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UnreadNotificationsCounterUpdatedSubscription, UnreadNotificationsCounterUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UnreadNotificationsCounterUpdatedSubscription, UnreadNotificationsCounterUpdatedSubscriptionVariables>(UnreadNotificationsCounterUpdatedDocument, options);
      }
export type UnreadNotificationsCounterUpdatedSubscriptionHookResult = ReturnType<typeof useUnreadNotificationsCounterUpdatedSubscription>;
export type UnreadNotificationsCounterUpdatedSubscriptionResult = Apollo.SubscriptionResult<UnreadNotificationsCounterUpdatedSubscription>;
export const PermissionsUpdatedDocument = gql`
    subscription PermissionsUpdated($input: PermissionsUpdatedInput!) {
  permissionsUpdated(input: $input) {
    sagaAiStatus
  }
}
    `;

/**
 * __usePermissionsUpdatedSubscription__
 *
 * To run a query within a React component, call `usePermissionsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsUpdatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePermissionsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PermissionsUpdatedSubscription, PermissionsUpdatedSubscriptionVariables> & ({ variables: PermissionsUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PermissionsUpdatedSubscription, PermissionsUpdatedSubscriptionVariables>(PermissionsUpdatedDocument, options);
      }
export type PermissionsUpdatedSubscriptionHookResult = ReturnType<typeof usePermissionsUpdatedSubscription>;
export type PermissionsUpdatedSubscriptionResult = Apollo.SubscriptionResult<PermissionsUpdatedSubscription>;
export const UserPagePermissionsBySpaceIdUpdatedDocument = gql`
    subscription userPagePermissionsBySpaceIdUpdated($input: UserPagePermissionsBySpaceIdInput!) {
  userPagePermissionsBySpaceId(input: $input) {
    ...UserPagePermissionFragment
  }
}
    ${UserPagePermissionFragmentFragmentDoc}`;

/**
 * __useUserPagePermissionsBySpaceIdUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserPagePermissionsBySpaceIdUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserPagePermissionsBySpaceIdUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPagePermissionsBySpaceIdUpdatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserPagePermissionsBySpaceIdUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<UserPagePermissionsBySpaceIdUpdatedSubscription, UserPagePermissionsBySpaceIdUpdatedSubscriptionVariables> & ({ variables: UserPagePermissionsBySpaceIdUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserPagePermissionsBySpaceIdUpdatedSubscription, UserPagePermissionsBySpaceIdUpdatedSubscriptionVariables>(UserPagePermissionsBySpaceIdUpdatedDocument, options);
      }
export type UserPagePermissionsBySpaceIdUpdatedSubscriptionHookResult = ReturnType<typeof useUserPagePermissionsBySpaceIdUpdatedSubscription>;
export type UserPagePermissionsBySpaceIdUpdatedSubscriptionResult = Apollo.SubscriptionResult<UserPagePermissionsBySpaceIdUpdatedSubscription>;
export const UserSharedPagesUpdatedDocument = gql`
    subscription UserSharedPagesUpdated {
  userSharedPages {
    ...SharedPageInfoFragment
  }
}
    ${SharedPageInfoFragmentFragmentDoc}`;

/**
 * __useUserSharedPagesUpdatedSubscription__
 *
 * To run a query within a React component, call `useUserSharedPagesUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserSharedPagesUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSharedPagesUpdatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUserSharedPagesUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UserSharedPagesUpdatedSubscription, UserSharedPagesUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UserSharedPagesUpdatedSubscription, UserSharedPagesUpdatedSubscriptionVariables>(UserSharedPagesUpdatedDocument, options);
      }
export type UserSharedPagesUpdatedSubscriptionHookResult = ReturnType<typeof useUserSharedPagesUpdatedSubscription>;
export type UserSharedPagesUpdatedSubscriptionResult = Apollo.SubscriptionResult<UserSharedPagesUpdatedSubscription>;